import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { fetchWithAmplify } from '../../fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: any;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
  BigInt: any;
  Double: any;
  Long: any;
};

export type AbstractAdvancedAnalysisItemCondition = {
  id: Scalars['ID'];
};

export type AbstractAdvancedAnalysisItemResultType = {
  dummy?: Maybe<Scalars['String']>;
};

export type AbstractAssignment = {
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AbstractEvaluationSheetResultItem = {
  complianceModule?: Maybe<ComplianceModule>;
  criticity: EvaluationSheetCriticityLevel;
  denom?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  num?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  unweightedCount?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type AbstractProjectVocalTrigger = {
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['ID']>;
  commandContextTextLower?: Maybe<Scalars['String']>;
  contextualDisplays: Array<ProjectCommandContext>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  isAlerting?: Maybe<Scalars['Boolean']>;
  onlyDisplayForAgent?: Maybe<Scalars['Boolean']>;
  onlyDisplayForClient?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['ID'];
  project: Project;
  projectId: Scalars['ID'];
  sessionActivityTrigger?: Maybe<SessionActivityTrigger>;
  tabId?: Maybe<Scalars['ID']>;
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  triggerId: Scalars['ID'];
  triggeredContext?: Maybe<CommandContext>;
  userId: Scalars['ID'];
};

export type AcknowledgeNotificationInput = {
  eventId: Scalars['ID'];
};

export type AddAdvancedAnalysisItemConditionInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  advancedAnalysisItemId: Scalars['ID'];
  parentConditionId?: InputMaybe<Scalars['ID']>;
};

export type AddAssistantDocumentInput = {
  assistantId: Scalars['ID'];
  documentName: Scalars['String'];
};

export type AddAssistantWebsiteSourceInput = {
  assistantId: Scalars['ID'];
  name: Scalars['String'];
  websiteSource: Scalars['String'];
};

export type AddCardContentBlockInput = {
  blockType: ContentBlockType;
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type AddCardScopeInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type AddCardTabInput = {
  cardId: Scalars['ID'];
  title: Scalars['String'];
};

export type AddDecisionTreeNodeInput = {
  parentId: Scalars['ID'];
  parentValue: Scalars['String'];
};

export type AddDecisionTreeSequenceConditionInput = {
  decisionTreeId: Scalars['ID'];
  inclusionType: TreeSequenceItemInclusionType;
  nodeId: Scalars['ID'];
  values: Array<Scalars['String']>;
};

export type AddDecisionTreeToSequenceInput = {
  decisionTreeId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type AddPhrasingPerformanceSubjectGoodConditionInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  parentConditionId?: InputMaybe<Scalars['ID']>;
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type AddPhrasingPerformanceSubjectScopeConditionInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  parentConditionId?: InputMaybe<Scalars['ID']>;
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type AddProjectAssignmentInput = {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AddProjectToExcelCardImporterInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type AddReferenceInput = {
  phrasingPerformanceSubjectId: Scalars['ID'];
  text: Scalars['String'];
};

export type AddVariableFilterInput = {
  childId: Scalars['ID'];
  childValue: Scalars['String'];
  conditions?: InputMaybe<Array<InclusionConditionInput>>;
  parentId: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type AddWordingInput = {
  phrasingSubjectId: Scalars['ID'];
  text: Scalars['String'];
};

export type AdditionalConsentUrl = {
  __typename?: 'AdditionalConsentUrl';
  displayText: Scalars['String'];
  url: Scalars['String'];
};

export type AdvancedAnalysisAssistantConversationCount = {
  __typename?: 'AdvancedAnalysisAssistantConversationCount';
  assistant: ContentGenerationAssistant;
  count: Scalars['Int'];
  id: Scalars['ID'];
};

export type AdvancedAnalysisCoaching = {
  __typename?: 'AdvancedAnalysisCoaching';
  advancedAnalysisItem: AdvancedAnalysisItem;
  advancedAnalysisItemId: Scalars['ID'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  errorMessage?: Maybe<Scalars['String']>;
  filters: AdvancedAnalysisCoachingFilters;
  finishedAt?: Maybe<Scalars['Long']>;
  from: Scalars['Long'];
  id: Scalars['ID'];
  inputTokenCount?: Maybe<Scalars['Long']>;
  modelId: Scalars['String'];
  organisationId: Scalars['ID'];
  outputTokenCount?: Maybe<Scalars['Long']>;
  prompt: Scalars['String'];
  result?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Long']>;
  targetSessions: Array<AdvancedAnalysisCoachingTargetSession>;
  to: Scalars['Long'];
};

export type AdvancedAnalysisCoachingConnection = {
  __typename?: 'AdvancedAnalysisCoachingConnection';
  items: Array<AdvancedAnalysisCoaching>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisCoachingFilters = {
  __typename?: 'AdvancedAnalysisCoachingFilters';
  callStatusIds?: Maybe<Array<Scalars['String']>>;
  contextIds?: Maybe<Array<Scalars['String']>>;
  projectIds?: Maybe<Array<Scalars['ID']>>;
  teamIds?: Maybe<Array<Scalars['ID']>>;
  userIds?: Maybe<Array<Scalars['ID']>>;
};

export type AdvancedAnalysisCoachingFiltersInput = {
  callStatusIds?: InputMaybe<Array<Scalars['String']>>;
  contextIds?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AdvancedAnalysisCoachingScopeInput = {
  advancedAnalysisItemId: Scalars['ID'];
  filters?: InputMaybe<AdvancedAnalysisCoachingFiltersInput>;
  from: Scalars['Long'];
  to: Scalars['Long'];
};

export type AdvancedAnalysisCoachingTargetSession = {
  __typename?: 'AdvancedAnalysisCoachingTargetSession';
  date: Scalars['Long'];
  duration: Scalars['Int'];
  explanation?: Maybe<Scalars['String']>;
  externalCallStatusIndex?: Maybe<Scalars['String']>;
  projectId: Scalars['ID'];
  sessionId: Scalars['ID'];
  userId: Scalars['ID'];
  verbatim?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisConversationCount = AdvancedAnalysisAssistantConversationCount | AdvancedAnalysisProjectConversationCount;

export type AdvancedAnalysisFilterInput = {
  filters?: InputMaybe<Array<AdvancedAnalysisItemFilterInput>>;
};

export type AdvancedAnalysisItem = {
  __typename?: 'AdvancedAnalysisItem';
  assistantAssignments: AdvancedAnalysisItemContentGenerationAssistantAssignmentConnection;
  condition?: Maybe<AdvancedAnalysisItemCondition>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastCommittedEvaluationAt?: Maybe<Scalars['Long']>;
  lastCommittedEvaluationClassificationRate?: Maybe<Scalars['Float']>;
  lastCommittedEvaluationJobId?: Maybe<Scalars['ID']>;
  lastDiscoveredOptionsAt?: Maybe<Scalars['Long']>;
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projectAssignments: AdvancedAnalysisItemProjectAssignmentConnection;
  question: Scalars['String'];
  resultType: AdvancedAnalysisItemResultType;
  serializedCondition?: Maybe<Scalars['AWSJSON']>;
  type?: Maybe<AdvancedAnalysisItemType>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AdvancedAnalysisItemComplianceModuleAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemComplianceModuleAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AdvancedAnalysisItemComplianceModuleAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemComplianceModuleAssignmentConnection';
  items: Array<AdvancedAnalysisItemComplianceModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemComplianceOperationItemAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemComplianceOperationItemAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceOperationItem;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  weight: Scalars['Float'];
};

export type AdvancedAnalysisItemComplianceOperationItemAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemComplianceOperationItemAssignmentConnection';
  items: Array<AdvancedAnalysisItemComplianceOperationItemAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemCondition = AdvancedAnalysisItemConditionAnd | AdvancedAnalysisItemConditionCallStatus | AdvancedAnalysisItemConditionCallStatusIn | AdvancedAnalysisItemConditionContext | AdvancedAnalysisItemConditionMinDuration | AdvancedAnalysisItemConditionNot | AdvancedAnalysisItemConditionOr | AdvancedAnalysisItemConditionRefValue;

export type AdvancedAnalysisItemConditionAnd = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionAnd';
  children: Array<AdvancedAnalysisItemCondition>;
  id: Scalars['ID'];
};

export type AdvancedAnalysisItemConditionAndInput = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionBooleanRefValueInput = {
  boolValue: Scalars['Boolean'];
  itemId: Scalars['String'];
};

export type AdvancedAnalysisItemConditionCallStatus = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionCallStatus';
  id: Scalars['ID'];
  statusId: Scalars['String'];
};

export type AdvancedAnalysisItemConditionCallStatusIn = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionCallStatusIn';
  id: Scalars['ID'];
  statusIds: Array<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionCallStatusInInput = {
  statusIds: Array<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionCallStatusInput = {
  statusId: Scalars['String'];
};

export type AdvancedAnalysisItemConditionContext = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionContext';
  contextId: Scalars['ID'];
  id: Scalars['ID'];
};

export type AdvancedAnalysisItemConditionContextInput = {
  contextId: Scalars['ID'];
};

export type AdvancedAnalysisItemConditionGroup = AdvancedAnalysisItemConditionAnd | AdvancedAnalysisItemConditionNot | AdvancedAnalysisItemConditionOr;

export type AdvancedAnalysisItemConditionMinDuration = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionMinDuration';
  id: Scalars['ID'];
  minDuration: Scalars['Float'];
};

export type AdvancedAnalysisItemConditionMinDurationInput = {
  minDuration: Scalars['Float'];
};

export type AdvancedAnalysisItemConditionNot = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionNot';
  children: Array<AdvancedAnalysisItemCondition>;
  id: Scalars['ID'];
};

export type AdvancedAnalysisItemConditionNotInput = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionOr = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionOr';
  children: Array<AdvancedAnalysisItemCondition>;
  id: Scalars['ID'];
};

export type AdvancedAnalysisItemConditionOrInput = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionRefValue = AbstractAdvancedAnalysisItemCondition & {
  __typename?: 'AdvancedAnalysisItemConditionRefValue';
  boolValue?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  stringValue?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemConditionRule = AdvancedAnalysisItemConditionCallStatus | AdvancedAnalysisItemConditionCallStatusIn | AdvancedAnalysisItemConditionContext | AdvancedAnalysisItemConditionMinDuration | AdvancedAnalysisItemConditionRefValue;

export type AdvancedAnalysisItemConditionStringRefValueInput = {
  itemId: Scalars['String'];
  stringValue: Scalars['String'];
};

export type AdvancedAnalysisItemContentGenerationAssistantAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemContentGenerationAssistantAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ContentGenerationAssistant;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AdvancedAnalysisItemContentGenerationAssistantAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemContentGenerationAssistantAssignmentConnection';
  items: Array<AdvancedAnalysisItemContentGenerationAssistantAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemDiscoverMulticlassOptionsResult = {
  __typename?: 'AdvancedAnalysisItemDiscoverMulticlassOptionsResult';
  lastDiscoveredOptionsAt: Scalars['Long'];
  options: Array<Scalars['String']>;
};

export type AdvancedAnalysisItemDryRunResult = {
  __typename?: 'AdvancedAnalysisItemDryRunResult';
  boolValue?: Maybe<Scalars['Boolean']>;
  explanation?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  verbatim?: Maybe<Scalars['String']>;
};

export enum AdvancedAnalysisItemEvaluationAnalysisMode {
  IndexedOutput = 'IndexedOutput',
  LegacyOutput = 'LegacyOutput',
  StructuredOutput = 'StructuredOutput'
}

export type AdvancedAnalysisItemEvaluationConfusionMatrixCell = {
  __typename?: 'AdvancedAnalysisItemEvaluationConfusionMatrixCell';
  actualLabel: Scalars['String'];
  count: Scalars['Int'];
  predictedLabel: Scalars['String'];
};

export enum AdvancedAnalysisItemEvaluationDelta {
  Improved = 'Improved',
  Regressed = 'Regressed',
  Unchanged = 'Unchanged'
}

export type AdvancedAnalysisItemEvaluationJob = {
  __typename?: 'AdvancedAnalysisItemEvaluationJob';
  advancedAnalysisItemId: Scalars['ID'];
  analysisMode: AdvancedAnalysisItemEvaluationAnalysisMode;
  baseItemUpdatedAt: Scalars['Long'];
  baselineMetrics?: Maybe<AdvancedAnalysisItemEvaluationMetrics>;
  candidateMetrics?: Maybe<AdvancedAnalysisItemEvaluationMetrics>;
  candidateWording: Scalars['String'];
  committedAt?: Maybe<Scalars['Long']>;
  committedBy?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  errorCount: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  modelId: Scalars['String'];
  organisationId: Scalars['ID'];
  results: Array<AdvancedAnalysisItemEvaluationJobResult>;
  startedAt?: Maybe<Scalars['Long']>;
  status: AdvancedAnalysisItemEvaluationJobStatus;
  totalCount: Scalars['Int'];
};

export type AdvancedAnalysisItemEvaluationJobConnection = {
  __typename?: 'AdvancedAnalysisItemEvaluationJobConnection';
  items: Array<AdvancedAnalysisItemEvaluationJob>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemEvaluationJobResult = {
  __typename?: 'AdvancedAnalysisItemEvaluationJobResult';
  candidateResult: AdvancedAnalysisItemEvaluationJobResultCandidate;
  delta: AdvancedAnalysisItemEvaluationDelta;
  evaluationJobId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  referenceResult: AdvancedAnalysisItemEvaluationJobResultReference;
  sessionId: Scalars['ID'];
};

export type AdvancedAnalysisItemEvaluationJobResultCandidate = {
  __typename?: 'AdvancedAnalysisItemEvaluationJobResultCandidate';
  boolValue?: Maybe<Scalars['Boolean']>;
  explanation?: Maybe<Scalars['String']>;
  match: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  sourceSessionId?: Maybe<Scalars['ID']>;
  stringValue?: Maybe<Scalars['String']>;
  verbatim?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemEvaluationJobResultReference = {
  __typename?: 'AdvancedAnalysisItemEvaluationJobResultReference';
  boolValue?: Maybe<Scalars['Boolean']>;
  groundTruthBoolValue?: Maybe<Scalars['Boolean']>;
  groundTruthStringValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  match: Scalars['Boolean'];
  stringValue?: Maybe<Scalars['String']>;
};

export enum AdvancedAnalysisItemEvaluationJobStatus {
  Failed = 'Failed',
  Queued = 'Queued',
  Resuming = 'Resuming',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type AdvancedAnalysisItemEvaluationMetrics = {
  __typename?: 'AdvancedAnalysisItemEvaluationMetrics';
  classificationRate: Scalars['Float'];
  confusionMatrixCells: Array<AdvancedAnalysisItemEvaluationConfusionMatrixCell>;
  evaluatedCount: Scalars['Int'];
  labels: Array<Scalars['String']>;
  matchCount: Scalars['Int'];
  mismatchCount: Scalars['Int'];
  noPredictionCount: Scalars['Int'];
};

export type AdvancedAnalysisItemEvaluationSheetAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemEvaluationSheetAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  criticityLevel: EvaluationSheetCriticityLevel;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: EvaluationSheet;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  weight: Scalars['Float'];
};

export type AdvancedAnalysisItemEvaluationSheetAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemEvaluationSheetAssignmentConnection';
  items: Array<AdvancedAnalysisItemEvaluationSheetAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemFilterInput = {
  boolValues?: InputMaybe<Array<Scalars['Boolean']>>;
  explanation?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
  stringValues?: InputMaybe<Array<Scalars['String']>>;
  verbatim?: InputMaybe<Scalars['Boolean']>;
};

export type AdvancedAnalysisItemMutations = {
  __typename?: 'AdvancedAnalysisItemMutations';
  addCondition: AdvancedAnalysisItem;
  commitEvaluationJob: AdvancedAnalysisItemEvaluationJob;
  create: AdvancedAnalysisItem;
  createAnalysisJob: AdvancedAnalysisJob;
  createCoaching: AdvancedAnalysisCoaching;
  createEvaluationJob: AdvancedAnalysisItemEvaluationJob;
  delete: AdvancedAnalysisItem;
  deleteCoaching: AdvancedAnalysisCoaching;
  discoverMulticlassOptions: AdvancedAnalysisItemDiscoverMulticlassOptionsResult;
  dryRun: AdvancedAnalysisItemDryRunResult;
  generate: AdvancedAnalysisItemSessionAssignmentConnection;
  removeCondition: AdvancedAnalysisItem;
  resumeEvaluationJob: AdvancedAnalysisItemEvaluationJob;
  retryAnalysisJob: AdvancedAnalysisJob;
  update: AdvancedAnalysisItem;
  updateConditionGroup: AdvancedAnalysisItem;
  updateConditionRule: AdvancedAnalysisItem;
};


export type AdvancedAnalysisItemMutationsAddConditionArgs = {
  input: AddAdvancedAnalysisItemConditionInput;
};


export type AdvancedAnalysisItemMutationsCommitEvaluationJobArgs = {
  input: CommitAdvancedAnalysisItemEvaluationJobInput;
};


export type AdvancedAnalysisItemMutationsCreateArgs = {
  input: CreateAdvancedAnalysisItemInput;
};


export type AdvancedAnalysisItemMutationsCreateAnalysisJobArgs = {
  input: CreateAdvancedAnalysisJobInput;
};


export type AdvancedAnalysisItemMutationsCreateCoachingArgs = {
  input: CreateAdvancedAnalysisCoachingInput;
};


export type AdvancedAnalysisItemMutationsCreateEvaluationJobArgs = {
  input: CreateAdvancedAnalysisItemEvaluationJobInput;
};


export type AdvancedAnalysisItemMutationsDeleteArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemMutationsDeleteCoachingArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemMutationsDiscoverMulticlassOptionsArgs = {
  input: DiscoverAdvancedAnalysisItemMulticlassOptionInput;
};


export type AdvancedAnalysisItemMutationsDryRunArgs = {
  input: DryRunAdvancedAnalysisItemInput;
};


export type AdvancedAnalysisItemMutationsGenerateArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemMutationsRemoveConditionArgs = {
  input: RemoveAdvancedAnalysisItemConditionInput;
};


export type AdvancedAnalysisItemMutationsResumeEvaluationJobArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemMutationsRetryAnalysisJobArgs = {
  input: RetryAdvancedAnalysisJobInput;
};


export type AdvancedAnalysisItemMutationsUpdateArgs = {
  input: UpdateAdvancedAnalysisItemInput;
};


export type AdvancedAnalysisItemMutationsUpdateConditionGroupArgs = {
  input: UpdateAdvancedAnalysisItemConditionGroupInput;
};


export type AdvancedAnalysisItemMutationsUpdateConditionRuleArgs = {
  input: UpdateAdvancedAnalysisItemConditionRuleInput;
};

export type AdvancedAnalysisItemProjectAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemProjectAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AdvancedAnalysisItemProjectAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemProjectAssignmentConnection';
  items: Array<AdvancedAnalysisItemProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemQueries = {
  __typename?: 'AdvancedAnalysisItemQueries';
  countAnalysisJobConversations: Array<AdvancedAnalysisConversationCount>;
  countCoachingTargetSessions: Scalars['Int'];
  get: AdvancedAnalysisItem;
  getAnalysisJob: AdvancedAnalysisJob;
  getCoaching: AdvancedAnalysisCoaching;
  getEvaluationJob: AdvancedAnalysisItemEvaluationJob;
  list: Array<AdvancedAnalysisItem>;
  listAnalysisJobs: AdvancedAnalysisJobConnection;
  listCoachings: AdvancedAnalysisCoachingConnection;
  listEvaluationJobs: AdvancedAnalysisItemEvaluationJobConnection;
};


export type AdvancedAnalysisItemQueriesCountAnalysisJobConversationsArgs = {
  input: CountAdvancedAnalysisConversationsInput;
};


export type AdvancedAnalysisItemQueriesCountCoachingTargetSessionsArgs = {
  input: AdvancedAnalysisCoachingScopeInput;
};


export type AdvancedAnalysisItemQueriesGetArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemQueriesGetAnalysisJobArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemQueriesGetCoachingArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemQueriesGetEvaluationJobArgs = {
  input: IdInput;
};


export type AdvancedAnalysisItemQueriesListAnalysisJobsArgs = {
  input: ListAdvancedAnalysisJobsInput;
};


export type AdvancedAnalysisItemQueriesListCoachingsArgs = {
  input: InfiniteQueryInput;
};


export type AdvancedAnalysisItemQueriesListEvaluationJobsArgs = {
  input: ListAdvancedAnalysisItemEvaluationJobsInput;
};

export type AdvancedAnalysisItemResultType = AdvancedAnalysisItemResultTypeBool | AdvancedAnalysisItemResultTypeOptions;

export type AdvancedAnalysisItemResultTypeBool = AbstractAdvancedAnalysisItemResultType & {
  __typename?: 'AdvancedAnalysisItemResultTypeBool';
  dummy?: Maybe<Scalars['String']>;
  positiveAnswer?: Maybe<Scalars['Boolean']>;
};

export type AdvancedAnalysisItemResultTypeOptions = AbstractAdvancedAnalysisItemResultType & {
  __typename?: 'AdvancedAnalysisItemResultTypeOptions';
  discoverOptions?: Maybe<Scalars['Boolean']>;
  dummy?: Maybe<Scalars['String']>;
  options: Array<Scalars['String']>;
};

export type AdvancedAnalysisItemSessionAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemSessionAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  boolValue?: Maybe<Scalars['Boolean']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  discoveredOption?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  groundTruthBoolValue?: Maybe<Scalars['Boolean']>;
  groundTruthStringValue?: Maybe<Scalars['String']>;
  group: Session;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  sourceSession?: Maybe<Session>;
  sourceSessionId?: Maybe<Scalars['ID']>;
  stringValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  verbatim?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemSessionAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemSessionAssignmentConnection';
  items: Array<AdvancedAnalysisItemSessionAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemStatId = StatId & {
  __typename?: 'AdvancedAnalysisItemStatId';
  advancedAnalysisItem: AdvancedAnalysisItem;
  advancedAnalysisItemId: Scalars['ID'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type AdvancedAnalysisItemStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type AdvancedAnalysisItemStatistics = {
  __typename?: 'AdvancedAnalysisItemStatistics';
  advancedAnalysisItem?: Maybe<AdvancedAnalysisItem>;
  advancedAnalysisItemId: Scalars['ID'];
  current: AdvancedAnalysisItemStatisticsMetric;
  previous: AdvancedAnalysisItemStatisticsMetric;
};

export type AdvancedAnalysisItemStatisticsMetric = {
  __typename?: 'AdvancedAnalysisItemStatisticsMetric';
  complianceScoreCount: Scalars['Int'];
  complianceScoreTotal: Scalars['Float'];
  qualityScoreCount: Scalars['Int'];
  qualityScoreTotal: Scalars['Float'];
  resultRepartition: Array<KeyIntValue>;
  runCount: Scalars['Int'];
};

export type AdvancedAnalysisItemStatisticsMetricTrend = {
  __typename?: 'AdvancedAnalysisItemStatisticsMetricTrend';
  current: AdvancedAnalysisItemStatisticsMetric;
  previous: AdvancedAnalysisItemStatisticsMetric;
};

export type AdvancedAnalysisItemStatisticsQueries = {
  __typename?: 'AdvancedAnalysisItemStatisticsQueries';
  byAdvancedAnalysisItem: Array<AdvancedAnalysisItemStatistics>;
  byUser: Array<UserAdvancedAnalysisItemStatistics>;
  totals: AdvancedAnalysisItemStatisticsMetricTrend;
};


export type AdvancedAnalysisItemStatisticsQueriesByAdvancedAnalysisItemArgs = {
  input: AdvancedAnalysisItemStatisticsTrendInput;
};


export type AdvancedAnalysisItemStatisticsQueriesByUserArgs = {
  input: AdvancedAnalysisItemStatisticsTrendInput;
};


export type AdvancedAnalysisItemStatisticsQueriesTotalsArgs = {
  input: AdvancedAnalysisItemStatisticsTrendInput;
};

export type AdvancedAnalysisItemStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type AdvancedAnalysisItemThreadAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemThreadAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  boolValue?: Maybe<Scalars['Boolean']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  discoveredOption?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  groundTruthBoolValue?: Maybe<Scalars['Boolean']>;
  groundTruthStringValue?: Maybe<Scalars['String']>;
  group: ContentGenerationAssistantThread;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  stringValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  verbatim?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisItemThreadAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemThreadAssignmentConnection';
  items: Array<AdvancedAnalysisItemThreadAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum AdvancedAnalysisItemType {
  Compliance = 'Compliance',
  CustomerInsights = 'CustomerInsights',
  Quality = 'Quality'
}

export type AdvancedAnalysisItemViewAssignment = AbstractAssignment & {
  __typename?: 'AdvancedAnalysisItemViewAssignment';
  assignee: AdvancedAnalysisItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: View;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type AdvancedAnalysisItemViewAssignmentConnection = {
  __typename?: 'AdvancedAnalysisItemViewAssignmentConnection';
  items: Array<AdvancedAnalysisItemViewAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AdvancedAnalysisJob = {
  __typename?: 'AdvancedAnalysisJob';
  advancedAnalysisItemId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  discovery?: Maybe<Scalars['Boolean']>;
  errorCount: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  factCheckModuleId?: Maybe<Scalars['ID']>;
  factCheckRuns: FactCheckModuleRunAdvancedAnalysisJobAssignmentConnection;
  finishedAt?: Maybe<Scalars['Long']>;
  forceIndexedOutput?: Maybe<Scalars['Boolean']>;
  forceStructuredOutput?: Maybe<Scalars['Boolean']>;
  from: Scalars['Long'];
  id: Scalars['ID'];
  modelId: Scalars['String'];
  organisationId: Scalars['ID'];
  overwrite?: Maybe<Scalars['Boolean']>;
  phrasingPerformanceSubjectId?: Maybe<Scalars['ID']>;
  processedCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['Long']>;
  status: AdvancedAnalysisJobStatus;
  to: Scalars['Long'];
  totalCount: Scalars['Int'];
};

export enum AdvancedAnalysisJobAssignmentStatus {
  Failed = 'Failed',
  Queued = 'Queued',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type AdvancedAnalysisJobConnection = {
  __typename?: 'AdvancedAnalysisJobConnection';
  items: Array<AdvancedAnalysisJob>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum AdvancedAnalysisJobStatus {
  Failed = 'Failed',
  PartiallySucceeded = 'PartiallySucceeded',
  Queued = 'Queued',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type AdvancedAnalysisOrgSettings = OrgFeatureSettings & {
  __typename?: 'AdvancedAnalysisOrgSettings';
  checkPreviousSessionsForNewItems?: Maybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  modelId?: Maybe<Scalars['String']>;
  staffOnly?: Maybe<Scalars['Boolean']>;
  useIndexedOutput?: Maybe<Scalars['Boolean']>;
  useLegacyOutput?: Maybe<Scalars['Boolean']>;
  useStructureOutput?: Maybe<Scalars['Boolean']>;
};

export type AdvancedAnalysisProjectConversationCount = {
  __typename?: 'AdvancedAnalysisProjectConversationCount';
  count: Scalars['Int'];
  id: Scalars['ID'];
  project: Project;
};

export enum AgentLabelId {
  Advisor = 'advisor',
  Agent = 'agent',
  Ambassador = 'ambassador',
  Hotliner = 'hotliner',
  Salesperson = 'salesperson',
  Technician = 'technician'
}

export type AnnotateAudioInput = {
  id: Scalars['ID'];
  status?: InputMaybe<DetectionStatus>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  appVersion?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  dualChannelAppVersion?: Maybe<Scalars['String']>;
  expiresAt: Scalars['Long'];
  id: Scalars['ID'];
  lastAuthUser?: Maybe<Scalars['String']>;
  lastSeenAt: Scalars['Long'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type ApplicationConnectionMutations = {
  __typename?: 'ApplicationConnectionMutations';
  refresh: Scalars['Boolean'];
};


export type ApplicationConnectionMutationsRefreshArgs = {
  input: IdInput;
};

export type ApplicationConnectionQueries = {
  __typename?: 'ApplicationConnectionQueries';
  list: Array<ApplicationConnection>;
};

export type ApplyFactCheckThemeInput = {
  attributeIds: Array<Scalars['ID']>;
  hint: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
};

export type ApplyFactCheckThemesInput = {
  deleteThemeIds: Array<Scalars['ID']>;
  moduleId: Scalars['ID'];
  themes: Array<ApplyFactCheckThemeInput>;
};

export type ArchiveProjectInput = {
  projectId: Scalars['ID'];
};

export type ArchiveTopicInput = {
  text: Scalars['String'];
};

export type AsrCommand = {
  __typename?: 'AsrCommand';
  alternatives?: Maybe<Array<Scalars['String']>>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  language: Scalars['String'];
  levenshteinDistance?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prefixSize?: Maybe<Scalars['Int']>;
};

export type AsrCommandConnection = {
  __typename?: 'AsrCommandConnection';
  items: Array<AsrCommand>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AsrCommandFilterInput = {
  enabled?: InputMaybe<TableBooleanFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  language?: InputMaybe<TableStringFilterInput>;
  levenshteinDistance?: InputMaybe<TableIntFilterInput>;
  name?: InputMaybe<TableStringFilterInput>;
  prefixSize?: InputMaybe<TableIntFilterInput>;
};

export type AsrSession = {
  __typename?: 'AsrSession';
  duration: Scalars['Int'];
  matchTranscript: Array<Scalars['String']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  projectName: Scalars['String'];
  sessionId: Scalars['ID'];
  sessionTags: Array<SimpleNamedObject>;
  timestamp: Scalars['Long'];
  userDisplayName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type AsrSessionConnection = {
  __typename?: 'AsrSessionConnection';
  count: Scalars['Int'];
  items: Array<AsrSession>;
  nextItem?: Maybe<Scalars['Int']>;
};

export type AssignProjectTopicInput = {
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type Assignment = AdvancedAnalysisItemComplianceModuleAssignment | AdvancedAnalysisItemComplianceOperationItemAssignment | AdvancedAnalysisItemContentGenerationAssistantAssignment | AdvancedAnalysisItemEvaluationSheetAssignment | AdvancedAnalysisItemProjectAssignment | AdvancedAnalysisItemSessionAssignment | AdvancedAnalysisItemThreadAssignment | AdvancedAnalysisItemViewAssignment | CallStatusFactCheckProductAssignment | CommandViewAssignment | ComplianceModuleProjectAssignment | ComplianceOperationItemComplianceModuleAssignment | ComplianceOperationItemComplianceOperationItemAssignment | ComplianceOperationItemEvaluationSheetAssignment | EvaluationSheetProjectAssignment | FactCheckAttributeFactCheckModuleAssignment | FactCheckAttributeFactCheckThemeAssignment | FactCheckModuleComplianceModuleAssignment | FactCheckModuleEvaluationSheetAssignment | FactCheckModuleProductSpec | FactCheckModuleProjectAssignment | FactCheckModuleRun | FactCheckModuleRunAdvancedAnalysisJobAssignment | FactCheckProductFactCheckModuleAssignment | FactCheckResult | FactCheckThemeFactCheckModuleAssignment | IntentionViewAssignment | PhrasingPerformanceSubjectProjectAssignment | PhrasingPerformanceSubjectSessionAssignment | PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment | PhrasingPerformanceWordingSessionAssignment | SessionAdvancedAnalysisJobAssignment | SummaryConfigProjectAssignment | SummaryConfigSessionAssignment | ThreadAdvancedAnalysisJobAssignment | ThreadContentGenerationAssistantAssignment | TopicComplianceModuleAssignment | TopicComplianceOperationItemAssignment | TopicEvaluationSheetAssignment | TopicViewAssignment | ViewComplianceModuleAssignment;

export type AssignmentConnection = {
  __typename?: 'AssignmentConnection';
  items: Array<Assignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AssignmentInput = {
  assigneeId: Scalars['ID'];
  to: Scalars['ID'];
};

export type AssignmentListInput = {
  assignmentType: AssignmentType;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['Long']>;
};

export type AssignmentMutations = {
  __typename?: 'AssignmentMutations';
  create: Assignment;
  delete: Assignment;
  reassignGroup: Assignment;
  replace: Assignment;
};


export type AssignmentMutationsCreateArgs = {
  input: CreateAssignmentInput;
};


export type AssignmentMutationsDeleteArgs = {
  input: IdInput;
};


export type AssignmentMutationsReassignGroupArgs = {
  input: ReassignAssignmentGroupInput;
};


export type AssignmentMutationsReplaceArgs = {
  input: ReplaceAssignmentInput;
};

export type AssignmentQueries = {
  __typename?: 'AssignmentQueries';
  listAssignees: AssignmentConnection;
  listGroups: AssignmentConnection;
};


export type AssignmentQueriesListAssigneesArgs = {
  input: AssignmentListInput;
};


export type AssignmentQueriesListGroupsArgs = {
  input: AssignmentListInput;
};

export enum AssignmentType {
  AdvancedAnalysisItemComplianceModuleAssignment = 'AdvancedAnalysisItemComplianceModuleAssignment',
  AdvancedAnalysisItemComplianceOperationItemAssignment = 'AdvancedAnalysisItemComplianceOperationItemAssignment',
  AdvancedAnalysisItemContentGenerationAssistantAssignment = 'AdvancedAnalysisItemContentGenerationAssistantAssignment',
  AdvancedAnalysisItemEvaluationSheetAssignment = 'AdvancedAnalysisItemEvaluationSheetAssignment',
  AdvancedAnalysisItemProjectAssignment = 'AdvancedAnalysisItemProjectAssignment',
  AdvancedAnalysisItemSessionAssignment = 'AdvancedAnalysisItemSessionAssignment',
  AdvancedAnalysisItemThreadAssignment = 'AdvancedAnalysisItemThreadAssignment',
  AdvancedAnalysisItemViewAssignment = 'AdvancedAnalysisItemViewAssignment',
  CallStatusFactCheckProductAssignment = 'CallStatusFactCheckProductAssignment',
  CardLinkFromCardAssignment = 'CardLinkFromCardAssignment',
  CardLinkFromDecisionTreeNodeAssignment = 'CardLinkFromDecisionTreeNodeAssignment',
  CommandViewAssignment = 'CommandViewAssignment',
  ComplianceModuleProjectAssignment = 'ComplianceModuleProjectAssignment',
  ComplianceOperationItemComplianceModuleAssignment = 'ComplianceOperationItemComplianceModuleAssignment',
  ComplianceOperationItemComplianceOperationItemAssignment = 'ComplianceOperationItemComplianceOperationItemAssignment',
  ComplianceOperationItemEvaluationSheetAssignment = 'ComplianceOperationItemEvaluationSheetAssignment',
  DecisionTreeLinkFromCardAssignment = 'DecisionTreeLinkFromCardAssignment',
  DecisionTreeLinkFromDecisionTreeNodeAssignment = 'DecisionTreeLinkFromDecisionTreeNodeAssignment',
  DocumentLinkFromCardAssignment = 'DocumentLinkFromCardAssignment',
  DocumentLinkFromDecisionTreeNodeAssignment = 'DocumentLinkFromDecisionTreeNodeAssignment',
  EvaluationSheetProjectAssignment = 'EvaluationSheetProjectAssignment',
  FactCheckAttributeFactCheckModuleAssignment = 'FactCheckAttributeFactCheckModuleAssignment',
  FactCheckAttributeFactCheckThemeAssignment = 'FactCheckAttributeFactCheckThemeAssignment',
  FactCheckModuleComplianceModuleAssignment = 'FactCheckModuleComplianceModuleAssignment',
  FactCheckModuleEvaluationSheetAssignment = 'FactCheckModuleEvaluationSheetAssignment',
  FactCheckModuleProductSpec = 'FactCheckModuleProductSpec',
  FactCheckModuleProjectAssignment = 'FactCheckModuleProjectAssignment',
  FactCheckModuleRun = 'FactCheckModuleRun',
  FactCheckModuleRunAdvancedAnalysisJobAssignment = 'FactCheckModuleRunAdvancedAnalysisJobAssignment',
  FactCheckProductFactCheckModuleAssignment = 'FactCheckProductFactCheckModuleAssignment',
  FactCheckResult = 'FactCheckResult',
  FactCheckThemeFactCheckModuleAssignment = 'FactCheckThemeFactCheckModuleAssignment',
  IntentionViewAssignment = 'IntentionViewAssignment',
  PhrasingPerformanceSubjectProjectAssignment = 'PhrasingPerformanceSubjectProjectAssignment',
  PhrasingPerformanceSubjectSessionAssignment = 'PhrasingPerformanceSubjectSessionAssignment',
  PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment = 'PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment',
  PhrasingPerformanceWordingSessionAssignment = 'PhrasingPerformanceWordingSessionAssignment',
  SessionAdvancedAnalysisJobAssignment = 'SessionAdvancedAnalysisJobAssignment',
  SummaryConfigProjectAssignment = 'SummaryConfigProjectAssignment',
  SummaryConfigSessionAssignment = 'SummaryConfigSessionAssignment',
  ThreadAdvancedAnalysisJobAssignment = 'ThreadAdvancedAnalysisJobAssignment',
  ThreadContentGenerationAssistantAssignment = 'ThreadContentGenerationAssistantAssignment',
  TopicComplianceModuleAssignment = 'TopicComplianceModuleAssignment',
  TopicComplianceOperationItemAssignment = 'TopicComplianceOperationItemAssignment',
  TopicEvaluationSheetAssignment = 'TopicEvaluationSheetAssignment',
  TopicViewAssignment = 'TopicViewAssignment',
  ViewComplianceModuleAssignment = 'ViewComplianceModuleAssignment'
}

export enum AssistantType {
  CardCreation = 'CardCreation',
  Chat = 'Chat'
}

export type AttributeFilter = {
  attribute: Scalars['String'];
  floatFilter?: InputMaybe<TableFloatFilterInput>;
  stringFilter?: InputMaybe<TableStringFilterInput>;
};

export type BaseContentGenerationAssistantCustomizationFormField = {
  description: Scalars['String'];
  fieldName: Scalars['String'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export type BaseContentGenerationAssistantDataSource = {
  assistantId: Scalars['ID'];
  id: Scalars['ID'];
  knowledgeBaseId: Scalars['ID'];
  name: Scalars['String'];
  syncJob?: Maybe<ContentGenerationAssistantDataSourceSyncJob>;
};

export type BasePhrasingSubjectCondition = {
  minCallDuration?: Maybe<Scalars['Int']>;
};

export type BaseSessionEventV2 = {
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type BatchCreateUserAssignmentsInput = {
  projectIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type BatchDeleteUserAssignmentsInput = {
  projectIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type BooleanInput = {
  value: Scalars['Boolean'];
};

export enum CallCoverageStatus {
  NoActivity = 'NoActivity',
  NotAlwaysCovered = 'NotAlwaysCovered',
  NotCovered = 'NotCovered',
  Ok = 'Ok',
  UserNotIntegrated = 'UserNotIntegrated'
}

export type CallStatus = {
  __typename?: 'CallStatus';
  code: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['ID']>;
  updatedByUser?: Maybe<User>;
};

export type CallStatusConnection = {
  __typename?: 'CallStatusConnection';
  items: Array<CallStatus>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CallStatusFactCheckProductAssignment = AbstractAssignment & {
  __typename?: 'CallStatusFactCheckProductAssignment';
  assignee: CallStatus;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: FactCheckProduct;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type CallStatusFactCheckProductAssignmentConnection = {
  __typename?: 'CallStatusFactCheckProductAssignmentConnection';
  items: Array<CallStatusFactCheckProductAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CallStatusMutations = {
  __typename?: 'CallStatusMutations';
  create: CallStatus;
  delete: CallStatus;
  update: CallStatus;
};


export type CallStatusMutationsCreateArgs = {
  input: CreateCallStatusInput;
};


export type CallStatusMutationsDeleteArgs = {
  input: IdInput;
};


export type CallStatusMutationsUpdateArgs = {
  input: UpdateCallStatusInput;
};

export type CallStatusQueries = {
  __typename?: 'CallStatusQueries';
  get: CallStatus;
  getOptional?: Maybe<CallStatus>;
  list: CallStatusConnection;
};


export type CallStatusQueriesGetArgs = {
  input: IdInput;
};


export type CallStatusQueriesGetOptionalArgs = {
  input: IdInput;
};


export type CallStatusQueriesListArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};

export type Card = {
  __typename?: 'Card';
  author: Scalars['ID'];
  authorUser?: Maybe<User>;
  clientId?: Maybe<Scalars['String']>;
  content: CardContentV2;
  contentIntegration?: Maybe<CardContentIntegration>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  expirationDate?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  importId?: Maybe<Scalars['String']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  isLibrary?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['String'];
  readonly?: Maybe<Scalars['Boolean']>;
  scopes: ScopeConnection;
  sourceUrl?: Maybe<Scalars['String']>;
  tags: ContentTagConnection;
  title: Scalars['String'];
  translation?: Maybe<CardTranslation>;
  translations?: Maybe<Array<CardTranslation>>;
  updatedAt: Scalars['AWSTimestamp'];
  updatedBy?: Maybe<Scalars['ID']>;
  updatedByUser?: Maybe<User>;
  version: CardVersion;
};

export type CardCommand = {
  __typename?: 'CardCommand';
  command?: Maybe<AsrCommand>;
  commandId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  detectionCounts: DetectionCountConnection;
  projectId: Scalars['ID'];
  scopeId: Scalars['ID'];
};


export type CardCommandDetectionCountsArgs = {
  date: TableStringFilterInput;
};

export type CardCommandConnection = {
  __typename?: 'CardCommandConnection';
  items: Array<CardCommand>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type CardCommandContextInput = {
  cardId: Scalars['String'];
  commandContextTextLower: Scalars['String'];
  tabId?: InputMaybe<Scalars['String']>;
};

export type CardConnection = {
  __typename?: 'CardConnection';
  items: Array<Card>;
};

export type CardContent = {
  __typename?: 'CardContent';
  cardVersionId: Scalars['ID'];
  tabs: Array<CardTab>;
};

export type CardContentIntegration = {
  __typename?: 'CardContentIntegration';
  pageId?: Maybe<Scalars['String']>;
  spaceId?: Maybe<Scalars['String']>;
};

export type CardContentV2 = {
  __typename?: 'CardContentV2';
  cardId: Scalars['ID'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  organisationId: Scalars['String'];
  tabs: Array<CardTabV2>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
};

export type CardDeleteOutput = {
  __typename?: 'CardDeleteOutput';
  id: Scalars['ID'];
};

export type CardDisplayStatistics = {
  __typename?: 'CardDisplayStatistics';
  card: Card;
  cardId: Scalars['ID'];
  current: DisplayStatisticsMetric;
  previous: DisplayStatisticsMetric;
};

export type CardLink = {
  __typename?: 'CardLink';
  date: Scalars['AWSTimestamp'];
  sourceScopeId: Scalars['ID'];
  targetScope: CardScope;
  targetScopeId: Scalars['ID'];
};

export type CardLinkConnection = {
  __typename?: 'CardLinkConnection';
  items: Array<CardLink>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type CardLinkFromCardAssignment = AbstractAssignment & {
  __typename?: 'CardLinkFromCardAssignment';
  assignee: Card;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Card;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  tabId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type CardLinkFromCardAssignmentConnection = {
  __typename?: 'CardLinkFromCardAssignmentConnection';
  items: Array<CardLinkFromCardAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CardLinkFromDecisionTreeNodeAssignment = AbstractAssignment & {
  __typename?: 'CardLinkFromDecisionTreeNodeAssignment';
  assignee: Card;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: DecisionTreeNode;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  tabId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type CardLinkFromDecisionTreeNodeAssignmentConnection = {
  __typename?: 'CardLinkFromDecisionTreeNodeAssignmentConnection';
  items: Array<CardLinkFromDecisionTreeNodeAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CardMutations = {
  __typename?: 'CardMutations';
  create: Card;
  delete: Card;
  duplicate: Card;
  exportAsMarkdown: Scalars['String'];
  publish: CardScope;
  transfer: Card;
  unpublish: CardScope;
  update: Card;
};


export type CardMutationsCreateArgs = {
  input: CreateCardInput;
};


export type CardMutationsDeleteArgs = {
  input: IdInput;
};


export type CardMutationsDuplicateArgs = {
  input: DuplicateCardInput;
};


export type CardMutationsExportAsMarkdownArgs = {
  input: IdInput;
};


export type CardMutationsPublishArgs = {
  input: PublishInput;
};


export type CardMutationsTransferArgs = {
  input: IdInput;
};


export type CardMutationsUnpublishArgs = {
  input: PublishInput;
};


export type CardMutationsUpdateArgs = {
  input: UpdateCardInput;
};

export type CardScope = {
  __typename?: 'CardScope';
  author: Scalars['ID'];
  card: Card;
  cardId: Scalars['ID'];
  commandCount: Scalars['Int'];
  contextualDisplayOrigins?: Maybe<Array<ProjectCommandContext>>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['String']>;
  feedbackCounts: FeedbackCountConnection;
  id: Scalars['ID'];
  importId?: Maybe<Scalars['String']>;
  links: CardLinkConnection;
  projectCommands: Array<ProjectCommand>;
  projectId: Scalars['ID'];
  projectVocalTriggers: Array<ProjectVocalTrigger>;
};


export type CardScopeFeedbackCountsArgs = {
  date: TableStringFilterInput;
};

export type CardSearchInput = {
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type CardStatId = StatId & {
  __typename?: 'CardStatId';
  card: Card;
  cardId: Scalars['ID'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type CardStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type CardTab = {
  __typename?: 'CardTab';
  blocks: Array<ContentBlock>;
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['AWSTimestamp'];
};

export type CardTabV2 = {
  __typename?: 'CardTabV2';
  blocks: Array<ContentBlockV2>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
};

export type CardTendency = {
  __typename?: 'CardTendency';
  current: Scalars['Int'];
  previous: Scalars['Int'];
};

export type CardTranslation = {
  __typename?: 'CardTranslation';
  createdAt: Scalars['Long'];
  id: Scalars['ID'];
  language: Scalars['String'];
  title: Scalars['String'];
};

export type CardVersion = {
  __typename?: 'CardVersion';
  author: Scalars['ID'];
  cardId: Scalars['ID'];
  content: CardContent;
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Catalog = {
  __typename?: 'Catalog';
  columns: Array<RenamedColumn>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  dataColumns: Array<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  draft?: Maybe<Scalars['String']>;
  files: Array<Scalars['String']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  projects: Array<CatalogProject>;
  publishedAt?: Maybe<Scalars['Long']>;
  publishedBy?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type CatalogConnection = {
  __typename?: 'CatalogConnection';
  items: Array<Catalog>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CatalogProject = {
  __typename?: 'CatalogProject';
  project: Project;
  projectId: Scalars['ID'];
};

export enum Category {
  Concurrent = 'Concurrent',
  FormulationNotRecommended = 'FormulationNotRecommended',
  Objection = 'Objection',
  Product = 'Product'
}

export type CheckCommandInput = {
  language: Scalars['String'];
  text: Scalars['String'];
};

export type ChildAssistantSelector = {
  __typename?: 'ChildAssistantSelector';
  assistantId: Scalars['ID'];
  message: Scalars['String'];
  title: Scalars['String'];
};

export enum ClientLabelId {
  Caller = 'caller',
  Client = 'client',
  Interlocutor = 'interlocutor',
  Partner = 'partner',
  Prospect = 'prospect',
  Representative = 'representative'
}

export type Command = {
  __typename?: 'Command';
  alternatives?: Maybe<Array<Scalars['String']>>;
  associations: Array<ProjectCommand>;
  commandRequest?: Maybe<CommandRequest>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  enabled: Scalars['Boolean'];
  forbiddenWordings?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  language: Scalars['String'];
  onlyAlternative?: Maybe<Scalars['Boolean']>;
  projectCommand?: Maybe<ProjectCommand>;
  text: Scalars['String'];
  textLower: Scalars['String'];
};


export type CommandProjectCommandArgs = {
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum CommandComplianceType {
  NotRecommended = 'NotRecommended',
  Recommended = 'Recommended'
}

export type CommandConnection = {
  __typename?: 'CommandConnection';
  items: Array<Command>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CommandContext = {
  __typename?: 'CommandContext';
  color: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  displays: Array<ProjectCommandContext>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  text: Scalars['String'];
  textLower: Scalars['String'];
  triggers: Array<ProjectCommand>;
  user: User;
  vocalTriggers: Array<ProjectVocalTrigger>;
};

export type CommandDetectionStatistics = {
  __typename?: 'CommandDetectionStatistics';
  command?: Maybe<Command>;
  commandId: Scalars['ID'];
  current: DetectionStatisticsMetric;
  previous: DetectionStatisticsMetric;
};

export type CommandRequest = {
  __typename?: 'CommandRequest';
  command: Command;
  commandId: Scalars['ID'];
  createdBy: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  organisationId: Scalars['ID'];
  status: CommandRequestStatus;
  updateDate: Scalars['AWSTimestamp'];
};

export type CommandRequestConnection = {
  __typename?: 'CommandRequestConnection';
  items: Array<CommandRequest>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum CommandRequestStatus {
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Generic = 'Generic',
  Ok = 'Ok',
  Pending = 'Pending'
}

export type CommandStatId = StatId & {
  __typename?: 'CommandStatId';
  command: Command;
  commandId: Scalars['String'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  projectCommand?: Maybe<ProjectCommand>;
  startDate: Scalars['Long'];
};


export type CommandStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type CommandViewAssignment = AbstractAssignment & {
  __typename?: 'CommandViewAssignment';
  assignee: Command;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: View;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type CommandViewAssignmentConnection = {
  __typename?: 'CommandViewAssignmentConnection';
  items: Array<CommandViewAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  commentType: CommentType;
  content: Scalars['String'];
  date: Scalars['Long'];
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  isReply?: Maybe<Scalars['Boolean']>;
  numReplies?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  parentId: Scalars['String'];
  updateDate?: Maybe<Scalars['Long']>;
  user: User;
  userId: Scalars['String'];
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  items: Array<Comment>;
};

export enum CommentType {
  Card = 'Card',
  ContentRequest = 'ContentRequest'
}

export type CommitAdvancedAnalysisItemEvaluationJobInput = {
  id: Scalars['ID'];
};

export type ComplianceChecklist = {
  __typename?: 'ComplianceChecklist';
  items: Array<ComplianceChecklistItem>;
};

export type ComplianceChecklistItem = {
  __typename?: 'ComplianceChecklistItem';
  date: Scalars['Long'];
  mandatoryTopic: MandatoryTopic;
  project: Project;
  projectId: Scalars['String'];
  status: ComplianceChecklistItemStatus;
  topicTextLower: Scalars['String'];
};

export enum ComplianceChecklistItemStatus {
  NotValidated = 'NotValidated',
  Rejected = 'Rejected',
  Validated = 'Validated'
}

export type ComplianceExcludedEvent = BaseSessionEventV2 & {
  __typename?: 'ComplianceExcludedEvent';
  causes: Array<SessionEventV2Cause>;
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type ComplianceFilterInput = {
  filters?: InputMaybe<Array<ComplianceTopicFilterInput>>;
};

export type ComplianceModule = {
  __typename?: 'ComplianceModule';
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemComplianceModuleAssignmentConnection;
  assignedFactCheckModules: FactCheckModuleComplianceModuleAssignmentConnection;
  assignedOperationItems: ComplianceOperationItemComplianceModuleAssignmentConnection;
  assignedTopics: TopicComplianceModuleAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  mirrorView?: Maybe<ViewComplianceModuleAssignment>;
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projectAssignments: ComplianceModuleProjectAssignmentConnection;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceModuleMutations = {
  __typename?: 'ComplianceModuleMutations';
  create: ComplianceModule;
  delete: ComplianceModule;
  update: ComplianceModule;
};


export type ComplianceModuleMutationsCreateArgs = {
  input: CreateComplianceModuleInput;
};


export type ComplianceModuleMutationsDeleteArgs = {
  input: IdInput;
};


export type ComplianceModuleMutationsUpdateArgs = {
  input: UpdateComplianceModuleInput;
};

export type ComplianceModuleProjectAssignment = AbstractAssignment & {
  __typename?: 'ComplianceModuleProjectAssignment';
  assignee: ComplianceModule;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceModuleProjectAssignmentConnection = {
  __typename?: 'ComplianceModuleProjectAssignmentConnection';
  items: Array<ComplianceModuleProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ComplianceModuleQueries = {
  __typename?: 'ComplianceModuleQueries';
  get: ComplianceModule;
  list: Array<ComplianceModule>;
};


export type ComplianceModuleQueriesGetArgs = {
  input: IdInput;
};

export type ComplianceModuleStatId = StatId & {
  __typename?: 'ComplianceModuleStatId';
  complianceModule: ComplianceModule;
  complianceModuleId: Scalars['ID'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type ComplianceModuleStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type ComplianceModuleStatistics = {
  __typename?: 'ComplianceModuleStatistics';
  complianceModule?: Maybe<ComplianceModule>;
  complianceModuleId: Scalars['ID'];
  current: ComplianceStatisticsMetric;
  previous: ComplianceStatisticsMetric;
};

export type ComplianceOperationItem = {
  __typename?: 'ComplianceOperationItem';
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemComplianceOperationItemAssignmentConnection;
  assignedOperationItems: ComplianceOperationItemComplianceOperationItemAssignmentConnection;
  assignedTopics: TopicComplianceOperationItemAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  operator: ComplianceOperationItemScoreRuleOperator;
  organisationId: Scalars['ID'];
  root: ComplianceOperationItemRoot;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceOperationItemComplianceModuleAssignment = AbstractAssignment & {
  __typename?: 'ComplianceOperationItemComplianceModuleAssignment';
  assignee: ComplianceOperationItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceOperationItemComplianceModuleAssignmentConnection = {
  __typename?: 'ComplianceOperationItemComplianceModuleAssignmentConnection';
  items: Array<ComplianceOperationItemComplianceModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ComplianceOperationItemComplianceOperationItemAssignment = AbstractAssignment & {
  __typename?: 'ComplianceOperationItemComplianceOperationItemAssignment';
  assignee: ComplianceOperationItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceOperationItem;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceOperationItemComplianceOperationItemAssignmentConnection = {
  __typename?: 'ComplianceOperationItemComplianceOperationItemAssignmentConnection';
  items: Array<ComplianceOperationItemComplianceOperationItemAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ComplianceOperationItemEvaluationSheetAssignment = AbstractAssignment & {
  __typename?: 'ComplianceOperationItemEvaluationSheetAssignment';
  assignee: ComplianceOperationItem;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  criticityLevel: EvaluationSheetCriticityLevel;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: EvaluationSheet;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ComplianceOperationItemEvaluationSheetAssignmentConnection = {
  __typename?: 'ComplianceOperationItemEvaluationSheetAssignmentConnection';
  items: Array<ComplianceOperationItemEvaluationSheetAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ComplianceOperationItemMutations = {
  __typename?: 'ComplianceOperationItemMutations';
  create: ComplianceOperationItem;
  delete: ComplianceOperationItem;
  update: ComplianceOperationItem;
};


export type ComplianceOperationItemMutationsCreateArgs = {
  input: CreateComplianceOperationItemInput;
};


export type ComplianceOperationItemMutationsDeleteArgs = {
  input: IdInput;
};


export type ComplianceOperationItemMutationsUpdateArgs = {
  input: UpdateComplianceOperationItemInput;
};

export type ComplianceOperationItemQueries = {
  __typename?: 'ComplianceOperationItemQueries';
  get: ComplianceOperationItem;
  list: Array<ComplianceOperationItem>;
};


export type ComplianceOperationItemQueriesGetArgs = {
  input: IdInput;
};

export type ComplianceOperationItemRoot = {
  __typename?: 'ComplianceOperationItemRoot';
  children: Scalars['AWSJSON'];
  weight: Scalars['Float'];
};

export enum ComplianceOperationItemScoreRuleOperator {
  Max = 'Max',
  Min = 'Min',
  StrictMax = 'StrictMax',
  Sum = 'Sum'
}

export type ComplianceRejectedEvent = BaseSessionEventV2 & {
  __typename?: 'ComplianceRejectedEvent';
  causes: Array<SessionEventV2Cause>;
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type ComplianceRequiredEvent = BaseSessionEventV2 & {
  __typename?: 'ComplianceRequiredEvent';
  causes: Array<SessionEventV2Cause>;
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type ComplianceStatisticsMetric = {
  __typename?: 'ComplianceStatisticsMetric';
  compliancyCompletedCount: Scalars['Int'];
  compliancyRequiredCount: Scalars['Int'];
};

export type ComplianceStatisticsMetricTrend = {
  __typename?: 'ComplianceStatisticsMetricTrend';
  current: ComplianceStatisticsMetric;
  previous: ComplianceStatisticsMetric;
};

export type ComplianceStatisticsQueries = {
  __typename?: 'ComplianceStatisticsQueries';
  byComplianceModule: Array<ComplianceModuleStatistics>;
  byTopic: Array<TopicComplianceStatistics>;
  byUser: Array<UserComplianceStatistics>;
  totals: ComplianceStatisticsMetricTrend;
};


export type ComplianceStatisticsQueriesByComplianceModuleArgs = {
  input: ComplianceStatisticsTrendInput;
};


export type ComplianceStatisticsQueriesByTopicArgs = {
  input: ComplianceStatisticsTrendInput;
};


export type ComplianceStatisticsQueriesByUserArgs = {
  input: ComplianceStatisticsTrendInput;
};


export type ComplianceStatisticsQueriesTotalsArgs = {
  input: ComplianceStatisticsTrendInput;
};

export type ComplianceStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export enum ComplianceStatusFilter {
  NonValidated = 'NonValidated',
  Rejected = 'Rejected',
  Validated = 'Validated'
}

export type ComplianceTopicFilterInput = {
  status?: InputMaybe<Array<ComplianceStatusFilter>>;
  topicTextLower: Scalars['String'];
};

export type ComplianceTopicQueries = {
  __typename?: 'ComplianceTopicQueries';
  get: MandatoryTopic;
};


export type ComplianceTopicQueriesGetArgs = {
  input: GetComplianceTopicInput;
};

export type ComplianceValidatedEvent = BaseSessionEventV2 & {
  __typename?: 'ComplianceValidatedEvent';
  causes: Array<SessionEventV2Cause>;
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type ConditionTopic = {
  __typename?: 'ConditionTopic';
  textLower: Scalars['String'];
  topic: Topic;
};

export type ConfirmAccountInput = {
  displayName: Scalars['String'];
  password: Scalars['String'];
};

/** Legacy types */
export type ContentBlock = {
  __typename?: 'ContentBlock';
  blockType: ContentBlockType;
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['Long']>;
  createdBy?: Maybe<Scalars['String']>;
  date: Scalars['Long'];
  displayType: ContentBlockDisplayType;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum ContentBlockDisplayType {
  Always = 'Always',
  Cta = 'Cta'
}

export enum ContentBlockType {
  Richtext = 'Richtext'
}

/** new card content types */
export type ContentBlockV2 = {
  __typename?: 'ContentBlockV2';
  blockType: ContentBlockType;
  content: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  displayType: ContentBlockDisplayType;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type ContentGenerationAssistant = {
  __typename?: 'ContentGenerationAssistant';
  agentAliasId?: Maybe<Scalars['ID']>;
  agentId?: Maybe<Scalars['ID']>;
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemContentGenerationAssistantAssignmentConnection;
  condenseQueryInstruction: Scalars['String'];
  contentGenerationSystemPrompt?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  customization: ContentGenerationAssistantCustomization;
  dataSources: Array<ContentGenerationAssistantDataSource>;
  deletedAt?: Maybe<Scalars['Long']>;
  documentNames: Array<Scalars['String']>;
  documents: Array<UploadedDocuments>;
  id: Scalars['ID'];
  indexedAt?: Maybe<Scalars['Long']>;
  instruction: Scalars['String'];
  knowledgeBaseId: Scalars['ID'];
  listThreads: ContentGenerationAssistantThreadConnection;
  model: ContentGenerationAssistantLlmModel;
  organisationId: Scalars['String'];
  rephraseConfig?: Maybe<ContentGenerationAssistantRephraseConfig>;
  status?: Maybe<ContentGenerationAssistantStatus>;
  title: Scalars['String'];
  titleInstruction: Scalars['String'];
  type: AssistantType;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
  user: User;
  websiteSources?: Maybe<Array<ContentGenerationAssistantWebDataSource>>;
};


export type ContentGenerationAssistantListThreadsArgs = {
  input: InfiniteQueryInput;
};

export type ContentGenerationAssistantConnection = {
  __typename?: 'ContentGenerationAssistantConnection';
  items: Array<ContentGenerationAssistant>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantCustomization = {
  __typename?: 'ContentGenerationAssistantCustomization';
  assistantId: Scalars['ID'];
  childAssistants?: Maybe<Array<ChildAssistantSelector>>;
  form?: Maybe<ContentGenerationAssistantCustomizationForm>;
  initMessages?: Maybe<Array<Scalars['String']>>;
  leftCta?: Maybe<ContentGenerationAssistantCustomizationCta>;
  organisationId: Scalars['String'];
  position: ContentGenerationAssistantCustomizationPosition;
  prompt: ContentGenerationAssistantCustomizationPrompt;
  rightCta?: Maybe<ContentGenerationAssistantCustomizationCta>;
  style: ContentGenerationAssistantCustomizationStyle;
  text: ContentGenerationAssistantCustomizationText;
  urls: ContentGenerationAssistantCustomizationUrls;
};

export type ContentGenerationAssistantCustomizationCta = {
  __typename?: 'ContentGenerationAssistantCustomizationCta';
  displayText: Scalars['String'];
  url: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationCtaInput = {
  displayText: Scalars['String'];
  url: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationForm = {
  __typename?: 'ContentGenerationAssistantCustomizationForm';
  description: Scalars['String'];
  endpoint: Scalars['String'];
  formFields: Array<ContentGenerationAssistantCustomizationFormField>;
  responseFields: Array<ContentGenerationAssistantCustomizationResponseField>;
  submit: Scalars['String'];
  title: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationFormBooleanField = BaseContentGenerationAssistantCustomizationFormField & {
  __typename?: 'ContentGenerationAssistantCustomizationFormBooleanField';
  description: Scalars['String'];
  fieldName: Scalars['String'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationFormField = ContentGenerationAssistantCustomizationFormBooleanField | ContentGenerationAssistantCustomizationFormNumberField | ContentGenerationAssistantCustomizationFormTextField;

export type ContentGenerationAssistantCustomizationFormInput = {
  id: Scalars['ID'];
  json: Scalars['AWSJSON'];
};

export type ContentGenerationAssistantCustomizationFormNumberField = BaseContentGenerationAssistantCustomizationFormField & {
  __typename?: 'ContentGenerationAssistantCustomizationFormNumberField';
  description: Scalars['String'];
  fieldName: Scalars['String'];
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationFormTextField = BaseContentGenerationAssistantCustomizationFormField & {
  __typename?: 'ContentGenerationAssistantCustomizationFormTextField';
  description: Scalars['String'];
  fieldName: Scalars['String'];
  multiple?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Scalars['String']>>;
  required: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationInput = {
  assistantId: Scalars['ID'];
  initMessages?: InputMaybe<Array<Scalars['String']>>;
  leftCta?: InputMaybe<ContentGenerationAssistantCustomizationCtaInput>;
  position?: InputMaybe<ContentGenerationAssistantCustomizationPositionInput>;
  prompt?: InputMaybe<ContentGenerationAssistantCustomizationPromptInput>;
  rightCta?: InputMaybe<ContentGenerationAssistantCustomizationCtaInput>;
  style?: InputMaybe<ContentGenerationAssistantCustomizationStyleInput>;
  text?: InputMaybe<ContentGenerationAssistantCustomizationTextInput>;
  urls?: InputMaybe<ContentGenerationAssistantCustomizationUrlsInput>;
};

export type ContentGenerationAssistantCustomizationPaletteColor = {
  __typename?: 'ContentGenerationAssistantCustomizationPaletteColor';
  dark: Scalars['String'];
  light: Scalars['String'];
  main: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationPaletteColorInput = {
  dark?: InputMaybe<Scalars['String']>;
  light?: InputMaybe<Scalars['String']>;
  main?: InputMaybe<Scalars['String']>;
};

export type ContentGenerationAssistantCustomizationPaletteInput = {
  error?: InputMaybe<ContentGenerationAssistantCustomizationPaletteColorInput>;
  primary?: InputMaybe<ContentGenerationAssistantCustomizationPaletteColorInput>;
  secondary?: InputMaybe<ContentGenerationAssistantCustomizationPaletteColorInput>;
  success?: InputMaybe<ContentGenerationAssistantCustomizationPaletteColorInput>;
  text?: InputMaybe<ContentGenerationAssistantCustomizationPaletteTextInput>;
  warning?: InputMaybe<ContentGenerationAssistantCustomizationPaletteColorInput>;
};

export type ContentGenerationAssistantCustomizationPaletteText = {
  __typename?: 'ContentGenerationAssistantCustomizationPaletteText';
  disabled: Scalars['String'];
  primary: Scalars['String'];
  secondary: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationPaletteTextInput = {
  disabled?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['String']>;
  secondary?: InputMaybe<Scalars['String']>;
};

export type ContentGenerationAssistantCustomizationPosition = {
  __typename?: 'ContentGenerationAssistantCustomizationPosition';
  horizontal: Scalars['String'];
  vertical: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationPositionInput = {
  horizontal?: InputMaybe<Scalars['String']>;
  vertical?: InputMaybe<Scalars['String']>;
};

export type ContentGenerationAssistantCustomizationPrompt = {
  __typename?: 'ContentGenerationAssistantCustomizationPrompt';
  bubbleImageOverrideUrl?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type ContentGenerationAssistantCustomizationPromptInput = {
  bubbleImageOverrideUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ContentGenerationAssistantCustomizationResponseField = {
  __typename?: 'ContentGenerationAssistantCustomizationResponseField';
  description: Scalars['String'];
  displayText?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  position: ContentGenerationAssistantCustomizationResponseFieldPosition;
  title: Scalars['String'];
  variant: ContentGenerationAssistantCustomizationResponseFieldVariant;
};

export enum ContentGenerationAssistantCustomizationResponseFieldPosition {
  Content = 'Content',
  Details = 'Details',
  Title = 'Title'
}

export enum ContentGenerationAssistantCustomizationResponseFieldVariant {
  Array = 'Array',
  Link = 'Link',
  Subtitle1 = 'Subtitle1',
  Title = 'Title'
}

export type ContentGenerationAssistantCustomizationStyle = {
  __typename?: 'ContentGenerationAssistantCustomizationStyle';
  palette: ContentGenerationAssistantCustomizationStylePalette;
  typography: ContentGenerationAssistantCustomizationTypography;
};

export type ContentGenerationAssistantCustomizationStyleInput = {
  palette?: InputMaybe<ContentGenerationAssistantCustomizationPaletteInput>;
  typography?: InputMaybe<ContentGenerationAssistantCustomizationTypographyInput>;
};

export type ContentGenerationAssistantCustomizationStylePalette = {
  __typename?: 'ContentGenerationAssistantCustomizationStylePalette';
  error: ContentGenerationAssistantCustomizationPaletteColor;
  primary: ContentGenerationAssistantCustomizationPaletteColor;
  secondary: ContentGenerationAssistantCustomizationPaletteColor;
  success: ContentGenerationAssistantCustomizationPaletteColor;
  text: ContentGenerationAssistantCustomizationPaletteText;
  warning: ContentGenerationAssistantCustomizationPaletteColor;
};

export type ContentGenerationAssistantCustomizationText = {
  __typename?: 'ContentGenerationAssistantCustomizationText';
  subtitle1: Scalars['String'];
  subtitle2: Scalars['String'];
  title: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationTextInput = {
  subtitle1?: InputMaybe<Scalars['String']>;
  subtitle2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ContentGenerationAssistantCustomizationTypography = {
  __typename?: 'ContentGenerationAssistantCustomizationTypography';
  fontFamily: Scalars['String'];
  fontSize: Scalars['Int'];
};

export type ContentGenerationAssistantCustomizationTypographyInput = {
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
};

export type ContentGenerationAssistantCustomizationUrls = {
  __typename?: 'ContentGenerationAssistantCustomizationUrls';
  ctaUrl: Scalars['String'];
  iconUrl: Scalars['String'];
};

export type ContentGenerationAssistantCustomizationUrlsInput = {
  ctaUrl: Scalars['String'];
  iconUrl: Scalars['String'];
};

export type ContentGenerationAssistantDataSource = ContentGenerationAssistantDataSourceS3 | ContentGenerationAssistantDataSourceWeb;

export type ContentGenerationAssistantDataSourceS3 = BaseContentGenerationAssistantDataSource & {
  __typename?: 'ContentGenerationAssistantDataSourceS3';
  assistantId: Scalars['ID'];
  documents: Array<UploadedDocuments>;
  id: Scalars['ID'];
  knowledgeBaseId: Scalars['ID'];
  name: Scalars['String'];
  syncJob?: Maybe<ContentGenerationAssistantDataSourceSyncJob>;
};

export type ContentGenerationAssistantDataSourceSyncJob = {
  __typename?: 'ContentGenerationAssistantDataSourceSyncJob';
  startedAt: Scalars['Long'];
  status: ContentGenerationAssistantDataSourceSyncJobStatus;
};

export enum ContentGenerationAssistantDataSourceSyncJobStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Starting = 'Starting'
}

export type ContentGenerationAssistantDataSourceWeb = BaseContentGenerationAssistantDataSource & {
  __typename?: 'ContentGenerationAssistantDataSourceWeb';
  assistantId: Scalars['ID'];
  exclusionFilters?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  inclusionFilters?: Maybe<Array<Scalars['String']>>;
  knowledgeBaseId: Scalars['ID'];
  name: Scalars['String'];
  seedUrls: Array<Scalars['String']>;
  syncJob?: Maybe<ContentGenerationAssistantDataSourceSyncJob>;
};

export enum ContentGenerationAssistantLlmModel {
  BedrockMixtral = 'BedrockMixtral',
  OpenAi = 'OpenAI'
}

export type ContentGenerationAssistantMessage = {
  __typename?: 'ContentGenerationAssistantMessage';
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type ContentGenerationAssistantMutation = {
  __typename?: 'ContentGenerationAssistantMutation';
  addWebsiteSource: ContentGenerationAssistant;
  create: ContentGenerationAssistant;
  generateTag: Scalars['String'];
  indexAllDocuments: ContentGenerationIndexDocumentResponse;
  prepareAgent: ContentGenerationAssistant;
  removeDocument: ContentGenerationAssistant;
  removeWebsiteSource: ContentGenerationAssistant;
  syncDataSource: ContentGenerationAssistantDataSourceSyncJob;
  update: ContentGenerationAssistant;
  updateCustomForm: ContentGenerationAssistant;
  updateCustomization: ContentGenerationAssistant;
  updateInstruction: ContentGenerationAssistant;
  updateOrganisationConfig: OrganisationChatFeatures;
  updateWebsiteDatasource: ContentGenerationAssistant;
};


export type ContentGenerationAssistantMutationAddWebsiteSourceArgs = {
  input: AddAssistantWebsiteSourceInput;
};


export type ContentGenerationAssistantMutationCreateArgs = {
  input: CreateContentGenerationAssistantInput;
};


export type ContentGenerationAssistantMutationGenerateTagArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantMutationIndexAllDocumentsArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantMutationPrepareAgentArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantMutationRemoveDocumentArgs = {
  input: RemoveAssistantDocumentInput;
};


export type ContentGenerationAssistantMutationRemoveWebsiteSourceArgs = {
  input: RemoveAssistantWebsiteSourceInput;
};


export type ContentGenerationAssistantMutationSyncDataSourceArgs = {
  input: StartAssistantDataSourceSyncInput;
};


export type ContentGenerationAssistantMutationUpdateArgs = {
  input: UpdateAssistantInput;
};


export type ContentGenerationAssistantMutationUpdateCustomFormArgs = {
  input: ContentGenerationAssistantCustomizationFormInput;
};


export type ContentGenerationAssistantMutationUpdateCustomizationArgs = {
  input: ContentGenerationAssistantCustomizationInput;
};


export type ContentGenerationAssistantMutationUpdateInstructionArgs = {
  input: UpdateAssistantInstructionInput;
};


export type ContentGenerationAssistantMutationUpdateOrganisationConfigArgs = {
  input: UpdateAssistantOrganisationConfigInput;
};


export type ContentGenerationAssistantMutationUpdateWebsiteDatasourceArgs = {
  input: UpdateAssistantWebsiteDataSourceInput;
};

export enum ContentGenerationAssistantPreset {
  Chat = 'Chat',
  ContentFormatting = 'ContentFormatting',
  ContentGeneration = 'ContentGeneration',
  EmailResponse = 'EmailResponse',
  Summarization = 'Summarization'
}

export type ContentGenerationAssistantQuery = {
  __typename?: 'ContentGenerationAssistantQuery';
  get: ContentGenerationAssistant;
  getContentGenerationThreadMessages: ContentGenerationAssistantThreadMessageConnection;
  getThread: ContentGenerationAssistantThread;
  getUploadDocumentUrl: Scalars['String'];
  list: ContentGenerationAssistantConnection;
};


export type ContentGenerationAssistantQueryGetArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantQueryGetContentGenerationThreadMessagesArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantQueryGetThreadArgs = {
  input: IdInput;
};


export type ContentGenerationAssistantQueryGetUploadDocumentUrlArgs = {
  input: GetUploadDocumentUrlInput;
};


export type ContentGenerationAssistantQueryListArgs = {
  input: InfiniteQueryInput;
};

export type ContentGenerationAssistantRephraseConfig = {
  __typename?: 'ContentGenerationAssistantRephraseConfig';
  enabled: Scalars['Boolean'];
  instruction?: Maybe<Scalars['String']>;
};

export enum ContentGenerationAssistantStatus {
  InPreview = 'InPreview',
  InProgress = 'InProgress',
  Published = 'Published'
}

export type ContentGenerationAssistantThread = {
  __typename?: 'ContentGenerationAssistantThread';
  assistantId: Scalars['ID'];
  childAssistantId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Long'];
  duration?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  messages: Array<ContentGenerationAssistantThreadMessage>;
  organisationId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantThreadConnection = {
  __typename?: 'ContentGenerationAssistantThreadConnection';
  items: Array<ContentGenerationAssistantThread>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantThreadMessage = {
  __typename?: 'ContentGenerationAssistantThreadMessage';
  createdAt: Scalars['Long'];
  grounded?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
  role: ContentGenerationAssistantThreadMessageRole;
  sources?: Maybe<Array<ContentGenerationAssistantThreadMessageSource>>;
};

export type ContentGenerationAssistantThreadMessageConnection = {
  __typename?: 'ContentGenerationAssistantThreadMessageConnection';
  items: Array<ContentGenerationMessage>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum ContentGenerationAssistantThreadMessageRole {
  Assistant = 'Assistant',
  System = 'System',
  User = 'User'
}

export type ContentGenerationAssistantThreadMessageSource = {
  __typename?: 'ContentGenerationAssistantThreadMessageSource';
  content: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

export type ContentGenerationAssistantUserMessage = {
  __typename?: 'ContentGenerationAssistantUserMessage';
  content: Scalars['String'];
  id: Scalars['ID'];
};

/** legacy */
export type ContentGenerationAssistantWebDataSource = {
  __typename?: 'ContentGenerationAssistantWebDataSource';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ContentGenerationContentMessage = {
  __typename?: 'ContentGenerationContentMessage';
  id: Scalars['ID'];
  tabs: Array<ContentGenerationTab>;
  title: Scalars['String'];
};

export type ContentGenerationIndexDocumentResponse = {
  __typename?: 'ContentGenerationIndexDocumentResponse';
  nbDocumentsIndexed: Scalars['Int'];
};

export type ContentGenerationMessage = ContentGenerationAssistantMessage | ContentGenerationAssistantUserMessage | ContentGenerationContentMessage;

export type ContentGenerationMutations = {
  __typename?: 'ContentGenerationMutations';
  translateCard: Card;
  translateProject: Project;
  translateTopics: Array<MandatoryTopic>;
  translateTriggers: Array<ProjectVocalTrigger>;
  updateProjectTranslateInstruction: Project;
};


export type ContentGenerationMutationsTranslateCardArgs = {
  input: TranslateCardInput;
};


export type ContentGenerationMutationsTranslateProjectArgs = {
  input: TranslateItemInput;
};


export type ContentGenerationMutationsTranslateTopicsArgs = {
  input: TranslateItemInput;
};


export type ContentGenerationMutationsTranslateTriggersArgs = {
  input: TranslateItemInput;
};


export type ContentGenerationMutationsUpdateProjectTranslateInstructionArgs = {
  input: UpdateTranslateInstructionInput;
};

export type ContentGenerationTab = {
  __typename?: 'ContentGenerationTab';
  lexical: Scalars['String'];
  title: Scalars['String'];
};

export type ContentRequest = {
  __typename?: 'ContentRequest';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['String']>;
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['String']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['Long']>;
  details: Scalars['String'];
  organisationId: Scalars['String'];
  project: Project;
  projectId: Scalars['String'];
  state: ContentRequestState;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  user: User;
};

export type ContentRequestConnection = {
  __typename?: 'ContentRequestConnection';
  items: Array<ContentRequest>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum ContentRequestState {
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Done = 'Done',
  InProgress = 'InProgress',
  Pending = 'Pending'
}

export type ContentTag = {
  __typename?: 'ContentTag';
  author: Scalars['ID'];
  contentId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  text: Scalars['String'];
};

export type ContentTagConnection = {
  __typename?: 'ContentTagConnection';
  items: Array<ContentTag>;
};

export type ContextEvent = BaseSessionEventV2 & {
  __typename?: 'ContextEvent';
  context: CommandContext;
  contextId: Scalars['String'];
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type ContextMutations = {
  __typename?: 'ContextMutations';
  create: CommandContext;
  delete: CommandContext;
  update: CommandContext;
};


export type ContextMutationsCreateArgs = {
  input: CreateCommandContextInput;
};


export type ContextMutationsDeleteArgs = {
  input: DeleteCommandContextInput;
};


export type ContextMutationsUpdateArgs = {
  input: UpdateContextInput;
};

export type ContextQueries = {
  __typename?: 'ContextQueries';
  get: CommandContext;
};


export type ContextQueriesGetArgs = {
  input: ContextQueryInput;
};

export type ContextQueryInput = {
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type ConversationEngagedEvent = BaseSessionEventV2 & {
  __typename?: 'ConversationEngagedEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type CountAdvancedAnalysisConversationsInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  factCheckModuleId?: InputMaybe<Scalars['ID']>;
  from: Scalars['Long'];
  overwrite?: InputMaybe<Scalars['Boolean']>;
  phrasingPerformanceSubjectId?: InputMaybe<Scalars['ID']>;
  to: Scalars['Long'];
};

export type CreateAdvancedAnalysisCoachingInput = {
  advancedAnalysisItemId: Scalars['ID'];
  filters?: InputMaybe<AdvancedAnalysisCoachingFiltersInput>;
  from: Scalars['Long'];
  modelId: Scalars['String'];
  prompt: Scalars['String'];
  to: Scalars['Long'];
};

export type CreateAdvancedAnalysisItemEvaluationJobInput = {
  advancedAnalysisItemId: Scalars['ID'];
  analysisMode?: InputMaybe<AdvancedAnalysisItemEvaluationAnalysisMode>;
  modelId?: InputMaybe<Scalars['String']>;
  wording: Scalars['String'];
};

export type CreateAdvancedAnalysisItemInput = {
  boolPositiveAnswer?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  options?: InputMaybe<Array<Scalars['String']>>;
  question: Scalars['String'];
  type?: InputMaybe<AdvancedAnalysisItemType>;
};

export type CreateAdvancedAnalysisJobInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  discovery?: InputMaybe<Scalars['Boolean']>;
  factCheckModuleId?: InputMaybe<Scalars['ID']>;
  forceIndexedOutput?: InputMaybe<Scalars['Boolean']>;
  forceStructuredOutput?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Long'];
  modelId?: InputMaybe<Scalars['String']>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
  phrasingPerformanceSubjectId?: InputMaybe<Scalars['ID']>;
  to: Scalars['Long'];
};

export type CreateAsrCommandInput = {
  alternatives: Array<Scalars['String']>;
  language: Scalars['String'];
  levenshteinDistance: Scalars['String'];
  name: Scalars['String'];
  prefixSize: Scalars['Int'];
};

export type CreateAssignmentInput = {
  assigneeId: Scalars['ID'];
  assignmentType: AssignmentType;
  extraFields?: InputMaybe<Scalars['AWSJSON']>;
  groupId: Scalars['ID'];
  withHistorization?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCallStatusInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCardInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  language?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  tabs?: InputMaybe<Scalars['AWSJSON']>;
  title: Scalars['String'];
};

export type CreateCommandContextInput = {
  color?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateCommandNewInput = {
  alternatives: Array<Scalars['String']>;
  language: Scalars['String'];
  text: Scalars['String'];
};

export type CreateCommentInput = {
  commentType: CommentType;
  content: Scalars['String'];
  isReply: Scalars['Boolean'];
  parentId: Scalars['String'];
};

export type CreateComplianceModuleInput = {
  name: Scalars['String'];
};

export type CreateComplianceOperationItemInput = {
  operator: ComplianceOperationItemScoreRuleOperator;
  title: Scalars['String'];
};

export type CreateContentGenerationAssistantInput = {
  customization: ContentGenerationAssistantCustomizationInput;
  name: Scalars['String'];
  preset?: InputMaybe<ContentGenerationAssistantPreset>;
};

export type CreateContentRequestInput = {
  details: Scalars['String'];
  projectId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateContentTagInput = {
  contentId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateDecisionTreeInput = {
  name: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
};

export type CreateDecisionTreeVariableInput = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CreateDetectionInput = {
  ASRText?: InputMaybe<Scalars['String']>;
  cardId: Scalars['ID'];
  commandId: Scalars['String'];
  id: Scalars['ID'];
  model: Scalars['String'];
  projectId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type CreateDisplayInput = {
  cardId: Scalars['ID'];
  detectionId?: InputMaybe<Scalars['ID']>;
  displayType: DisplayType;
  id?: InputMaybe<Scalars['ID']>;
  isVisible: Scalars['Boolean'];
  projectId: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
  tabId?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type CreateEvaluationSheetInput = {
  name: Scalars['String'];
};

export type CreateExcelCardImporterInput = {
  name: Scalars['String'];
  organisationId: Scalars['ID'];
};

export type CreateFactCheckModuleInput = {
  attributionGuidance?: InputMaybe<Scalars['String']>;
  attributionMode?: InputMaybe<FactCheckAttributionMode>;
  name: Scalars['String'];
};

export type CreateFactCheckProductInput = {
  freeText: Scalars['String'];
  moduleId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateFactCheckThemeInput = {
  hint: Scalars['String'];
  label: Scalars['String'];
  moduleId: Scalars['ID'];
};

export type CreateIntegrationInput = {
  type: IntegrationType;
};

export type CreateIntentionInput = {
  text: Scalars['String'];
};

export type CreateMandatoryTopicInput = {
  complianceExample?: InputMaybe<Scalars['String']>;
  conditionTopics?: InputMaybe<Array<Scalars['String']>>;
  externalStatusCodeBlacklist?: InputMaybe<Array<Scalars['String']>>;
  forbiddenCommands?: InputMaybe<Array<Scalars['String']>>;
  forceRequiredIfPreviousNotValidated?: InputMaybe<Scalars['Boolean']>;
  minimumDuration?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['String'];
  reminderTime?: InputMaybe<Scalars['Float']>;
  reminderType?: InputMaybe<MandatoryTopicReminderType>;
  sessionStepCondition?: InputMaybe<MandatoryTopicSessionStep>;
  sessionTagBlacklist?: InputMaybe<Array<Scalars['String']>>;
  sessionTagWhitelist?: InputMaybe<Array<Scalars['String']>>;
  topicTextLower: Scalars['String'];
};

export type CreateNewsInput = {
  content: Scalars['String'];
  title: Scalars['String'];
};

export type CreatePhrasingPerformanceSubjectInput = {
  name: Scalars['String'];
};

export type CreatePhrasingSubjectInput = {
  name: Scalars['String'];
  wordings: Array<Scalars['String']>;
};

export type CreateProjectCommandInput = {
  cardCommandContexts?: InputMaybe<Array<CardCommandContextInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Category>;
  commandContextTextLower?: InputMaybe<Scalars['String']>;
  isAlerting?: InputMaybe<Scalars['Boolean']>;
  isSpecific: Scalars['Boolean'];
  language: Scalars['String'];
  onlyDisplayForAgent?: InputMaybe<Scalars['Boolean']>;
  onlyDisplayForClient?: InputMaybe<Scalars['Boolean']>;
  permissiveMatching?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  tabId?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type CreateProjectInput = {
  asrLanguage: Scalars['String'];
  name: Scalars['String'];
};

export type CreateProjectIntentionInput = {
  cardCommandContexts?: InputMaybe<Array<CardCommandContextInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  commandContextTextLower?: InputMaybe<Scalars['String']>;
  intentionId: Scalars['ID'];
  isAlerting?: InputMaybe<Scalars['Boolean']>;
  onlyDisplayForAgent?: InputMaybe<Scalars['Boolean']>;
  onlyDisplayForClient?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  tabId?: InputMaybe<Scalars['String']>;
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type CreateRecommenderColumnSpecInput = {
  columnName: Scalars['String'];
  defaultSpec: RecommenderStringColumnSpecInput;
  displaySpec?: InputMaybe<RecommenderColumnSpecDisplayInput>;
  numberSpec?: InputMaybe<RecommenderNumberColumnSpecInput>;
  recommenderId: Scalars['ID'];
};

export type CreateRecommenderInput = {
  name: Scalars['String'];
  organisationId: Scalars['String'];
};

export type CreateSessionInput = {
  externalCallId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
};

export type CreateSessionInputV2 = {
  dualChannelAppVersion?: InputMaybe<Scalars['String']>;
  externalCallId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  inputDevice?: InputMaybe<Scalars['String']>;
  inputDeviceOptions?: InputMaybe<Array<Scalars['String']>>;
  isDualChannel: Scalars['Boolean'];
  language: Scalars['String'];
  liveAppVersion?: InputMaybe<Scalars['String']>;
  outputDevice?: InputMaybe<Scalars['String']>;
  outputDeviceOptions?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['ID'];
};

export type CreateTeamInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type CreateTopicInput = {
  color: Scalars['String'];
  text: Scalars['String'];
};

export type CreateViewInput = {
  name: Scalars['String'];
};

export type CustomTerminology = {
  __typename?: 'CustomTerminology';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CustomTerminologyInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DailySessionStatistics = {
  __typename?: 'DailySessionStatistics';
  date: Scalars['String'];
  metrics: SessionStatisticsMetric;
};

export type DatasetSummary = {
  __typename?: 'DatasetSummary';
  firstDataPoints: Array<Scalars['AWSJSON']>;
  numDataPoints: Scalars['Int'];
};

export type DateInput = {
  value: Scalars['AWSTimestamp'];
};

export type DecisionTree = {
  __typename?: 'DecisionTree';
  allowComments?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Long']>;
  hideLeafContent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  latestRun?: Maybe<DecisionTreeRun>;
  llmQuestion?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nodes: Array<DecisionTreeNode>;
  organisationId: Scalars['String'];
  projectCount: Scalars['Long'];
  projects: Array<DecisionTreeProject>;
  root: DecisionTreeNode;
  rootId: Scalars['ID'];
  sequenceOnly?: Maybe<Scalars['Boolean']>;
  sourceUrl?: Maybe<Scalars['String']>;
  subtrees?: Maybe<Array<DecisionTreeSubtree>>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  updatedByUser?: Maybe<User>;
};

export type DecisionTreeChildNode = {
  __typename?: 'DecisionTreeChildNode';
  filteredByState?: Maybe<Array<DecisionTreeVariableFilter>>;
  id: Scalars['ID'];
  nodeValue: Scalars['String'];
};

export type DecisionTreeChildNodeInput = {
  id: Scalars['ID'];
  nodeValue: Scalars['String'];
};

export type DecisionTreeConnection = {
  __typename?: 'DecisionTreeConnection';
  items: Array<DecisionTree>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DecisionTreeLeafNodeStatId = StatId & {
  __typename?: 'DecisionTreeLeafNodeStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  leafNode: DecisionTreeNode;
  leafNodeId: Scalars['ID'];
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type DecisionTreeLeafNodeStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type DecisionTreeLinkFromCardAssignment = AbstractAssignment & {
  __typename?: 'DecisionTreeLinkFromCardAssignment';
  assignee: DecisionTree;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Card;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type DecisionTreeLinkFromCardAssignmentConnection = {
  __typename?: 'DecisionTreeLinkFromCardAssignmentConnection';
  items: Array<DecisionTreeLinkFromCardAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DecisionTreeLinkFromDecisionTreeNodeAssignment = AbstractAssignment & {
  __typename?: 'DecisionTreeLinkFromDecisionTreeNodeAssignment';
  assignee: DecisionTree;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: DecisionTreeNode;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type DecisionTreeLinkFromDecisionTreeNodeAssignmentConnection = {
  __typename?: 'DecisionTreeLinkFromDecisionTreeNodeAssignmentConnection';
  items: Array<DecisionTreeLinkFromDecisionTreeNodeAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DecisionTreeMutation = {
  __typename?: 'DecisionTreeMutation';
  node: DecisionTreeNodeMutation;
  run: DecisionTreeRunMutations;
  sequence: DecisionTreeSequenceMutations;
  stateVariable: DecisionTreeStateMutations;
  tree: DecisionTreeTreeMutations;
};

export type DecisionTreeNode = {
  __typename?: 'DecisionTreeNode';
  cleanedAt?: Maybe<Scalars['Long']>;
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser?: Maybe<User>;
  decisionTree: DecisionTree;
  decisionTreeId: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  isLeaf?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newChildren?: Maybe<Array<DecisionTreeChildNode>>;
  organisationId: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  parentIds?: Maybe<Array<Scalars['ID']>>;
  richText?: Maybe<Scalars['String']>;
  setVariable?: Maybe<DecisionTreeVariable>;
  setVariableId?: Maybe<Scalars['ID']>;
  sourceUrl?: Maybe<Scalars['String']>;
  treeSequence?: Maybe<Array<DecisionTreeSequenceItem>>;
  type: DecisionTreeNodeType;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
  updatedByUser?: Maybe<User>;
};

export type DecisionTreeNodeConnection = {
  __typename?: 'DecisionTreeNodeConnection';
  items: Array<DecisionTreeNode>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DecisionTreeNodeMutation = {
  __typename?: 'DecisionTreeNodeMutation';
  addChild: DecisionTreeNode;
  desynchronize: DecisionTreeNode;
  duplicate: DecisionTreeNode;
  insert: DecisionTreeNode;
  markAsVariableSetter: DecisionTreeNode;
  putVariableFilter: DecisionTreeNode;
  removeChild: DecisionTreeNode;
  removeVariableFilter: DecisionTreeNode;
  reorderChildren: DecisionTreeNode;
  unmarkAsVariableSetter: DecisionTreeNode;
  update: DecisionTreeNode;
  updateChildValue: DecisionTreeNode;
  updateColor: DecisionTreeNode;
};


export type DecisionTreeNodeMutationAddChildArgs = {
  input: AddDecisionTreeNodeInput;
};


export type DecisionTreeNodeMutationDesynchronizeArgs = {
  input: DesynchronizeDecisionTreeNodeInput;
};


export type DecisionTreeNodeMutationDuplicateArgs = {
  input: DuplicateDecisionTreeNodeInput;
};


export type DecisionTreeNodeMutationInsertArgs = {
  input: InsertDecisionTreeNodeInput;
};


export type DecisionTreeNodeMutationMarkAsVariableSetterArgs = {
  input: NodeVariableInput;
};


export type DecisionTreeNodeMutationPutVariableFilterArgs = {
  input: AddVariableFilterInput;
};


export type DecisionTreeNodeMutationRemoveChildArgs = {
  input: RemoveDecisionTreeNodeChildInput;
};


export type DecisionTreeNodeMutationRemoveVariableFilterArgs = {
  input: RemoveVariableFilterInput;
};


export type DecisionTreeNodeMutationReorderChildrenArgs = {
  input: ReorderDecisionTreeNodeChildrenInput;
};


export type DecisionTreeNodeMutationUnmarkAsVariableSetterArgs = {
  input: NodeVariableInput;
};


export type DecisionTreeNodeMutationUpdateArgs = {
  input: UpdateDecisionTreeNodeInput;
};


export type DecisionTreeNodeMutationUpdateChildValueArgs = {
  input: UpdateDecisionTreeNodeChildValueInput;
};


export type DecisionTreeNodeMutationUpdateColorArgs = {
  input: UpdateDecisionTreeNodeColorInput;
};

export type DecisionTreeNodeQueries = {
  __typename?: 'DecisionTreeNodeQueries';
  get: DecisionTreeNode;
  /**
   * Every node of one tree, in no guaranteed order — walk `newChildren` from the tree's
   * `rootId` to reconstruct the shape. `DecisionTree.nodes` returns the same set for a tree
   * already in hand; this is the entry point when all you have is the tree's id.
   */
  list: DecisionTreeNodeConnection;
};


export type DecisionTreeNodeQueriesGetArgs = {
  input: IdInput;
};


export type DecisionTreeNodeQueriesListArgs = {
  input: ListDecisionTreeNodesInput;
};

export enum DecisionTreeNodeType {
  ActionClient = 'ActionClient',
  Information = 'Information',
  Question = 'Question'
}

export type DecisionTreeProject = {
  __typename?: 'DecisionTreeProject';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  decisionTreeId: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type DecisionTreeProjectInput = {
  decisionTreeId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type DecisionTreeQuery = {
  __typename?: 'DecisionTreeQuery';
  node: DecisionTreeNodeQueries;
  stateVariable: DecisionTreeStateQueries;
  tree: DecisionTreeTreeQueries;
};

export type DecisionTreeRun = {
  __typename?: 'DecisionTreeRun';
  children?: Maybe<Array<DecisionTreeRun>>;
  comments: Array<DecisionTreeRunComment>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  decisionTree?: Maybe<DecisionTree>;
  decisionTreeId: Scalars['ID'];
  finishedAt?: Maybe<Scalars['Long']>;
  history: Array<DecisionTreeRunHistoryItem>;
  id: Scalars['ID'];
  isPreviewRun?: Maybe<Scalars['Boolean']>;
  nodes: Array<DecisionTreeRunNode>;
  organisationId: Scalars['String'];
  parent?: Maybe<DecisionTreeRun>;
  parentId?: Maybe<Scalars['ID']>;
  projectId?: Maybe<Scalars['ID']>;
  sequence?: Maybe<Array<DecisionTreeRunSequenceItem>>;
  sessionId?: Maybe<Scalars['ID']>;
  state?: Maybe<Array<DecisionTreeVariableState>>;
  summary?: Maybe<Scalars['String']>;
  summaryFinishedAt?: Maybe<Scalars['Long']>;
  summaryModel?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};

export type DecisionTreeRunComment = {
  __typename?: 'DecisionTreeRunComment';
  nodeId: Scalars['ID'];
  userComment: Scalars['String'];
};

export type DecisionTreeRunHistoryItem = {
  __typename?: 'DecisionTreeRunHistoryItem';
  comment?: Maybe<Scalars['String']>;
  node: DecisionTreeNode;
  nodeId: Scalars['String'];
  sequenceValues?: Maybe<Array<Scalars['String']>>;
  value?: Maybe<Scalars['String']>;
};

export type DecisionTreeRunMutations = {
  __typename?: 'DecisionTreeRunMutations';
  start: DecisionTreeRun;
  stop: DecisionTreeRun;
  updateHistory: DecisionTreeRun;
  writeComment: DecisionTreeRun;
};


export type DecisionTreeRunMutationsStartArgs = {
  input: StartDecisionTreeRunInput;
};


export type DecisionTreeRunMutationsStopArgs = {
  input: IdInput;
};


export type DecisionTreeRunMutationsUpdateHistoryArgs = {
  input: UpdateDecisionTreeRunHistoryV2Input;
};


export type DecisionTreeRunMutationsWriteCommentArgs = {
  input: WriteDecisionTreeRunCommentInput;
};

export type DecisionTreeRunNode = {
  __typename?: 'DecisionTreeRunNode';
  id: Scalars['ID'];
  node: DecisionTreeNode;
};

export type DecisionTreeRunNodeHistoryItemInput = {
  nodeId: Scalars['String'];
  sequenceValues?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};

export type DecisionTreeRunSequenceItem = {
  __typename?: 'DecisionTreeRunSequenceItem';
  decisionTree: DecisionTree;
  decisionTreeId: Scalars['ID'];
  run?: Maybe<DecisionTreeRun>;
  runId?: Maybe<Scalars['ID']>;
};

export type DecisionTreeSequenceInclusionCondition = {
  __typename?: 'DecisionTreeSequenceInclusionCondition';
  id: Scalars['ID'];
  inclusionType: TreeSequenceItemInclusionType;
  values: Array<Scalars['String']>;
};

export type DecisionTreeSequenceInclusionConditionInput = {
  inclusionType: TreeSequenceItemInclusionType;
  values: Array<Scalars['String']>;
};

export type DecisionTreeSequenceItem = {
  __typename?: 'DecisionTreeSequenceItem';
  conditions?: Maybe<Array<DecisionTreeSequenceInclusionCondition>>;
  decisionTree: DecisionTree;
  decisionTreeId: Scalars['ID'];
};

export type DecisionTreeSequenceMutations = {
  __typename?: 'DecisionTreeSequenceMutations';
  add: DecisionTreeNode;
  addCondition: DecisionTreeNode;
  remove: DecisionTreeNode;
  removeCondition: DecisionTreeNode;
  reorder: DecisionTreeNode;
  updateCondition: DecisionTreeNode;
};


export type DecisionTreeSequenceMutationsAddArgs = {
  input: AddDecisionTreeToSequenceInput;
};


export type DecisionTreeSequenceMutationsAddConditionArgs = {
  input: AddDecisionTreeSequenceConditionInput;
};


export type DecisionTreeSequenceMutationsRemoveArgs = {
  input: RemoveDecisionTreeFromSequenceInput;
};


export type DecisionTreeSequenceMutationsRemoveConditionArgs = {
  input: RemoveDecisionTreeSequenceConditionInput;
};


export type DecisionTreeSequenceMutationsReorderArgs = {
  input: ReorderDecisionTreeSequenceInput;
};


export type DecisionTreeSequenceMutationsUpdateConditionArgs = {
  input: UpdateDecisionTreeSequenceConditionInput;
};

export type DecisionTreeStatId = StatId & {
  __typename?: 'DecisionTreeStatId';
  decisionTree: DecisionTree;
  decisionTreeId: Scalars['ID'];
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type DecisionTreeStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type DecisionTreeStateMutations = {
  __typename?: 'DecisionTreeStateMutations';
  create: DecisionTreeVariable;
  delete: DecisionTreeVariable;
  update: DecisionTreeVariable;
};


export type DecisionTreeStateMutationsCreateArgs = {
  input: CreateDecisionTreeVariableInput;
};


export type DecisionTreeStateMutationsDeleteArgs = {
  input: IdInput;
};


export type DecisionTreeStateMutationsUpdateArgs = {
  input: UpdateDecisionTreeVariableInput;
};

export type DecisionTreeStateQueries = {
  __typename?: 'DecisionTreeStateQueries';
  get: DecisionTreeVariable;
  list: DecisionTreeVariableConnection;
};


export type DecisionTreeStateQueriesGetArgs = {
  input: IdInput;
};


export type DecisionTreeStateQueriesListArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};

export type DecisionTreeSubtree = {
  __typename?: 'DecisionTreeSubtree';
  decisionTree: DecisionTree;
  id: Scalars['ID'];
};

export type DecisionTreeSubtreeInput = {
  decisionTreeId: Scalars['ID'];
  subtreeId: Scalars['ID'];
};

export type DecisionTreeTreeMutations = {
  __typename?: 'DecisionTreeTreeMutations';
  addSubtree: DecisionTree;
  assignToProject: DecisionTreeProject;
  create: DecisionTree;
  delete: DecisionTree;
  duplicate: DecisionTree;
  removeSubtree: DecisionTree;
  unassignToProject: DecisionTreeProject;
  update: DecisionTree;
  updateSummaryConfig: DecisionTree;
};


export type DecisionTreeTreeMutationsAddSubtreeArgs = {
  input: DecisionTreeSubtreeInput;
};


export type DecisionTreeTreeMutationsAssignToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type DecisionTreeTreeMutationsCreateArgs = {
  input: CreateDecisionTreeInput;
};


export type DecisionTreeTreeMutationsDeleteArgs = {
  input: IdInput;
};


export type DecisionTreeTreeMutationsDuplicateArgs = {
  input: DuplicateDecisionTreeInput;
};


export type DecisionTreeTreeMutationsRemoveSubtreeArgs = {
  input: DecisionTreeSubtreeInput;
};


export type DecisionTreeTreeMutationsUnassignToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type DecisionTreeTreeMutationsUpdateArgs = {
  input: UpdateDecisionTreeInput;
};


export type DecisionTreeTreeMutationsUpdateSummaryConfigArgs = {
  input: UpdateSummaryConfigInput;
};

export type DecisionTreeTreeQueries = {
  __typename?: 'DecisionTreeTreeQueries';
  get: DecisionTree;
  /**
   * The organisation's decision trees, ordered by name. `textSearch` matches the name
   * case-insensitively.
   *
   * `projectId` narrows to the trees assigned to that project, and answers all of them at
   * once: that set is read through the assignment table rather than the name index, it runs
   * to a handful of trees, and `limit`/`nextToken` are ignored with `nextToken` always null.
   */
  list: DecisionTreeConnection;
};


export type DecisionTreeTreeQueriesGetArgs = {
  input: IdInput;
};


export type DecisionTreeTreeQueriesListArgs = {
  input?: InputMaybe<ListDecisionTreesInput>;
};

export type DecisionTreeVariable = {
  __typename?: 'DecisionTreeVariable';
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameLowerCase: Scalars['String'];
  organisationId: Scalars['String'];
  updatedAt: Scalars['Long'];
  uses: Array<DecisionTreeNode>;
  values: Array<Scalars['String']>;
};

export type DecisionTreeVariableConnection = {
  __typename?: 'DecisionTreeVariableConnection';
  items: Array<DecisionTreeVariable>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DecisionTreeVariableFilter = {
  __typename?: 'DecisionTreeVariableFilter';
  conditions?: Maybe<Array<DecisionTreeSequenceInclusionCondition>>;
  variable: DecisionTreeVariable;
  variableId: Scalars['ID'];
};

export type DecisionTreeVariableState = {
  __typename?: 'DecisionTreeVariableState';
  nodeId: Scalars['ID'];
  runId: Scalars['ID'];
  value: Scalars['String'];
  variableId: Scalars['ID'];
};

export type DeleteCardInput = {
  id: Scalars['ID'];
};

export type DeleteCommandContextInput = {
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type DeleteCommandInput = {
  id: Scalars['ID'];
};

export type DeleteCommentInput = {
  id: Scalars['String'];
};

export type DeleteContentTagInput = {
  id: Scalars['ID'];
};

export type DeleteProjectTriggerInput = {
  cardId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteRecommenderColumnSpecInput = {
  columnName: Scalars['String'];
  recommenderId: Scalars['ID'];
};

export type DeleteRecommenderInput = {
  id: Scalars['ID'];
};

export type DeleteUserInput = {
  id: Scalars['ID'];
};

export type DesynchronizeDecisionTreeNodeInput = {
  nodeId: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type Detection = {
  __typename?: 'Detection';
  ASRText?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['ID']>;
  command?: Maybe<AsrCommand>;
  commandId: Scalars['String'];
  creationDate: Scalars['String'];
  date: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  intention?: Maybe<Intention>;
  isFromClient?: Maybe<Scalars['Boolean']>;
  model: Scalars['String'];
  projectId: Scalars['ID'];
  projectTrigger?: Maybe<ProjectVocalTrigger>;
  scope?: Maybe<CardScope>;
  session: Session;
  sessionId: Scalars['ID'];
  status?: Maybe<DetectionStatus>;
  transcriptOrigin?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type DetectionConnection = {
  __typename?: 'DetectionConnection';
  items: Array<Detection>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DetectionCount = {
  __typename?: 'DetectionCount';
  command?: Maybe<AsrCommand>;
  commandId: Scalars['ID'];
  count: Scalars['Int'];
  date: Scalars['String'];
  projectId: Scalars['ID'];
  projectUserCommandIndex: Scalars['String'];
  userId: Scalars['ID'];
};

export type DetectionCountConnection = {
  __typename?: 'DetectionCountConnection';
  items: Array<DetectionCount>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export type DetectionEvent = BaseSessionEventV2 & {
  __typename?: 'DetectionEvent';
  ASRText: Scalars['String'];
  command?: Maybe<Command>;
  commandId: Scalars['String'];
  date: Scalars['Long'];
  id: Scalars['ID'];
  isFromClient: Scalars['Boolean'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  trigger?: Maybe<TriggerDetection>;
  triggerId?: Maybe<Scalars['String']>;
};

export type DetectionFilterInput = {
  ASRText?: InputMaybe<TableStringFilterInput>;
  commandId?: InputMaybe<TableIdFilterInput>;
  status?: InputMaybe<TableDetectionStatusFilterInput>;
};

export type DetectionQueryInput = {
  date?: InputMaybe<TableIntFilterInput>;
  projectId: TableIdFilterInput;
};

export type DetectionStatisticsMetric = {
  __typename?: 'DetectionStatisticsMetric';
  detectionCount: Scalars['Int'];
};

export type DetectionStatisticsMetricTrend = {
  __typename?: 'DetectionStatisticsMetricTrend';
  current: DetectionStatisticsMetric;
  previous: DetectionStatisticsMetric;
};

export type DetectionStatisticsQueries = {
  __typename?: 'DetectionStatisticsQueries';
  byCommand: Array<CommandDetectionStatistics>;
  byUser: Array<UserDetectionStatistics>;
  totals: DetectionStatisticsMetricTrend;
};


export type DetectionStatisticsQueriesByCommandArgs = {
  input: DetectionStatisticsTrendInput;
};


export type DetectionStatisticsQueriesByUserArgs = {
  input: DetectionStatisticsTrendInput;
};


export type DetectionStatisticsQueriesTotalsArgs = {
  input: DetectionStatisticsTrendInput;
};

export type DetectionStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export enum DetectionStatus {
  Bad = 'BAD',
  Good = 'GOOD',
  Noise = 'NOISE'
}

export type DisableIntegrationInput = {
  type: IntegrationType;
};

export type DiscoverAdvancedAnalysisItemMulticlassOptionInput = {
  id: Scalars['ID'];
};

export type Display = {
  __typename?: 'Display';
  card: Card;
  cardId: Scalars['ID'];
  date: Scalars['AWSTimestamp'];
  detection?: Maybe<Detection>;
  detectionId?: Maybe<Scalars['ID']>;
  displayType: DisplayType;
  feedback?: Maybe<Feedback>;
  id: Scalars['ID'];
  isVisible?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  sessionId?: Maybe<Scalars['ID']>;
  tabId?: Maybe<Scalars['ID']>;
  user: Scalars['ID'];
};

export type DisplayOriginRepartition = {
  __typename?: 'DisplayOriginRepartition';
  CardLink?: Maybe<Scalars['Int']>;
  ClientDisplay?: Maybe<Scalars['Int']>;
  Detection?: Maybe<Scalars['Int']>;
  Favorite?: Maybe<Scalars['Int']>;
  History?: Maybe<Scalars['Int']>;
  InitialDisplay?: Maybe<Scalars['Int']>;
  Search?: Maybe<Scalars['Int']>;
  SessionEndDisplay?: Maybe<Scalars['Int']>;
  SessionStartDisplay?: Maybe<Scalars['Int']>;
};

export type DisplayStatisticsMetric = {
  __typename?: 'DisplayStatisticsMetric';
  displayCount: Scalars['Int'];
  displayOriginRepartition: DisplayOriginRepartition;
};

export type DisplayStatisticsMetricTrend = {
  __typename?: 'DisplayStatisticsMetricTrend';
  current: DisplayStatisticsMetric;
  previous: DisplayStatisticsMetric;
};

export type DisplayStatisticsQueries = {
  __typename?: 'DisplayStatisticsQueries';
  byCard: Array<CardDisplayStatistics>;
  byUser: Array<UserDisplayStatistics>;
  totals: DisplayStatisticsMetricTrend;
};


export type DisplayStatisticsQueriesByCardArgs = {
  input: DisplayStatisticsTrendInput;
};


export type DisplayStatisticsQueriesByUserArgs = {
  input: DisplayStatisticsTrendInput;
};


export type DisplayStatisticsQueriesTotalsArgs = {
  input: DisplayStatisticsTrendInput;
};

export type DisplayStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export enum DisplayType {
  CardLink = 'CardLink',
  ClientDisplay = 'ClientDisplay',
  Detection = 'Detection',
  Favorite = 'Favorite',
  History = 'History',
  InitialDisplay = 'InitialDisplay',
  Search = 'Search',
  SessionEndDisplay = 'SessionEndDisplay',
  SessionStartDisplay = 'SessionStartDisplay'
}

export type DissociateCommandInput = {
  cardId?: InputMaybe<Scalars['ID']>;
  commandId: Scalars['ID'];
  projectId: Scalars['ID'];
};

/**
 * A presigned S3 GET link for one uploaded document, with the moment it stops working.
 * `UploadedDocuments.url` is not an alternative: it is a plain media-server URL whose
 * Lambda@Edge authorizer reads a Cognito idToken cookie only, so no header-authenticated
 * client can fetch it.
 */
export type DocumentDownloadUrl = {
  __typename?: 'DocumentDownloadUrl';
  expiresAt: Scalars['Long'];
  url: Scalars['String'];
};

export type DocumentLinkFromCardAssignment = AbstractAssignment & {
  __typename?: 'DocumentLinkFromCardAssignment';
  assignee: UploadedDocuments;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Card;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type DocumentLinkFromCardAssignmentConnection = {
  __typename?: 'DocumentLinkFromCardAssignmentConnection';
  items: Array<DocumentLinkFromCardAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DocumentLinkFromDecisionTreeNodeAssignment = AbstractAssignment & {
  __typename?: 'DocumentLinkFromDecisionTreeNodeAssignment';
  assignee: UploadedDocuments;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: DecisionTreeNode;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type DocumentLinkFromDecisionTreeNodeAssignmentConnection = {
  __typename?: 'DocumentLinkFromDecisionTreeNodeAssignmentConnection';
  items: Array<DocumentLinkFromDecisionTreeNodeAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DocumentQueries = {
  __typename?: 'DocumentQueries';
  getDownloadUrl: DocumentDownloadUrl;
};


export type DocumentQueriesGetDownloadUrlArgs = {
  input: IdInput;
};

export type DryRunAdvancedAnalysisItemInput = {
  advancedAnalysisItemId: Scalars['ID'];
  sessionId: Scalars['ID'];
  wording: Scalars['String'];
};

/** new card update inputs */
export type DuplicateCardInput = {
  id: Scalars['ID'];
  projectId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DuplicateDecisionTreeInput = {
  decisionTreeId: Scalars['ID'];
  projectId?: InputMaybe<Scalars['ID']>;
};

export type DuplicateDecisionTreeNodeInput = {
  dissociate?: InputMaybe<Scalars['Boolean']>;
  nodeId: Scalars['ID'];
  parentId: Scalars['ID'];
  parentValue: Scalars['String'];
};

export type DuplicateProjectInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type DuplicateProjectTriggerInput = {
  id: Scalars['ID'];
  newProjectId?: InputMaybe<Scalars['String']>;
};

export type DurationPhrasingSubjectCondition = BasePhrasingSubjectCondition & {
  __typename?: 'DurationPhrasingSubjectCondition';
  callSurvivalSuccessThreshold: Scalars['Int'];
  minCallDuration?: Maybe<Scalars['Int']>;
};

export type DurationPhrasingSubjectConditionInput = {
  callSurvivalSuccessThreshold: Scalars['Int'];
  minCallDuration?: InputMaybe<Scalars['Int']>;
};

export type DurationThresholdReachedEvent = BaseSessionEventV2 & {
  __typename?: 'DurationThresholdReachedEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  minDuration: Scalars['Float'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type EnableIntegrationInput = {
  type: IntegrationType;
};

export type EvaluationSheet = {
  __typename?: 'EvaluationSheet';
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemEvaluationSheetAssignmentConnection;
  assignedFactCheckModules: FactCheckModuleEvaluationSheetAssignmentConnection;
  assignedOperationItems: ComplianceOperationItemEvaluationSheetAssignmentConnection;
  assignedTopics: TopicEvaluationSheetAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projectAssignments: EvaluationSheetProjectAssignmentConnection;
  scoreThresholds?: Maybe<EvaluationSheetScoreThresholds>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export enum EvaluationSheetCriticityLevel {
  Critical = 'Critical',
  Major = 'Major',
  Minor = 'Minor'
}

export type EvaluationSheetGrainCountBySheet = {
  __typename?: 'EvaluationSheetGrainCountBySheet';
  evaluationSheetId: Scalars['ID'];
  grainCount: Scalars['Int'];
  users: Array<EvaluationSheetUserGrainCount>;
};

export type EvaluationSheetGrainCountGroupInput = {
  assigneeIds: Array<Scalars['ID']>;
  evaluationSheetId: Scalars['ID'];
  key: Scalars['String'];
};

export type EvaluationSheetGrainCounts = {
  __typename?: 'EvaluationSheetGrainCounts';
  evaluationSheets: Array<EvaluationSheetGrainCountBySheet>;
  total: Scalars['Int'];
  users: Array<EvaluationSheetUserGrainCount>;
};

export type EvaluationSheetGrainGroupCount = {
  __typename?: 'EvaluationSheetGrainGroupCount';
  grainCount: Scalars['Int'];
  key: Scalars['String'];
};

export type EvaluationSheetGroupGrainCountInput = {
  endDate: Scalars['Long'];
  granularity: EvaluationSheetStatGranularity;
  groups: Array<EvaluationSheetGrainCountGroupInput>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type EvaluationSheetItemStat = {
  __typename?: 'EvaluationSheetItemStat';
  advancedAnalysisItem?: Maybe<AdvancedAnalysisItem>;
  advancedAnalysisItemId?: Maybe<Scalars['String']>;
  children?: Maybe<Scalars['AWSJSON']>;
  complianceOperationId?: Maybe<Scalars['String']>;
  complianceOperationItem?: Maybe<ComplianceOperationItem>;
  criticityLevel: EvaluationSheetCriticityLevel;
  denom: Scalars['Float'];
  evaluationSheetId: Scalars['ID'];
  factCheckDetails?: Maybe<Array<FactCheckAttributeStat>>;
  factCheckModule?: Maybe<FactCheckModule>;
  factCheckModuleId?: Maybe<Scalars['String']>;
  factCheckProducts?: Maybe<Array<FactCheckProductStat>>;
  grainCount?: Maybe<Scalars['Int']>;
  num: Scalars['Float'];
  score?: Maybe<Scalars['Float']>;
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  weight: Scalars['Float'];
};

export type EvaluationSheetMutations = {
  __typename?: 'EvaluationSheetMutations';
  create: EvaluationSheet;
  delete: EvaluationSheet;
  update: EvaluationSheet;
};


export type EvaluationSheetMutationsCreateArgs = {
  input: CreateEvaluationSheetInput;
};


export type EvaluationSheetMutationsDeleteArgs = {
  input: IdInput;
};


export type EvaluationSheetMutationsUpdateArgs = {
  input: UpdateEvaluationSheetInput;
};

export type EvaluationSheetProjectAssignment = AbstractAssignment & {
  __typename?: 'EvaluationSheetProjectAssignment';
  assignee: EvaluationSheet;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type EvaluationSheetProjectAssignmentConnection = {
  __typename?: 'EvaluationSheetProjectAssignmentConnection';
  items: Array<EvaluationSheetProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type EvaluationSheetQueries = {
  __typename?: 'EvaluationSheetQueries';
  get: EvaluationSheet;
  list: Array<EvaluationSheet>;
};


export type EvaluationSheetQueriesGetArgs = {
  input: IdInput;
};

export type EvaluationSheetResult = {
  __typename?: 'EvaluationSheetResult';
  denom?: Maybe<Scalars['Float']>;
  evaluationSheet: EvaluationSheet;
  id: Scalars['ID'];
  items: Array<EvaluationSheetResultItem>;
  num?: Maybe<Scalars['Float']>;
  scoreTotal?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetResultAdvancedAnalysisItem = AbstractEvaluationSheetResultItem & {
  __typename?: 'EvaluationSheetResultAdvancedAnalysisItem';
  advancedAnalysisItem: AdvancedAnalysisItem;
  complianceModule?: Maybe<ComplianceModule>;
  criticity: EvaluationSheetCriticityLevel;
  denom?: Maybe<Scalars['Float']>;
  explanation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  num?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  unweightedCount?: Maybe<Scalars['Int']>;
  verbatim?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetResultComplianceOperationItem = AbstractEvaluationSheetResultItem & {
  __typename?: 'EvaluationSheetResultComplianceOperationItem';
  complianceModule?: Maybe<ComplianceModule>;
  complianceOperationItem: ComplianceOperationItem;
  criticity: EvaluationSheetCriticityLevel;
  denom?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  num?: Maybe<Scalars['Float']>;
  root: EvaluationSheetResultComplianceOperationItemRoot;
  score?: Maybe<Scalars['Float']>;
  unweightedCount?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetResultComplianceOperationItemRoot = {
  __typename?: 'EvaluationSheetResultComplianceOperationItemRoot';
  children: Scalars['AWSJSON'];
  score?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetResultFactCheckModuleItem = AbstractEvaluationSheetResultItem & {
  __typename?: 'EvaluationSheetResultFactCheckModuleItem';
  complianceModule?: Maybe<ComplianceModule>;
  criticity: EvaluationSheetCriticityLevel;
  denom?: Maybe<Scalars['Float']>;
  factCheckModule: FactCheckModule;
  id: Scalars['ID'];
  num?: Maybe<Scalars['Float']>;
  run?: Maybe<FactCheckModuleRun>;
  score?: Maybe<Scalars['Float']>;
  unweightedCount?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetResultInput = {
  onlySession?: InputMaybe<Scalars['Boolean']>;
};

export type EvaluationSheetResultItem = EvaluationSheetResultAdvancedAnalysisItem | EvaluationSheetResultComplianceOperationItem | EvaluationSheetResultFactCheckModuleItem | EvaluationSheetResultTopicItem;

export type EvaluationSheetResultTopicItem = AbstractEvaluationSheetResultItem & {
  __typename?: 'EvaluationSheetResultTopicItem';
  complianceModule?: Maybe<ComplianceModule>;
  criticity: EvaluationSheetCriticityLevel;
  denom?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  num?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  topic: Topic;
  unweightedCount?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

export type EvaluationSheetScoreThresholds = {
  __typename?: 'EvaluationSheetScoreThresholds';
  lowerBound: Scalars['Float'];
  upperBound: Scalars['Float'];
};

export type EvaluationSheetScoreThresholdsInput = {
  lowerBound: Scalars['Float'];
  upperBound: Scalars['Float'];
};

export type EvaluationSheetStat = {
  __typename?: 'EvaluationSheetStat';
  denom: Scalars['Float'];
  evaluationSheet: EvaluationSheet;
  evaluationSheetId: Scalars['ID'];
  items: Array<EvaluationSheetItemStat>;
  num: Scalars['Float'];
  score?: Maybe<Scalars['Float']>;
};

export enum EvaluationSheetStatGranularity {
  CallGroup = 'CallGroup',
  Session = 'Session'
}

export enum EvaluationSheetStatGroupBy {
  Item = 'Item',
  User = 'User'
}

export type EvaluationSheetStatId = StatId & {
  __typename?: 'EvaluationSheetStatId';
  endDate: Scalars['Long'];
  evaluationSheet: EvaluationSheet;
  evaluationSheetId: Scalars['ID'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type EvaluationSheetStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type EvaluationSheetStatInput = {
  endDate: Scalars['Long'];
  evaluationSheetIds?: InputMaybe<Array<Scalars['ID']>>;
  granularity: EvaluationSheetStatGranularity;
  groupBy: EvaluationSheetStatGroupBy;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type EvaluationSheetStatQueries = {
  __typename?: 'EvaluationSheetStatQueries';
  grainCounts?: Maybe<EvaluationSheetGrainCounts>;
  groupGrainCounts?: Maybe<Array<EvaluationSheetGrainGroupCount>>;
  listEvaluationSheetStats: Array<EvaluationSheetStat>;
};


export type EvaluationSheetStatQueriesGrainCountsArgs = {
  input: EvaluationSheetStatInput;
};


export type EvaluationSheetStatQueriesGroupGrainCountsArgs = {
  input: EvaluationSheetGroupGrainCountInput;
};


export type EvaluationSheetStatQueriesListEvaluationSheetStatsArgs = {
  input: EvaluationSheetStatInput;
};

export type EvaluationSheetUserGrainCount = {
  __typename?: 'EvaluationSheetUserGrainCount';
  grainCount: Scalars['Int'];
  userId: Scalars['ID'];
};

export type ExcelCardImporter = {
  __typename?: 'ExcelCardImporter';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projects: Array<ExcelCardImporterProject>;
  status: ExcelCardImporterStatus;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['ID']>;
};

export type ExcelCardImporterProject = {
  __typename?: 'ExcelCardImporterProject';
  id: Scalars['ID'];
  project: Project;
};

export enum ExcelCardImporterStatus {
  Failed = 'Failed',
  Init = 'Init',
  Processing = 'Processing',
  Success = 'Success'
}

export type ExcelExportInput = {
  endDate: Scalars['AWSTimestamp'];
  language: Scalars['String'];
  startDate: Scalars['AWSTimestamp'];
};

export enum ExcelStatType {
  Compliance = 'Compliance'
}

export type ExternalCall = {
  __typename?: 'ExternalCall';
  clientCard?: Maybe<Card>;
  cogneedCallGroupId?: Maybe<Scalars['String']>;
  cogneedDate?: Maybe<Scalars['Long']>;
  cogneedExternalClientId?: Maybe<Scalars['String']>;
  cogneedHangUpDate?: Maybe<Scalars['Long']>;
  cogneedId: Scalars['String'];
  cogneedOrganisationId?: Maybe<Scalars['String']>;
  cogneedPartner: Scalars['String'];
  cogneedPartnerCallId?: Maybe<Scalars['String']>;
  cogneedPartnerProjectId?: Maybe<Scalars['String']>;
  cogneedPartnerUserId?: Maybe<Scalars['String']>;
  cogneedProjectId?: Maybe<Scalars['String']>;
  cogneedStatusIndex?: Maybe<Scalars['String']>;
  cogneedStatusText?: Maybe<Scalars['String']>;
  cogneedUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ExternalCallStatisticsInput = {
  period: StatisticsPeriodInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type ExternalCallStatisticsMetric = {
  __typename?: 'ExternalCallStatisticsMetric';
  externalCallCoveredDuration: Scalars['Long'];
  externalCallDuration: Scalars['Long'];
  externalCalls: Scalars['Long'];
  externalCallsCovered: Scalars['Long'];
};

export type ExternalCallStatisticsMetricTrend = {
  __typename?: 'ExternalCallStatisticsMetricTrend';
  current: ExternalCallStatisticsMetric;
  previous: ExternalCallStatisticsMetric;
};

export type ExternalCallStatisticsQueries = {
  __typename?: 'ExternalCallStatisticsQueries';
  byUser: Array<UserExternalCallStatistics>;
  totals: ExternalCallStatisticsMetricTrend;
};


export type ExternalCallStatisticsQueriesByUserArgs = {
  input: ExternalCallStatisticsTrendInput;
};


export type ExternalCallStatisticsQueriesTotalsArgs = {
  input: ExternalCallStatisticsTrendInput;
};

export type ExternalCallStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  cogneedAutoMatched?: Maybe<Scalars['Boolean']>;
  cogneedCount?: Maybe<Scalars['Int']>;
  cogneedId?: Maybe<Scalars['String']>;
  cogneedLastSeenAt?: Maybe<Scalars['Long']>;
  cogneedName?: Maybe<Scalars['String']>;
  cogneedOrganisationId?: Maybe<Scalars['String']>;
  cogneedPartner: Scalars['String'];
  cogneedPartnerId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  isInCall?: Maybe<Scalars['Boolean']>;
};

export type ExternalUserMutations = {
  __typename?: 'ExternalUserMutations';
  remove: ExternalUser;
  update: ExternalUser;
};


export type ExternalUserMutationsRemoveArgs = {
  input: RemoveExternalUserInput;
};


export type ExternalUserMutationsUpdateArgs = {
  input: UpdateExternalUserInput;
};

export type ExternalUserQueries = {
  __typename?: 'ExternalUserQueries';
  list: Array<ExternalUser>;
};

export type FactCheckAttribute = {
  __typename?: 'FactCheckAttribute';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  moduleAssignments: FactCheckAttributeFactCheckModuleAssignmentConnection;
  organisationId: Scalars['ID'];
  productSpecs: FactCheckModuleProductSpecConnection;
  results: FactCheckResultConnection;
  themeAssignments: FactCheckAttributeFactCheckThemeAssignmentConnection;
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckAttributeFactCheckModuleAssignment = AbstractAssignment & {
  __typename?: 'FactCheckAttributeFactCheckModuleAssignment';
  assignee: FactCheckAttribute;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: FactCheckModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckAttributeFactCheckModuleAssignmentConnection = {
  __typename?: 'FactCheckAttributeFactCheckModuleAssignmentConnection';
  items: Array<FactCheckAttributeFactCheckModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckAttributeFactCheckThemeAssignment = AbstractAssignment & {
  __typename?: 'FactCheckAttributeFactCheckThemeAssignment';
  assignee: FactCheckAttribute;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: FactCheckTheme;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckAttributeFactCheckThemeAssignmentConnection = {
  __typename?: 'FactCheckAttributeFactCheckThemeAssignmentConnection';
  items: Array<FactCheckAttributeFactCheckThemeAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckAttributeMutations = {
  __typename?: 'FactCheckAttributeMutations';
  delete: FactCheckAttribute;
  update: FactCheckAttribute;
};


export type FactCheckAttributeMutationsDeleteArgs = {
  input: IdInput;
};


export type FactCheckAttributeMutationsUpdateArgs = {
  input: UpdateFactCheckAttributeInput;
};

export type FactCheckAttributeStat = {
  __typename?: 'FactCheckAttributeStat';
  attribute?: Maybe<FactCheckAttribute>;
  attributeId: Scalars['ID'];
  denom: Scalars['Float'];
  notMentioned: Scalars['Int'];
  num: Scalars['Float'];
  score?: Maybe<Scalars['Float']>;
};

export enum FactCheckAttributionMode {
  Lenient = 'Lenient',
  Strict = 'Strict'
}

export type FactCheckFilterInput = {
  filters?: InputMaybe<Array<FactCheckModuleFilterInput>>;
};

export type FactCheckModule = {
  __typename?: 'FactCheckModule';
  assignedAttributes: FactCheckAttributeFactCheckModuleAssignmentConnection;
  assignedProducts: FactCheckProductFactCheckModuleAssignmentConnection;
  assignedThemes: FactCheckThemeFactCheckModuleAssignmentConnection;
  attributionGuidance?: Maybe<Scalars['String']>;
  attributionMode?: Maybe<FactCheckAttributionMode>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  projectAssignments: FactCheckModuleProjectAssignmentConnection;
  runs: FactCheckModuleRunConnection;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckModuleComplianceModuleAssignment = AbstractAssignment & {
  __typename?: 'FactCheckModuleComplianceModuleAssignment';
  assignee: FactCheckModule;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckModuleComplianceModuleAssignmentConnection = {
  __typename?: 'FactCheckModuleComplianceModuleAssignmentConnection';
  items: Array<FactCheckModuleComplianceModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckModuleEvaluationSheetAssignment = AbstractAssignment & {
  __typename?: 'FactCheckModuleEvaluationSheetAssignment';
  assignee: FactCheckModule;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  criticityLevel: EvaluationSheetCriticityLevel;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: EvaluationSheet;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  weight: Scalars['Float'];
};

export type FactCheckModuleEvaluationSheetAssignmentConnection = {
  __typename?: 'FactCheckModuleEvaluationSheetAssignmentConnection';
  items: Array<FactCheckModuleEvaluationSheetAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckModuleFilterInput = {
  moduleId: Scalars['ID'];
};

export type FactCheckModuleMutations = {
  __typename?: 'FactCheckModuleMutations';
  applyThemes: FactCheckModule;
  create: FactCheckModule;
  delete: FactCheckModule;
  exportSessionTranscript: SessionFactCheckTranscriptExport;
  previewThemes: FactCheckThemeProposal;
  submitSessionRun: FactCheckModuleRun;
  update: FactCheckModule;
};


export type FactCheckModuleMutationsApplyThemesArgs = {
  input: ApplyFactCheckThemesInput;
};


export type FactCheckModuleMutationsCreateArgs = {
  input: CreateFactCheckModuleInput;
};


export type FactCheckModuleMutationsDeleteArgs = {
  input: IdInput;
};


export type FactCheckModuleMutationsExportSessionTranscriptArgs = {
  input: SessionFactCheckPlanInput;
};


export type FactCheckModuleMutationsPreviewThemesArgs = {
  input: PreviewFactCheckThemesInput;
};


export type FactCheckModuleMutationsSubmitSessionRunArgs = {
  input: SubmitSessionFactCheckRunInput;
};


export type FactCheckModuleMutationsUpdateArgs = {
  input: UpdateFactCheckModuleInput;
};

export type FactCheckModuleProductSpec = AbstractAssignment & {
  __typename?: 'FactCheckModuleProductSpec';
  assignee: FactCheckAttribute;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  embeddingTokenCount?: Maybe<Scalars['Int']>;
  evidence: Scalars['String'];
  group: FactCheckProduct;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  kind?: Maybe<FactCheckSpecKind>;
  operand?: Maybe<FactCheckOperand>;
  organisationId: Scalars['ID'];
  phrasings?: Maybe<Array<Scalars['String']>>;
  sourceNote?: Maybe<Scalars['String']>;
  statement: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  value?: Maybe<Scalars['String']>;
  valueKind?: Maybe<FactCheckValueKind>;
  values?: Maybe<Array<Scalars['String']>>;
};

export type FactCheckModuleProductSpecConnection = {
  __typename?: 'FactCheckModuleProductSpecConnection';
  items: Array<FactCheckModuleProductSpec>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckModuleProjectAssignment = AbstractAssignment & {
  __typename?: 'FactCheckModuleProjectAssignment';
  assignee: FactCheckModule;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy: Scalars['ID'];
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckModuleProjectAssignmentConnection = {
  __typename?: 'FactCheckModuleProjectAssignmentConnection';
  items: Array<FactCheckModuleProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckModuleQueries = {
  __typename?: 'FactCheckModuleQueries';
  get: FactCheckModule;
  list: Array<FactCheckModule>;
  sessionPlan: SessionFactCheckPlan;
  sessionQueue: FactCheckSessionQueue;
};


export type FactCheckModuleQueriesGetArgs = {
  input: IdInput;
};


export type FactCheckModuleQueriesSessionPlanArgs = {
  input: SessionFactCheckPlanInput;
};


export type FactCheckModuleQueriesSessionQueueArgs = {
  input: FactCheckSessionQueueInput;
};

export type FactCheckModuleRun = AbstractAssignment & {
  __typename?: 'FactCheckModuleRun';
  assignee: FactCheckModule;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Session;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inputTokenCount?: Maybe<Scalars['Long']>;
  organisationId: Scalars['ID'];
  origin?: Maybe<FactCheckRunOrigin>;
  outputTokenCount?: Maybe<Scalars['Long']>;
  product?: Maybe<FactCheckProduct>;
  productId?: Maybe<Scalars['ID']>;
  results: FactCheckResultConnection;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckModuleRunAdvancedAnalysisJobAssignment = AbstractAssignment & {
  __typename?: 'FactCheckModuleRunAdvancedAnalysisJobAssignment';
  assignee: FactCheckModuleRun;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckModuleRunAdvancedAnalysisJobAssignmentConnection = {
  __typename?: 'FactCheckModuleRunAdvancedAnalysisJobAssignmentConnection';
  items: Array<FactCheckModuleRunAdvancedAnalysisJobAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckModuleRunConnection = {
  __typename?: 'FactCheckModuleRunConnection';
  items: Array<FactCheckModuleRun>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckMutations = {
  __typename?: 'FactCheckMutations';
  attribute: FactCheckAttributeMutations;
  module: FactCheckModuleMutations;
  product: FactCheckProductMutations;
  theme: FactCheckThemeMutations;
};

export enum FactCheckOperand {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

export type FactCheckOrgSettings = OrgFeatureSettings & {
  __typename?: 'FactCheckOrgSettings';
  enabled: Scalars['Boolean'];
  showInnerWorkings?: Maybe<StandardOrgSetting>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type FactCheckPhrasingProposal = {
  __typename?: 'FactCheckPhrasingProposal';
  attributeId: Scalars['ID'];
  attributeLabel: Scalars['String'];
  phrasings: Array<Scalars['String']>;
};

export type FactCheckProduct = {
  __typename?: 'FactCheckProduct';
  assignedCallStatuses: CallStatusFactCheckProductAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  freeText?: Maybe<Scalars['String']>;
  generationError?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  moduleAssignments: FactCheckProductFactCheckModuleAssignmentConnection;
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  specs: FactCheckModuleProductSpecConnection;
  status: FactCheckProductStatus;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckProductFactCheckModuleAssignment = AbstractAssignment & {
  __typename?: 'FactCheckProductFactCheckModuleAssignment';
  assignee: FactCheckProduct;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: FactCheckModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckProductFactCheckModuleAssignmentConnection = {
  __typename?: 'FactCheckProductFactCheckModuleAssignmentConnection';
  items: Array<FactCheckProductFactCheckModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckProductMutations = {
  __typename?: 'FactCheckProductMutations';
  create: FactCheckProduct;
  delete: FactCheckProduct;
  previewPhrasings: Array<FactCheckPhrasingProposal>;
  publish: FactCheckProduct;
  setSpecs: FactCheckProduct;
  unpublish: FactCheckProduct;
  update: FactCheckProduct;
};


export type FactCheckProductMutationsCreateArgs = {
  input: CreateFactCheckProductInput;
};


export type FactCheckProductMutationsDeleteArgs = {
  input: IdInput;
};


export type FactCheckProductMutationsPreviewPhrasingsArgs = {
  input: PreviewFactCheckPhrasingsInput;
};


export type FactCheckProductMutationsPublishArgs = {
  input: IdInput;
};


export type FactCheckProductMutationsSetSpecsArgs = {
  input: SetFactCheckProductSpecsInput;
};


export type FactCheckProductMutationsUnpublishArgs = {
  input: IdInput;
};


export type FactCheckProductMutationsUpdateArgs = {
  input: UpdateFactCheckProductInput;
};

export type FactCheckProductQueries = {
  __typename?: 'FactCheckProductQueries';
  get: FactCheckProduct;
};


export type FactCheckProductQueriesGetArgs = {
  input: IdInput;
};

export type FactCheckProductStat = {
  __typename?: 'FactCheckProductStat';
  attributes: Array<FactCheckAttributeStat>;
  denom: Scalars['Float'];
  grainCount: Scalars['Int'];
  notMentioned: Scalars['Int'];
  num: Scalars['Float'];
  product?: Maybe<FactCheckProduct>;
  productId?: Maybe<Scalars['ID']>;
  score?: Maybe<Scalars['Float']>;
};

export enum FactCheckProductStatus {
  Draft = 'Draft',
  Failed = 'Failed',
  Generating = 'Generating',
  Ready = 'Ready'
}

export type FactCheckQueries = {
  __typename?: 'FactCheckQueries';
  module: FactCheckModuleQueries;
  product: FactCheckProductQueries;
  theme: FactCheckThemeQueries;
};

export type FactCheckResult = AbstractAssignment & {
  __typename?: 'FactCheckResult';
  agentClaim?: Maybe<Scalars['String']>;
  assignee: FactCheckAttribute;
  assigneeId: Scalars['ID'];
  citedValues?: Maybe<Array<Scalars['String']>>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  explanation?: Maybe<Scalars['String']>;
  groundTruthNote?: Maybe<Scalars['String']>;
  groundTruthStatus?: Maybe<FactCheckResultStatus>;
  groundTruthVerbatims?: Maybe<Array<FactCheckResultVerbatim>>;
  group: FactCheckModuleRun;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  offListClaims?: Maybe<Array<Scalars['String']>>;
  organisationId: Scalars['ID'];
  status: FactCheckResultStatus;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  verbatim?: Maybe<Scalars['String']>;
  verbatims?: Maybe<Array<FactCheckResultVerbatim>>;
};

export type FactCheckResultConnection = {
  __typename?: 'FactCheckResultConnection';
  items: Array<FactCheckResult>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum FactCheckResultStatus {
  Correct = 'Correct',
  Incorrect = 'Incorrect',
  NotMentioned = 'NotMentioned'
}

export type FactCheckResultVerbatim = {
  __typename?: 'FactCheckResultVerbatim';
  sessionId: Scalars['ID'];
  text: Scalars['String'];
  timestamp: Scalars['Long'];
};

export enum FactCheckRunOrigin {
  External = 'External',
  Pipeline = 'Pipeline'
}

export type FactCheckSessionQueue = {
  __typename?: 'FactCheckSessionQueue';
  callGroupCount: Scalars['Int'];
  eligibleSessionCount: Scalars['Int'];
  filters: FactCheckSessionQueueFilters;
  moduleId: Scalars['ID'];
  queue: Array<FactCheckSessionQueueEntry>;
  truncated: Scalars['Boolean'];
};

export type FactCheckSessionQueueEntry = {
  __typename?: 'FactCheckSessionQueueEntry';
  alreadyGraded: Scalars['Boolean'];
  date: Scalars['Long'];
  groupSessionIds: Array<Scalars['ID']>;
  productId: Scalars['ID'];
  productName: Scalars['String'];
  sessionId: Scalars['ID'];
};

export type FactCheckSessionQueueFilters = {
  __typename?: 'FactCheckSessionQueueFilters';
  callStatusIds: Array<Scalars['String']>;
  minCharacters: Scalars['Int'];
  minDurationMs: Scalars['Int'];
  minSentences: Scalars['Int'];
  projectIds: Array<Scalars['ID']>;
};

export type FactCheckSessionQueueInput = {
  from: Scalars['Long'];
  includeAlreadyGraded?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  moduleId: Scalars['ID'];
  to: Scalars['Long'];
};

export type FactCheckSpecInput = {
  attributeId?: InputMaybe<Scalars['ID']>;
  attributeLabel?: InputMaybe<Scalars['String']>;
  evidence: Scalars['String'];
  kind?: InputMaybe<FactCheckSpecKind>;
  operand?: InputMaybe<FactCheckOperand>;
  sourceNote?: InputMaybe<Scalars['String']>;
  statement: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  valueKind?: InputMaybe<FactCheckValueKind>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export enum FactCheckSpecKind {
  Condition = 'CONDITION',
  Enumeration = 'ENUMERATION',
  Inclusion = 'INCLUSION',
  Quantity = 'QUANTITY'
}

export type FactCheckTheme = {
  __typename?: 'FactCheckTheme';
  assignedAttributes: FactCheckAttributeFactCheckThemeAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  hint: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  moduleAssignments: FactCheckThemeFactCheckModuleAssignmentConnection;
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckThemeConnection = {
  __typename?: 'FactCheckThemeConnection';
  items: Array<FactCheckTheme>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckThemeFactCheckModuleAssignment = AbstractAssignment & {
  __typename?: 'FactCheckThemeFactCheckModuleAssignment';
  assignee: FactCheckTheme;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: FactCheckModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type FactCheckThemeFactCheckModuleAssignmentConnection = {
  __typename?: 'FactCheckThemeFactCheckModuleAssignmentConnection';
  items: Array<FactCheckThemeFactCheckModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FactCheckThemeMutations = {
  __typename?: 'FactCheckThemeMutations';
  create: FactCheckTheme;
  delete: FactCheckTheme;
  update: FactCheckTheme;
};


export type FactCheckThemeMutationsCreateArgs = {
  input: CreateFactCheckThemeInput;
};


export type FactCheckThemeMutationsDeleteArgs = {
  input: IdInput;
};


export type FactCheckThemeMutationsUpdateArgs = {
  input: UpdateFactCheckThemeInput;
};

export type FactCheckThemeProposal = {
  __typename?: 'FactCheckThemeProposal';
  proposed: Array<ProposedFactCheckTheme>;
  wouldDelete: Array<FactCheckThemeSummary>;
};

export type FactCheckThemeQueries = {
  __typename?: 'FactCheckThemeQueries';
  get: FactCheckTheme;
};


export type FactCheckThemeQueriesGetArgs = {
  input: IdInput;
};

export type FactCheckThemeSummary = {
  __typename?: 'FactCheckThemeSummary';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export enum FactCheckValueKind {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Set = 'SET',
  Text = 'TEXT',
  Unlimited = 'UNLIMITED'
}

export type FavoriteCard = {
  __typename?: 'FavoriteCard';
  card: Card;
  cardId: Scalars['ID'];
  organisationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type FavoriteCardConnection = {
  __typename?: 'FavoriteCardConnection';
  items: Array<FavoriteCard>;
  nextToken?: Maybe<Scalars['String']>;
  scannedCount: Scalars['Int'];
};

export enum Feedback {
  Negative = 'Negative',
  Positive = 'Positive'
}

export type FeedbackCount = {
  __typename?: 'FeedbackCount';
  card: Card;
  cardId: Scalars['String'];
  date: Scalars['String'];
  numNegativeFeedbacks?: Maybe<Scalars['Int']>;
  numPositiveFeedbacks?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type FeedbackCountConnection = {
  __typename?: 'FeedbackCountConnection';
  items: Array<FeedbackCount>;
  nextToken?: Maybe<Scalars['String']>;
};

export type FloatBetweenInput = {
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type FloatFilter = {
  between?: InputMaybe<FloatBetweenInput>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type ForbiddenCommand = {
  __typename?: 'ForbiddenCommand';
  command: Command;
  commandId: Scalars['String'];
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
  locale: Scalars['String'];
};

export type GenerateAdvancedAnalysisItemsExportUrlInput = {
  advancedAnalysisItem?: InputMaybe<StatExportAdvancedAnalysisFilterInput>;
  contextId?: InputMaybe<Scalars['ID']>;
  element: StatExportElement;
  endDate: Scalars['Long'];
  evaluationSheetId?: InputMaybe<Scalars['ID']>;
  format: StatExportFormat;
  granularity?: InputMaybe<EvaluationSheetStatGranularity>;
  language: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type GenerateExcelStatUrlForStaffInput = {
  endDate: Scalars['Long'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
};

export type GenerateExcelStatUrlInput = {
  endDate: Scalars['Long'];
  language: Scalars['String'];
  projectId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Long'];
  type: ExcelStatType;
};

export type GeneratePostgresItemStatsExportUrlInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  complianceOperationId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Long'];
  startDate: Scalars['Long'];
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type GenerateTemporaryCodeInput = {
  accessToken: Scalars['String'];
  idToken: Scalars['String'];
  lastAuthUser: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type GetAudioInput = {
  id: Scalars['ID'];
};

export type GetCardInstanceInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type GetComplianceTopicInput = {
  projectId: Scalars['String'];
  textLower: Scalars['String'];
};

export type GetStatIdInput = {
  contextId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Long'];
  projectId?: InputMaybe<Scalars['ID']>;
  speaker?: InputMaybe<SpeakerType>;
  startDate: Scalars['Long'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type GetTriggerInput = {
  commandId?: InputMaybe<Scalars['ID']>;
  triggerId?: InputMaybe<Scalars['ID']>;
};

export type GetUploadDocumentUrlInput = {
  assistantId: Scalars['ID'];
  fileType: Scalars['String'];
  filename: Scalars['String'];
  metadataMap?: InputMaybe<Scalars['String']>;
  update: Scalars['Boolean'];
};

export type GetUploadUrlInput = {
  filePath: Scalars['String'];
  metadataMap?: InputMaybe<Scalars['String']>;
};

export type GetUserPerformanceStatsInput = {
  weeksAgo: Scalars['Int'];
};

export type GlobalStatId = StatId & {
  __typename?: 'GlobalStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type GlobalStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type GlobalStatsBigNumbersTrend = {
  __typename?: 'GlobalStatsBigNumbersTrend';
  current: GlobalStatsMetric;
  previous: GlobalStatsMetric;
};

export type GlobalStatsMetric = {
  __typename?: 'GlobalStatsMetric';
  avgCallDuration?: Maybe<Scalars['Float']>;
  avgSessionDuration?: Maybe<Scalars['Float']>;
  avgSessionScore?: Maybe<Scalars['Float']>;
  callCoverage?: Maybe<Scalars['Float']>;
  detectionCount: Scalars['Int'];
  displayCount: Scalars['Int'];
  displayOriginRepartition: DisplayOriginRepartition;
  dualAppSessionCount: Scalars['Int'];
  dualAppSessionRatio?: Maybe<Scalars['Float']>;
  externalCallCoveredDuration: Scalars['Long'];
  externalCallDuration: Scalars['Long'];
  externalCalls: Scalars['Long'];
  externalCallsCovered: Scalars['Long'];
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Long'];
};

export type GlobalStatsPageQueries = {
  __typename?: 'GlobalStatsPageQueries';
  bigNumbers: GlobalStatsBigNumbersTrend;
  projectTable: Array<GlobalStatsProjectRow>;
  teamTable: Array<GlobalStatsTeamRow>;
};


export type GlobalStatsPageQueriesBigNumbersArgs = {
  input: SessionStatisticsTrendInput;
};


export type GlobalStatsPageQueriesProjectTableArgs = {
  input: SessionStatisticsTrendInput;
};


export type GlobalStatsPageQueriesTeamTableArgs = {
  input: SessionStatisticsTrendInput;
};

export type GlobalStatsProjectRow = {
  __typename?: 'GlobalStatsProjectRow';
  current: GlobalStatsRowMetric;
  previous: GlobalStatsRowMetric;
  project: Project;
  projectId: Scalars['ID'];
};

export type GlobalStatsRowMetric = {
  __typename?: 'GlobalStatsRowMetric';
  avgSessionDuration?: Maybe<Scalars['Float']>;
  avgSessionScore?: Maybe<Scalars['Float']>;
  displayCount: Scalars['Int'];
  dualAppSessionCount: Scalars['Int'];
  dualAppSessionRatio?: Maybe<Scalars['Float']>;
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Long'];
};

export type GlobalStatsTeamRow = {
  __typename?: 'GlobalStatsTeamRow';
  current: GlobalStatsRowMetric;
  previous: GlobalStatsRowMetric;
  team: Team;
  teamId: Scalars['ID'];
};

export type IdInput = {
  id: Scalars['ID'];
};

export type InclusionConditionInput = {
  id: Scalars['ID'];
  inclusionType: TreeSequenceItemInclusionType;
  values: Array<Scalars['String']>;
};

export type InfinitePhrasingQueryInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  phrasingSubjectType?: InputMaybe<PhrasingSubjectType>;
  projectId?: InputMaybe<Scalars['ID']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type InfiniteProjectAndUserQueryInput = {
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  textSearch?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type InfiniteProjectQueryInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type InfiniteQueryInput = {
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type InfiniteSessionQueryInput = {
  endDate?: InputMaybe<Scalars['Long']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Long']>;
  teamId?: InputMaybe<Scalars['ID']>;
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type InsertDecisionTreeNodeInput = {
  nodeId: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type IntRangeFilter = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type Integration = {
  __typename?: 'Integration';
  createdAt: Scalars['AWSTimestamp'];
  createdBy: Scalars['ID'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId: Scalars['String'];
  type: IntegrationType;
};

export type IntegrationMutation = {
  __typename?: 'IntegrationMutation';
  removeMsTeams: Organisation;
  removeSlackHuddle: Organisation;
};

export enum IntegrationPartner {
  Aircall = 'Aircall',
  Genesys = 'Genesys',
  Inocx = 'Inocx',
  OpenPhone = 'OpenPhone',
  Public = 'Public',
  Ringover = 'Ringover',
  Slack = 'Slack',
  Teams = 'Teams',
  Viadialog = 'Viadialog'
}

export enum IntegrationType {
  Aircall = 'AIRCALL',
  Inocx = 'INOCX',
  Ringover = 'RINGOVER'
}

export type Intention = {
  __typename?: 'Intention';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  samples: Array<IntentionSamples>;
  text: Scalars['String'];
  textLower: Scalars['String'];
  threshold?: Maybe<Scalars['Float']>;
};

export type IntentionConnection = {
  __typename?: 'IntentionConnection';
  items: Array<Intention>;
  nextToken?: Maybe<Scalars['String']>;
};

export type IntentionMutations = {
  __typename?: 'IntentionMutations';
  create: Intention;
  delete: Intention;
  test: Array<IntentionTestResult>;
  update: Intention;
};


export type IntentionMutationsCreateArgs = {
  input: CreateIntentionInput;
};


export type IntentionMutationsDeleteArgs = {
  input: IdInput;
};


export type IntentionMutationsTestArgs = {
  input: IntentionSamplesTestInput;
};


export type IntentionMutationsUpdateArgs = {
  input: UpdateIntentionInput;
};

export type IntentionQueries = {
  __typename?: 'IntentionQueries';
  get: Intention;
  list: IntentionConnection;
};


export type IntentionQueriesGetArgs = {
  input: IdInput;
};


export type IntentionQueriesListArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};

export type IntentionSamples = {
  __typename?: 'IntentionSamples';
  text: Scalars['String'];
};

export type IntentionSamplesInput = {
  text: Scalars['String'];
};

export type IntentionSamplesTestInput = {
  samples: Array<Scalars['String']>;
  threshold: Scalars['Float'];
  transcript: Scalars['String'];
};

export type IntentionStatId = StatId & {
  __typename?: 'IntentionStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  intention: Intention;
  intentionId: Scalars['ID'];
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type IntentionStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type IntentionTestResult = {
  __typename?: 'IntentionTestResult';
  results: Array<ResultSentence>;
  transcript: Scalars['String'];
};

export type IntentionViewAssignment = AbstractAssignment & {
  __typename?: 'IntentionViewAssignment';
  assignee: Intention;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: View;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type IntentionViewAssignmentConnection = {
  __typename?: 'IntentionViewAssignmentConnection';
  items: Array<IntentionViewAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type InviteUserInput = {
  emails: Array<Scalars['String']>;
  locale: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  role: Scalars['Int'];
  subscriptionId?: InputMaybe<Scalars['String']>;
  teamsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ItemLock = {
  __typename?: 'ItemLock';
  expireAt: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
};

export type KeyIntValue = {
  __typename?: 'KeyIntValue';
  key: Scalars['String'];
  value: Scalars['Int'];
};

export type KeyStringValue = {
  __typename?: 'KeyStringValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type LinkInput = {
  sourceScopeId: Scalars['ID'];
  targetScopeId: Scalars['ID'];
};

export type ListAdvancedAnalysisItemEvaluationJobsInput = {
  advancedAnalysisItemId: Scalars['ID'];
  pagination: PaginationInput;
};

export type ListAdvancedAnalysisJobsInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  factCheckModuleId?: InputMaybe<Scalars['ID']>;
  pagination: PaginationInput;
  phrasingPerformanceSubjectId?: InputMaybe<Scalars['ID']>;
};

export type ListAsrSessionTranscriptsInput = {
  embeddingSearch?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};

export type ListAsrSessionsEmbeddingSearchInput = {
  excludedSessionIds: Array<Scalars['ID']>;
  text: Scalars['String'];
};

export type ListAsrSessionsFiltersInput = {
  date?: InputMaybe<LongRangeFilter>;
  duration?: InputMaybe<IntRangeFilter>;
  projectId?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  userDisplayName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ListAsrSessionsInput = {
  embeddingSearch?: InputMaybe<ListAsrSessionsEmbeddingSearchInput>;
  filters: ListAsrSessionsFiltersInput;
  from?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
};

export type ListContentRequestsInput = {
  assigneeFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  stateFilter?: InputMaybe<ContentRequestState>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type ListDecisionTreeNodesInput = {
  decisionTreeId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};

export type ListDecisionTreesInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type ListIntegration = {
  __typename?: 'ListIntegration';
  items: Array<Integration>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ListPhrasingPerformanceSubjectsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type ListSessionEventsInput = {
  sessionEventType?: InputMaybe<Array<SessionEventComplianceType>>;
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type ListSessionEventsOfUserWithTopicInput = {
  endDate: Scalars['Long'];
  eventType: SessionEventType;
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['Long'];
  topicTextLower: Scalars['String'];
  userId: Scalars['ID'];
};

export type ListStatIdsInput = {
  element: StatElement;
  endDate: Scalars['Long'];
  filters: StatIdFilterInput;
  startDate: Scalars['Long'];
};

export enum LiveNotificationType {
  BrowserNotification = 'BrowserNotification',
  FocusWindow = 'FocusWindow'
}

export enum LockedItemType {
  AdvancedAnalysisItem = 'AdvancedAnalysisItem',
  Assignment = 'Assignment',
  Organisation = 'Organisation',
  PhrasingPerformanceSubject = 'PhrasingPerformanceSubject',
  SessionSummary = 'SessionSummary'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LongBetweenInput = {
  end: Scalars['Long'];
  start: Scalars['Long'];
};

export type LongFilter = {
  between?: InputMaybe<LongBetweenInput>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
};

export type LongRangeFilter = {
  from?: InputMaybe<Scalars['Long']>;
  to?: InputMaybe<Scalars['Long']>;
};

export type MandatoryTopic = {
  __typename?: 'MandatoryTopic';
  callGroupConfig?: Maybe<MandatoryTopicCallGroupConfig>;
  complianceExample?: Maybe<Scalars['String']>;
  conditionTopics?: Maybe<Array<ConditionTopic>>;
  createdAt: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  externalStatusCodeBlacklist?: Maybe<Array<Scalars['String']>>;
  forbiddenCommands: Array<ForbiddenCommand>;
  hasExample?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isCurrent?: Maybe<Scalars['Boolean']>;
  minimumDuration?: Maybe<Scalars['Float']>;
  organisationId: Scalars['String'];
  projectCommands?: Maybe<ProjectCommandConnection>;
  projectId: Scalars['ID'];
  projectTopic: ProjectTopic;
  projectVocalTriggers?: Maybe<ProjectVocalTriggerConnection>;
  reminder?: Maybe<MandatoryTopicReminderConfig>;
  sessionStepCondition?: Maybe<MandatoryTopicSessionStep>;
  sessionTagBlacklist?: Maybe<Array<Scalars['String']>>;
  sessionTagWhitelist?: Maybe<Array<Scalars['String']>>;
  textLower: Scalars['String'];
  topic: Topic;
  translations?: Maybe<Array<MandatoryTopicTranslation>>;
};

export type MandatoryTopicCallGroupConfig = {
  __typename?: 'MandatoryTopicCallGroupConfig';
  forceRequiredIfPreviousNotValidated?: Maybe<Scalars['Boolean']>;
};

export type MandatoryTopicReminderConfig = {
  __typename?: 'MandatoryTopicReminderConfig';
  time: Scalars['Float'];
  type: MandatoryTopicReminderType;
};

export enum MandatoryTopicReminderType {
  FixedTime = 'FixedTime',
  Recurring = 'Recurring'
}

export enum MandatoryTopicSessionStep {
  ConversationEngaged = 'ConversationEngaged'
}

export type MandatoryTopicTranslation = {
  __typename?: 'MandatoryTopicTranslation';
  createdAt: Scalars['Long'];
  id: Scalars['String'];
  language: Scalars['String'];
};

export type MetricsFilter = {
  endDate: Scalars['Long'];
  startDate: Scalars['Long'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAllNotifications: Array<Notification>;
  /** Notifications */
  acknowledgeNotification: Notification;
  addAutoStartUrl: Scalars['String'];
  addCardContentBlock: ContentBlockV2;
  addCardLink: CardLink;
  addCardTab: CardTabV2;
  addDecisionTreeNodeChild: DecisionTreeNode;
  addProjectAssignment: ProjectAssignment;
  addProjectToExcelCardImporter: ExcelCardImporter;
  addToFavorite: FavoriteCard;
  advancedAnalysisItem: AdvancedAnalysisItemMutations;
  /** detection */
  annotateAudio: Detection;
  applicationConnection: ApplicationConnectionMutations;
  archiveProject: Project;
  archiveTopic: Topic;
  /** catalog */
  assignCatalog: Catalog;
  assignDecisionTreeToProject: DecisionTreeProject;
  assignNews: News;
  assignTeam: TeamMembership;
  assignment: AssignmentMutations;
  callStatus: CallStatusMutations;
  card: CardMutations;
  checkCommand: Scalars['Boolean'];
  complianceModule: ComplianceModuleMutations;
  complianceOperationItem: ComplianceOperationItemMutations;
  consentToLinks: User;
  contentGeneration: ContentGenerationMutations;
  contentGenerationAssistant: ContentGenerationAssistantMutation;
  context: ContextMutations;
  /** content */
  createCard?: Maybe<Card>;
  /** ASR Commands */
  createCommandNew?: Maybe<Command>;
  /** Comments */
  createComment: Comment;
  createContentRequest: ContentRequest;
  createContentTag: ContentTag;
  /** decision tree */
  createDecisionTree: DecisionTree;
  createDetection: Detection;
  /** display */
  createDisplay: Display;
  createExcelCardImporter: ExcelCardImporter;
  /** reporting */
  createExcelExport: Scalars['String'];
  createIntegration: Integration;
  createMandatoryTopic: MandatoryTopic;
  /** news */
  createNews: News;
  createProject: Project;
  /** recommender */
  createRecommender: Recommender;
  createRecommenderColumnSpec: RecommenderColumnSpec;
  /** session */
  createSession: Session;
  /** team */
  createTeam: Team;
  /** Topic */
  createTopic: Topic;
  decisionTree: DecisionTreeMutation;
  deleteCard?: Maybe<CardDeleteOutput>;
  deleteCommand?: Maybe<Command>;
  deleteComment: Comment;
  deleteContentTag: ContentTag;
  deleteDecisionTree: DecisionTree;
  deleteExcelCardImporter: ExcelCardImporter;
  deleteMandatoryTopic: MandatoryTopic;
  deleteNews: News;
  deleteRecommender: Recommender;
  deleteRecommenderColumnSpec: RecommenderColumnSpec;
  deleteTeam: Team;
  deleteUser: User;
  desynchronizeDecisionTreeNode: DecisionTreeNode;
  disableIntegration: Integration;
  dissociateCommand: ProjectCommand;
  duplicateCard: Card;
  duplicateDecisionTree: DecisionTree;
  duplicateDecisionTreeNode: DecisionTreeNode;
  duplicateProject: Project;
  enableIntegration: Integration;
  evaluationSheet: EvaluationSheetMutations;
  externalUser: ExternalUserMutations;
  factCheck: FactCheckMutations;
  generateExcelStatUrl: Scalars['String'];
  generateExcelStatUrlForStaff: Scalars['String'];
  /** user */
  generateToken: Scalars['String'];
  getAudio: Scalars['String'];
  getRecommendation: Recommendation;
  integration: IntegrationMutation;
  intention: IntentionMutations;
  /** user administration */
  inviteUsers: Array<User>;
  organisation: OrganisationMutations;
  phrasingPerformanceSubject: PhrasingPerformanceSubjectMutations;
  project: ProjectMutations;
  projectTopic: ProjectTopicMutations;
  projectTrigger: ProjectTriggerMutations;
  publish: CardScope;
  publishCatalog: Catalog;
  removeAutoStartUrl: Scalars['String'];
  removeCardContentBlock: ContentBlockV2;
  removeCardLink: CardLink;
  removeCardTab: CardTabV2;
  removeDecisionTreeNodeChild: DecisionTreeNode;
  removeFromFavorite: FavoriteCard;
  removeProjectAssignment: ProjectAssignment;
  removeProjectFromExcelCardImporter: ExcelCardImporter;
  renameCard: Card;
  renameCardTab: CardTabV2;
  renameCatalog: Catalog;
  renameCatalogColumn: Catalog;
  renameProject: Project;
  reorderCardContentBlocks: CardTabV2;
  reorderCardTabs: CardContentV2;
  reorderDecisionTreeNodeChildren: DecisionTreeNode;
  resendInvitation: User;
  revertCatalog: Catalog;
  session: SessionMutations;
  /** Organisation */
  setIntegrations: Organisation;
  startDecisionTreeRun: DecisionTreeRun;
  statExport: StatExportMutations;
  subscribeAlerting: ProjectAlertingSubscription;
  /** services */
  transcript: TranscriptMutation;
  transfer: Card;
  transitionContentRequest: ContentRequest;
  unassignCatalog: Catalog;
  unassignDecisionTreeToProject: DecisionTreeProject;
  unassignNews: News;
  unassignTeam: TeamMembership;
  unpublish: CardScope;
  unpublishCatalog: Catalog;
  unsubscribeAlerting: ProjectAlertingSubscription;
  updateAdvancedAnalysisItemEvaluationJobResultNoOp: AdvancedAnalysisItemEvaluationJobResult;
  updateAdvancedAnalysisJobNoOp: AdvancedAnalysisJob;
  updateCard?: Maybe<Card>;
  updateCardContentBlock: ContentBlockV2;
  updateCatalogDraft: Catalog;
  updateCommandNew?: Maybe<Command>;
  updateCommandRequest: CommandRequest;
  updateComment: Comment;
  updateDecisionTree: DecisionTree;
  updateDecisionTreeNode: DecisionTreeNode;
  updateDecisionTreeNodeChildValue: DecisionTreeNode;
  updateDecisionTreeNodeColor: DecisionTreeNode;
  updateDecisionTreeRunHistory: DecisionTreeRun;
  updateDisplay: Display;
  updateDisplayFeedback: Display;
  updateExcelCardImporter: ExcelCardImporter;
  updateLastEmailSent: User;
  updateMandatoryTopic: MandatoryTopic;
  updateNews: News;
  updatePassword: User;
  updatePersonalInfo: User;
  updateProject: Project;
  updatePushSubscription: User;
  updateRecommender: Recommender;
  updateRecommenderColumnSpec: RecommenderColumnSpec;
  updateSessionComplianceChecklistNoOp: Session;
  /** no-op mutations for Subscriptions */
  updateSessionNoOp: Session;
  updateStripeInfo: Scalars['Boolean'];
  updateTeam: Team;
  updateTopicColor: Topic;
  updateTopicThreshold: Topic;
  updateUserPermissions: User;
  updateUserSettings: User;
  user: UserMutations;
  view: ViewMutations;
  writeDecisionTreeRunComment: DecisionTreeRun;
};


export type MutationAcknowledgeNotificationArgs = {
  input: AcknowledgeNotificationInput;
};


export type MutationAddAutoStartUrlArgs = {
  input: UpdateAutoStartUrlInput;
};


export type MutationAddCardContentBlockArgs = {
  input: AddCardContentBlockInput;
};


export type MutationAddCardLinkArgs = {
  input: LinkInput;
};


export type MutationAddCardTabArgs = {
  input: AddCardTabInput;
};


export type MutationAddDecisionTreeNodeChildArgs = {
  input: AddDecisionTreeNodeInput;
};


export type MutationAddProjectAssignmentArgs = {
  input: AddProjectAssignmentInput;
};


export type MutationAddProjectToExcelCardImporterArgs = {
  input: AddProjectToExcelCardImporterInput;
};


export type MutationAddToFavoriteArgs = {
  cardId: Scalars['ID'];
};


export type MutationAnnotateAudioArgs = {
  input: AnnotateAudioInput;
};


export type MutationArchiveProjectArgs = {
  input: ArchiveProjectInput;
};


export type MutationArchiveTopicArgs = {
  input: ArchiveTopicInput;
};


export type MutationAssignCatalogArgs = {
  input: ProjectAssignmentInput;
};


export type MutationAssignDecisionTreeToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type MutationAssignNewsArgs = {
  input: NewsAssignmentInput;
};


export type MutationAssignTeamArgs = {
  input: AssignmentInput;
};


export type MutationCheckCommandArgs = {
  input: CheckCommandInput;
};


export type MutationCreateCardArgs = {
  input: CreateCardInput;
};


export type MutationCreateCommandNewArgs = {
  input: CreateCommandNewInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateContentRequestArgs = {
  input: CreateContentRequestInput;
};


export type MutationCreateContentTagArgs = {
  input: CreateContentTagInput;
};


export type MutationCreateDecisionTreeArgs = {
  input: CreateDecisionTreeInput;
};


export type MutationCreateDetectionArgs = {
  input: CreateDetectionInput;
};


export type MutationCreateDisplayArgs = {
  input: CreateDisplayInput;
};


export type MutationCreateExcelCardImporterArgs = {
  input: CreateExcelCardImporterInput;
};


export type MutationCreateExcelExportArgs = {
  input: ExcelExportInput;
};


export type MutationCreateIntegrationArgs = {
  input?: InputMaybe<CreateIntegrationInput>;
};


export type MutationCreateMandatoryTopicArgs = {
  input: CreateMandatoryTopicInput;
};


export type MutationCreateNewsArgs = {
  input: CreateNewsInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateRecommenderArgs = {
  input: CreateRecommenderInput;
};


export type MutationCreateRecommenderColumnSpecArgs = {
  input: CreateRecommenderColumnSpecInput;
};


export type MutationCreateSessionArgs = {
  input?: InputMaybe<CreateSessionInput>;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationDeleteCardArgs = {
  input: DeleteCardInput;
};


export type MutationDeleteCommandArgs = {
  input: DeleteCommandInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteContentTagArgs = {
  input: DeleteContentTagInput;
};


export type MutationDeleteDecisionTreeArgs = {
  input: IdInput;
};


export type MutationDeleteExcelCardImporterArgs = {
  input: IdInput;
};


export type MutationDeleteMandatoryTopicArgs = {
  input: IdInput;
};


export type MutationDeleteNewsArgs = {
  input: IdInput;
};


export type MutationDeleteRecommenderArgs = {
  input: DeleteRecommenderInput;
};


export type MutationDeleteRecommenderColumnSpecArgs = {
  input: DeleteRecommenderColumnSpecInput;
};


export type MutationDeleteTeamArgs = {
  input: IdInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDesynchronizeDecisionTreeNodeArgs = {
  input: DesynchronizeDecisionTreeNodeInput;
};


export type MutationDisableIntegrationArgs = {
  input?: InputMaybe<DisableIntegrationInput>;
};


export type MutationDissociateCommandArgs = {
  input: DissociateCommandInput;
};


export type MutationDuplicateCardArgs = {
  input: DuplicateCardInput;
};


export type MutationDuplicateDecisionTreeArgs = {
  input: DuplicateDecisionTreeInput;
};


export type MutationDuplicateDecisionTreeNodeArgs = {
  input: DuplicateDecisionTreeNodeInput;
};


export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};


export type MutationEnableIntegrationArgs = {
  input?: InputMaybe<EnableIntegrationInput>;
};


export type MutationGenerateExcelStatUrlArgs = {
  input: GenerateExcelStatUrlInput;
};


export type MutationGenerateExcelStatUrlForStaffArgs = {
  input: GenerateExcelStatUrlForStaffInput;
};


export type MutationGetAudioArgs = {
  input: GetAudioInput;
};


export type MutationGetRecommendationArgs = {
  input: RecommenderQueryInput;
};


export type MutationInviteUsersArgs = {
  input: InviteUserInput;
};


export type MutationPublishArgs = {
  input: PublishInput;
};


export type MutationPublishCatalogArgs = {
  input: IdInput;
};


export type MutationRemoveAutoStartUrlArgs = {
  input: UpdateAutoStartUrlInput;
};


export type MutationRemoveCardContentBlockArgs = {
  input: RemoveCardContentBlockInput;
};


export type MutationRemoveCardLinkArgs = {
  input: LinkInput;
};


export type MutationRemoveCardTabArgs = {
  input: RemoveCardTabInput;
};


export type MutationRemoveDecisionTreeNodeChildArgs = {
  input: RemoveDecisionTreeNodeChildInput;
};


export type MutationRemoveFromFavoriteArgs = {
  cardId: Scalars['ID'];
};


export type MutationRemoveProjectAssignmentArgs = {
  input: RemoveProjectAssignmentInput;
};


export type MutationRemoveProjectFromExcelCardImporterArgs = {
  input: AddProjectToExcelCardImporterInput;
};


export type MutationRenameCardArgs = {
  input: RenameCardInput;
};


export type MutationRenameCardTabArgs = {
  input: RenameCardTabInput;
};


export type MutationRenameCatalogArgs = {
  input: RenameCatalogInput;
};


export type MutationRenameCatalogColumnArgs = {
  input: RenameCatalogColumnInput;
};


export type MutationRenameProjectArgs = {
  input: RenameProjectInput;
};


export type MutationReorderCardContentBlocksArgs = {
  input: ReorderCardContentBlocksInput;
};


export type MutationReorderCardTabsArgs = {
  input: ReorderCardTabsInput;
};


export type MutationReorderDecisionTreeNodeChildrenArgs = {
  input: ReorderDecisionTreeNodeChildrenInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


export type MutationRevertCatalogArgs = {
  input: IdInput;
};


export type MutationSetIntegrationsArgs = {
  input: SetIntegrationsInput;
};


export type MutationStartDecisionTreeRunArgs = {
  input: StartDecisionTreeRunInput;
};


export type MutationSubscribeAlertingArgs = {
  input: IdInput;
};


export type MutationTransferArgs = {
  cardId: Scalars['ID'];
};


export type MutationTransitionContentRequestArgs = {
  input: TransitionContentRequestInput;
};


export type MutationUnassignCatalogArgs = {
  input: ProjectAssignmentInput;
};


export type MutationUnassignDecisionTreeToProjectArgs = {
  input: DecisionTreeProjectInput;
};


export type MutationUnassignNewsArgs = {
  input: NewsAssignmentInput;
};


export type MutationUnassignTeamArgs = {
  input: AssignmentInput;
};


export type MutationUnpublishArgs = {
  input: PublishInput;
};


export type MutationUnpublishCatalogArgs = {
  input: IdInput;
};


export type MutationUnsubscribeAlertingArgs = {
  input: IdInput;
};


export type MutationUpdateAdvancedAnalysisItemEvaluationJobResultNoOpArgs = {
  evaluationJobId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
};


export type MutationUpdateAdvancedAnalysisJobNoOpArgs = {
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
};


export type MutationUpdateCardArgs = {
  input: UpdateCardInput;
};


export type MutationUpdateCardContentBlockArgs = {
  input: UpdateCardContentBlockInput;
};


export type MutationUpdateCatalogDraftArgs = {
  input: UpdateCatalogDraftInput;
};


export type MutationUpdateCommandNewArgs = {
  input: UpdateCommandNewInput;
};


export type MutationUpdateCommandRequestArgs = {
  input: UpdateCommandRequestInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateDecisionTreeArgs = {
  input: UpdateDecisionTreeInput;
};


export type MutationUpdateDecisionTreeNodeArgs = {
  input: UpdateDecisionTreeNodeInput;
};


export type MutationUpdateDecisionTreeNodeChildValueArgs = {
  input: UpdateDecisionTreeNodeChildValueInput;
};


export type MutationUpdateDecisionTreeNodeColorArgs = {
  input: UpdateDecisionTreeNodeColorInput;
};


export type MutationUpdateDecisionTreeRunHistoryArgs = {
  input: UpdateDecisionTreeRunHistoryInput;
};


export type MutationUpdateDisplayArgs = {
  input: UpdateDisplayInput;
};


export type MutationUpdateDisplayFeedbackArgs = {
  input: UpdateDisplayFeedbackInput;
};


export type MutationUpdateExcelCardImporterArgs = {
  input: UpdateExcelCardImporterInput;
};


export type MutationUpdateLastEmailSentArgs = {
  input: UpdateLastEmailSentInput;
};


export type MutationUpdateMandatoryTopicArgs = {
  input: UpdateMandatoryTopicInput;
};


export type MutationUpdateNewsArgs = {
  input: UpdateNewsInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePersonalInfoArgs = {
  input: UpdatePersonalInfoInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdatePushSubscriptionArgs = {
  input: UpdatePushSubscriptionInput;
};


export type MutationUpdateRecommenderArgs = {
  input: UpdateRecommenderInput;
};


export type MutationUpdateRecommenderColumnSpecArgs = {
  input: CreateRecommenderColumnSpecInput;
};


export type MutationUpdateSessionComplianceChecklistNoOpArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateSessionNoOpArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateStripeInfoArgs = {
  input: UpdateStripeInfoInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTopicColorArgs = {
  input: UpdateTopicColorInput;
};


export type MutationUpdateTopicThresholdArgs = {
  input: UpdateTopicThresholdInput;
};


export type MutationUpdateUserPermissionsArgs = {
  input: UpdateUserPermissionsInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationWriteDecisionTreeRunCommentArgs = {
  input: WriteDecisionTreeRunCommentInput;
};

export type News = {
  __typename?: 'News';
  content: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  endDate?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  publications: Array<NewsPublication>;
  startDate?: Maybe<Scalars['Long']>;
  status: NewsStatus;
  title: Scalars['String'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser?: Maybe<User>;
};

export type NewsAssignmentInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type NewsConnection = {
  __typename?: 'NewsConnection';
  items: Array<News>;
  nextToken?: Maybe<Scalars['String']>;
};

export type NewsPublication = {
  __typename?: 'NewsPublication';
  projectId: Scalars['ID'];
};

export enum NewsStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type NodeVariableInput = {
  nodeId: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  acknowledgeDate?: Maybe<Scalars['AWSTimestamp']>;
  date: Scalars['AWSTimestamp'];
  event: NotificationEvent;
  eventId: Scalars['ID'];
  organisationId: Scalars['String'];
  userId: Scalars['ID'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  items: Array<Notification>;
  nextToken?: Maybe<Scalars['String']>;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['ID']>;
  command?: Maybe<Command>;
  commandId?: Maybe<Scalars['ID']>;
  contentRequest?: Maybe<ContentRequest>;
  contentRequestCounter?: Maybe<Scalars['Int']>;
  date: Scalars['AWSTimestamp'];
  eventType?: Maybe<NotificationType>;
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  organisationId: Scalars['String'];
  project?: Maybe<Project>;
  projectCommand?: Maybe<ProjectCommand>;
  projectId?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export enum NotificationType {
  AvailableCommand = 'AvailableCommand',
  CardComment = 'CardComment',
  CommandRequestStatusChanged = 'CommandRequestStatusChanged',
  CommentReply = 'CommentReply',
  ContentRequestCommented = 'ContentRequestCommented',
  ContentRequestCreated = 'ContentRequestCreated',
  ContentRequestUpdated = 'ContentRequestUpdated',
  NewContent = 'NewContent',
  ProjectAssigned = 'ProjectAssigned',
  UserConfirmed = 'UserConfirmed',
  UserInvited = 'UserInvited',
  UserRoleChanged = 'UserRoleChanged'
}

export type NumberIdInput = {
  id: Scalars['Int'];
};

export type OrgFeatureSettings = {
  enabled: Scalars['Boolean'];
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type Organisation = {
  __typename?: 'Organisation';
  additionalConsentUrlsEN: Array<AdditionalConsentUrl>;
  /** Consent Settings */
  additionalConsentUrlsFR: Array<AdditionalConsentUrl>;
  aircallIntegration?: Maybe<Scalars['Boolean']>;
  autoStartUrls?: Maybe<Array<Scalars['String']>>;
  date: Scalars['AWSTimestamp'];
  defaultAudioSettings_enableAudioAutoGainControl?: Maybe<Scalars['Boolean']>;
  defaultAudioSettings_enableAudioEchoCancellation?: Maybe<Scalars['Boolean']>;
  /** Defaut Audio Settings */
  defaultAudioSettings_enableAudioNoiseSuppression?: Maybe<Scalars['Boolean']>;
  displayText: Scalars['String'];
  enableAlternativeAsrApi?: Maybe<Scalars['Boolean']>;
  enableCoreAsrApi?: Maybe<Scalars['Boolean']>;
  enableFeature_coveredCallStatistics?: Maybe<Scalars['Boolean']>;
  enableFeature_phrasingPerformance?: Maybe<Scalars['Boolean']>;
  /** deprecated */
  enableFeature_wysiwygTerminationFeeComputation?: Maybe<Scalars['Boolean']>;
  excelCardImports: Array<ExcelCardImporter>;
  features: OrganisationFeatures;
  freezeStripeSeats?: Maybe<Scalars['Boolean']>;
  genesysIntegration?: Maybe<Scalars['Boolean']>;
  /** legacy. Move to new settings object */
  inocxIntegration?: Maybe<Scalars['Boolean']>;
  inocxPassword?: Maybe<Scalars['String']>;
  inocxUsePhoneNumberAsGroupCallId?: Maybe<Scalars['Boolean']>;
  invitation?: Maybe<Scalars['AWSJSON']>;
  licenseBillingOverride?: Maybe<Scalars['Boolean']>;
  minLicenses?: Maybe<Scalars['Int']>;
  msTeamsTenantId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numSeats?: Maybe<Scalars['Int']>;
  openPhoneIntegration?: Maybe<Scalars['Boolean']>;
  preferHttpConnection?: Maybe<Scalars['Boolean']>;
  ringoverIntegration?: Maybe<Scalars['Boolean']>;
  ringoverIntegrationSecret?: Maybe<Scalars['String']>;
  samlIdp?: Maybe<Scalars['String']>;
  samlProviders?: Maybe<Array<OrganisationSamlProvider>>;
  sharepointTenantId?: Maybe<Scalars['String']>;
  skipStripe?: Maybe<Scalars['Boolean']>;
  slackHuddleIntegration?: Maybe<Scalars['Boolean']>;
  slackHuddleToken?: Maybe<Scalars['String']>;
  slackTeamId?: Maybe<Scalars['String']>;
  slackToken?: Maybe<Scalars['String']>;
  smarttribuneIntegration?: Maybe<SmarttribuneIntegration>;
  stripeId?: Maybe<Scalars['String']>;
  stripeInterval?: Maybe<Scalars['String']>;
  stripeSubscriptions?: Maybe<Array<StripeSubscriptionEntity>>;
  subscription?: Maybe<StripeSubscription>;
  uploadedDocuments?: Maybe<UploadedDocumentsConnection>;
  viadialogIntegration?: Maybe<Scalars['Boolean']>;
};


export type OrganisationUploadedDocumentsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};

export type OrganisationAnonymisationFeatures = {
  __typename?: 'OrganisationAnonymisationFeatures';
  AllowPerson?: Maybe<Scalars['Boolean']>;
};

export type OrganisationChatFeatures = {
  __typename?: 'OrganisationChatFeatures';
  enabled: Scalars['Boolean'];
  quotas?: Maybe<OrganisationChatFeaturesQuotas>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationChatFeaturesQuotas = {
  __typename?: 'OrganisationChatFeaturesQuotas';
  dailyRequests: Scalars['Int'];
  monthlyRequests: Scalars['Int'];
};

export type OrganisationCogneedAiDecisionTreeSummaryConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiDecisionTreeSummaryConfig';
  enabled: Scalars['Boolean'];
  modelId?: Maybe<Scalars['String']>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiDualChannelConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiDualChannelConfig';
  displayCoverageStats?: Maybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  live?: Maybe<OrganisationCogneedAiDualChannelLiveConfig>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiDualChannelLiveConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiDualChannelLiveConfig';
  enabled: Scalars['Boolean'];
  focusOnCallStart?: Maybe<Scalars['Boolean']>;
  openOnCallStart?: Maybe<Scalars['Boolean']>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiFeatures = {
  __typename?: 'OrganisationCogneedAiFeatures';
  advancedAnalysis?: Maybe<AdvancedAnalysisOrgSettings>;
  anonymizer?: Maybe<OrganisationAnonymisationFeatures>;
  coaching?: Maybe<StandardOrgSetting>;
  complianceCrossCallGroup?: Maybe<Scalars['Boolean']>;
  confluenceIntegration?: Maybe<OrganisationConfluenceIntegrationSettings>;
  coveredCallStatistics?: Maybe<Scalars['Boolean']>;
  decisionTreeSummary?: Maybe<OrganisationCogneedAiDecisionTreeSummaryConfig>;
  disableSessionNotes?: Maybe<Scalars['Boolean']>;
  dualChannel?: Maybe<OrganisationCogneedAiDualChannelConfig>;
  enabled: Scalars['Boolean'];
  factCheck?: Maybe<FactCheckOrgSettings>;
  liveAssistant?: Maybe<OrganisationCogneedAiLiveAssistantConfig>;
  liveSessionDefaultFocusMode?: Maybe<StandardOrgSetting>;
  liveSessionDisableLiveSessionPageNavigation?: Maybe<StandardOrgSetting>;
  liveSessionPage?: Maybe<OrganisationCogneedAiLiveSessionPageConfig>;
  phrasingPerformance?: Maybe<Scalars['Boolean']>;
  sessionSummary?: Maybe<OrganisationCogneedAiSessionSummaryConfig>;
  speakerLabels?: Maybe<OrganisationCogneedAiSpeakerLabelsConfig>;
  transcriptVisibility?: Maybe<StandardOrgSetting>;
  wysiwygTerminationFeeComputation?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiLiveAssistantConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiLiveAssistantConfig';
  enabled: Scalars['Boolean'];
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiLiveSessionPageConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiLiveSessionPageConfig';
  enabled: Scalars['Boolean'];
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiSessionSummaryConfig = OrgFeatureSettings & {
  __typename?: 'OrganisationCogneedAiSessionSummaryConfig';
  enabled: Scalars['Boolean'];
  modelId?: Maybe<Scalars['String']>;
  overrideLegacyWithNova?: Maybe<Scalars['Boolean']>;
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type OrganisationCogneedAiSpeakerLabelsConfig = {
  __typename?: 'OrganisationCogneedAiSpeakerLabelsConfig';
  agentLabelId: AgentLabelId;
  clientLabelId: ClientLabelId;
};

export type OrganisationConfluenceIntegrationSettings = {
  __typename?: 'OrganisationConfluenceIntegrationSettings';
  apiToken: Scalars['String'];
  baseUrl: Scalars['String'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  hierarchyBlacklist?: Maybe<Array<Scalars['String']>>;
  pageBlacklist?: Maybe<Array<Scalars['String']>>;
  pageWhitelist?: Maybe<Array<Scalars['String']>>;
  projectIds: Array<Scalars['String']>;
  spaceBlacklist?: Maybe<Array<Scalars['String']>>;
  spaceWhitelist?: Maybe<Array<Scalars['String']>>;
};

export type OrganisationFeatures = {
  __typename?: 'OrganisationFeatures';
  chat?: Maybe<OrganisationChatFeatures>;
  cogneedAi?: Maybe<OrganisationCogneedAiFeatures>;
  demoOrg?: Maybe<Scalars['Boolean']>;
  ssoOnlyDomains?: Maybe<Array<Scalars['String']>>;
};

export type OrganisationMutations = {
  __typename?: 'OrganisationMutations';
  deleteUploadedDocument: Scalars['Boolean'];
  update: Organisation;
};


export type OrganisationMutationsDeleteUploadedDocumentArgs = {
  input: IdInput;
};


export type OrganisationMutationsUpdateArgs = {
  input: UpdateOrganisationInput;
};

export type OrganisationQueries = {
  __typename?: 'OrganisationQueries';
  get: Organisation;
};

export type OrganisationSamlProvider = {
  __typename?: 'OrganisationSamlProvider';
  id: Scalars['ID'];
  regex: Scalars['String'];
};

export type OwnerUpdateUserInput = {
  id: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type OwnerUserMutations = {
  __typename?: 'OwnerUserMutations';
  setScopes: User;
  update: User;
};


export type OwnerUserMutationsSetScopesArgs = {
  input: SetUserScopesInput;
};


export type OwnerUserMutationsUpdateArgs = {
  input: OwnerUpdateUserInput;
};

export type PaginationInput = {
  limit: Scalars['Int'];
  nextToken?: InputMaybe<Scalars['String']>;
};

export type Period = {
  __typename?: 'Period';
  endDate?: Maybe<Scalars['Long']>;
  startDate: Scalars['Long'];
  uncoveredCalls: Scalars['Int'];
};

export type PhrasingPerformanceReferenceStatistic = {
  __typename?: 'PhrasingPerformanceReferenceStatistic';
  badCount: Scalars['Int'];
  goodCount: Scalars['Int'];
  lastSeenAt: Scalars['Long'];
  occurrenceCount: Scalars['Int'];
  wordingId: Scalars['ID'];
};

export enum PhrasingPerformanceSessionOutcome {
  Bad = 'Bad',
  Good = 'Good'
}

export type PhrasingPerformanceStatisticsInput = {
  confirmedOnly: Scalars['Boolean'];
  period?: InputMaybe<StatisticsPeriodInput>;
  phrasingPerformanceSubjectId?: InputMaybe<Scalars['ID']>;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type PhrasingPerformanceStatisticsQueries = {
  __typename?: 'PhrasingPerformanceStatisticsQueries';
  bySubject: Array<PhrasingPerformanceSubjectStatistic>;
};


export type PhrasingPerformanceStatisticsQueriesBySubjectArgs = {
  input: PhrasingPerformanceStatisticsInput;
};

export type PhrasingPerformanceSubject = {
  __typename?: 'PhrasingPerformanceSubject';
  assignedPhrasingPerformanceWordings: PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignmentConnection;
  candidateThreshold: Scalars['Float'];
  confirmedMatchThreshold: Scalars['Float'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  goodCondition?: Maybe<AdvancedAnalysisItemCondition>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  preFilterThreshold: Scalars['Float'];
  projectAssignments: PhrasingPerformanceSubjectProjectAssignmentConnection;
  scopeCondition?: Maybe<AdvancedAnalysisItemCondition>;
  serializedGoodCondition?: Maybe<Scalars['AWSJSON']>;
  serializedScopeCondition?: Maybe<Scalars['AWSJSON']>;
  subSpanLengthTolerance: Scalars['Int'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type PhrasingPerformanceSubjectConnection = {
  __typename?: 'PhrasingPerformanceSubjectConnection';
  items: Array<PhrasingPerformanceSubject>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingPerformanceSubjectMutations = {
  __typename?: 'PhrasingPerformanceSubjectMutations';
  addGoodCondition: PhrasingPerformanceSubject;
  addReference: PhrasingPerformanceSubject;
  addScopeCondition: PhrasingPerformanceSubject;
  create: PhrasingPerformanceSubject;
  delete: PhrasingPerformanceSubject;
  removeGoodCondition: PhrasingPerformanceSubject;
  removeReference: PhrasingPerformanceSubject;
  removeScopeCondition: PhrasingPerformanceSubject;
  update: PhrasingPerformanceSubject;
  updateGoodConditionGroup: PhrasingPerformanceSubject;
  updateGoodConditionRule: PhrasingPerformanceSubject;
  updateScopeConditionGroup: PhrasingPerformanceSubject;
  updateScopeConditionRule: PhrasingPerformanceSubject;
};


export type PhrasingPerformanceSubjectMutationsAddGoodConditionArgs = {
  input: AddPhrasingPerformanceSubjectGoodConditionInput;
};


export type PhrasingPerformanceSubjectMutationsAddReferenceArgs = {
  input: AddReferenceInput;
};


export type PhrasingPerformanceSubjectMutationsAddScopeConditionArgs = {
  input: AddPhrasingPerformanceSubjectScopeConditionInput;
};


export type PhrasingPerformanceSubjectMutationsCreateArgs = {
  input: CreatePhrasingPerformanceSubjectInput;
};


export type PhrasingPerformanceSubjectMutationsDeleteArgs = {
  input: IdInput;
};


export type PhrasingPerformanceSubjectMutationsRemoveGoodConditionArgs = {
  input: RemovePhrasingPerformanceSubjectGoodConditionInput;
};


export type PhrasingPerformanceSubjectMutationsRemoveReferenceArgs = {
  input: RemoveReferenceInput;
};


export type PhrasingPerformanceSubjectMutationsRemoveScopeConditionArgs = {
  input: RemovePhrasingPerformanceSubjectScopeConditionInput;
};


export type PhrasingPerformanceSubjectMutationsUpdateArgs = {
  input: UpdatePhrasingPerformanceSubjectInput;
};


export type PhrasingPerformanceSubjectMutationsUpdateGoodConditionGroupArgs = {
  input: UpdatePhrasingPerformanceSubjectGoodConditionGroupInput;
};


export type PhrasingPerformanceSubjectMutationsUpdateGoodConditionRuleArgs = {
  input: UpdatePhrasingPerformanceSubjectGoodConditionRuleInput;
};


export type PhrasingPerformanceSubjectMutationsUpdateScopeConditionGroupArgs = {
  input: UpdatePhrasingPerformanceSubjectScopeConditionGroupInput;
};


export type PhrasingPerformanceSubjectMutationsUpdateScopeConditionRuleArgs = {
  input: UpdatePhrasingPerformanceSubjectScopeConditionRuleInput;
};

export type PhrasingPerformanceSubjectProjectAssignment = AbstractAssignment & {
  __typename?: 'PhrasingPerformanceSubjectProjectAssignment';
  assignee: PhrasingPerformanceSubject;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type PhrasingPerformanceSubjectProjectAssignmentConnection = {
  __typename?: 'PhrasingPerformanceSubjectProjectAssignmentConnection';
  items: Array<PhrasingPerformanceSubjectProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingPerformanceSubjectQueries = {
  __typename?: 'PhrasingPerformanceSubjectQueries';
  get?: Maybe<PhrasingPerformanceSubject>;
  list: PhrasingPerformanceSubjectConnection;
};


export type PhrasingPerformanceSubjectQueriesGetArgs = {
  input: IdInput;
};


export type PhrasingPerformanceSubjectQueriesListArgs = {
  input: ListPhrasingPerformanceSubjectsInput;
};

export type PhrasingPerformanceSubjectSessionAssignment = AbstractAssignment & {
  __typename?: 'PhrasingPerformanceSubjectSessionAssignment';
  assignee: PhrasingPerformanceSubject;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Session;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  matchedText: Scalars['String'];
  matchedWordingId: Scalars['ID'];
  organisationId: Scalars['ID'];
  outcome: PhrasingPerformanceSessionOutcome;
  score: Scalars['Float'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type PhrasingPerformanceSubjectSessionAssignmentConnection = {
  __typename?: 'PhrasingPerformanceSubjectSessionAssignmentConnection';
  items: Array<PhrasingPerformanceSubjectSessionAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingPerformanceSubjectStatistic = {
  __typename?: 'PhrasingPerformanceSubjectStatistic';
  badCount: Scalars['Int'];
  byReference: Array<PhrasingPerformanceReferenceStatistic>;
  goodCount: Scalars['Int'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type PhrasingPerformanceWording = {
  __typename?: 'PhrasingPerformanceWording';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  embedding: Array<Scalars['Float']>;
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  text: Scalars['String'];
};

export type PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment = AbstractAssignment & {
  __typename?: 'PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment';
  assignee: PhrasingPerformanceWording;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: PhrasingPerformanceSubject;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  score: Scalars['Float'];
  status: PhrasingPerformanceWordingStatus;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  wordingRefId?: Maybe<Scalars['ID']>;
};

export type PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignmentConnection = {
  __typename?: 'PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignmentConnection';
  items: Array<PhrasingPerformanceWordingPhrasingPerformanceSubjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingPerformanceWordingSessionAssignment = AbstractAssignment & {
  __typename?: 'PhrasingPerformanceWordingSessionAssignment';
  assignee: PhrasingPerformanceWording;
  assigneeId: Scalars['ID'];
  confirmed: Scalars['Boolean'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Session;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  matchedText: Scalars['String'];
  organisationId: Scalars['ID'];
  outcome: PhrasingPerformanceSessionOutcome;
  phrasingPerformanceSubjectId: Scalars['ID'];
  score: Scalars['Float'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type PhrasingPerformanceWordingSessionAssignmentConnection = {
  __typename?: 'PhrasingPerformanceWordingSessionAssignmentConnection';
  items: Array<PhrasingPerformanceWordingSessionAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum PhrasingPerformanceWordingStatus {
  Pending = 'Pending',
  Reference = 'Reference',
  Rejected = 'Rejected'
}

export type PhrasingSubject = {
  __typename?: 'PhrasingSubject';
  condition?: Maybe<PhrasingSubjectCondition>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mostDifferentSentences: Array<Transcript>;
  name: Scalars['String'];
  nameTextLower: Scalars['String'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  record: PhrasingSubjectRecord;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
  wordings: Array<Wording>;
};

export type PhrasingSubjectCondition = DurationPhrasingSubjectCondition | StatusPhrasingSubjectCondition;

export type PhrasingSubjectConditionInput = {
  duration?: InputMaybe<DurationPhrasingSubjectConditionInput>;
  status?: InputMaybe<StatusPhrasingSubjectConditionInput>;
};

export type PhrasingSubjectConnection = {
  __typename?: 'PhrasingSubjectConnection';
  items: Array<PhrasingSubject>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingSubjectConnectionRecord = {
  __typename?: 'PhrasingSubjectConnectionRecord';
  items: Array<PhrasingSubjectRecord>;
  nextToken?: Maybe<Scalars['String']>;
};

export type PhrasingSubjectMutation = {
  __typename?: 'PhrasingSubjectMutation';
  addWording: PhrasingSubject;
  assign: PhrasingSubject;
  create: PhrasingSubject;
  delete: PhrasingSubject;
  removeWording: PhrasingSubject;
  unassign: PhrasingSubject;
  update: PhrasingSubject;
};


export type PhrasingSubjectMutationAddWordingArgs = {
  input: AddWordingInput;
};


export type PhrasingSubjectMutationAssignArgs = {
  input: AssignmentInput;
};


export type PhrasingSubjectMutationCreateArgs = {
  input: CreatePhrasingSubjectInput;
};


export type PhrasingSubjectMutationDeleteArgs = {
  input: IdInput;
};


export type PhrasingSubjectMutationRemoveWordingArgs = {
  input: RemoveWordingInput;
};


export type PhrasingSubjectMutationUnassignArgs = {
  input: AssignmentInput;
};


export type PhrasingSubjectMutationUpdateArgs = {
  input: UpdatePhrasingSubjectInput;
};

export type PhrasingSubjectQueries = {
  __typename?: 'PhrasingSubjectQueries';
  list: PhrasingSubjectConnection;
};


export type PhrasingSubjectQueriesListArgs = {
  input: InfinitePhrasingQueryInput;
};

export type PhrasingSubjectRecord = {
  __typename?: 'PhrasingSubjectRecord';
  condition?: Maybe<PhrasingSubjectCondition>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameTextLower: Scalars['String'];
  organisationId: Scalars['String'];
  projectIds: Array<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedBy?: Maybe<Scalars['String']>;
  usedForSessionTagging?: Maybe<Scalars['Boolean']>;
  wordings: Array<Wording>;
};

export type PhrasingSubjectStatId = StatId & {
  __typename?: 'PhrasingSubjectStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  phrasingSubjectId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type PhrasingSubjectStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export enum PhrasingSubjectType {
  PhrasingPerformance = 'PhrasingPerformance',
  SessionTags = 'SessionTags'
}

export type PhrasingSubjectWordingStatId = StatId & {
  __typename?: 'PhrasingSubjectWordingStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  phrasingSubjectId: Scalars['ID'];
  startDate: Scalars['Long'];
  wordingId: Scalars['ID'];
};


export type PhrasingSubjectWordingStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type PostgresStatsQueries = {
  __typename?: 'PostgresStatsQueries';
  advancedAnalysisItemStatistics: AdvancedAnalysisItemStatisticsQueries;
  complianceStatistics: ComplianceStatisticsQueries;
  detectionStatistics: DetectionStatisticsQueries;
  displayStatistics: DisplayStatisticsQueries;
  evaluationSheet?: Maybe<EvaluationSheetStatQueries>;
  externalCallStatistics: ExternalCallStatisticsQueries;
  globalStatsPage: GlobalStatsPageQueries;
  phrasingPerformanceStatistics: PhrasingPerformanceStatisticsQueries;
  qualityStatistics: QualityStatisticsQueries;
  sessionStatistics: SessionStatisticsQueries;
  sessionStatsPage: SessionStatsPageQueries;
};

export type PreviewFactCheckPhrasingsInput = {
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  productId: Scalars['ID'];
};

export type PreviewFactCheckThemesInput = {
  moduleId: Scalars['ID'];
};

export type Project = {
  __typename?: 'Project';
  archived: Scalars['Boolean'];
  asrLanguage: Scalars['String'];
  assistantConfig?: Maybe<ProjectAssistantConfig>;
  autoStartUrls?: Maybe<Array<Scalars['String']>>;
  cardCommandCount: Scalars['Int'];
  cardCount: Scalars['Int'];
  commandContexts: Array<CommandContext>;
  commands: ProjectCommandConnection;
  complianceTopics: Array<MandatoryTopic>;
  date: Scalars['AWSTimestamp'];
  decisionTrees: Array<DecisionTree>;
  decisionTreesCount: Scalars['Int'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  detectionCounts: DetectionCountConnection;
  formulationTopicCount: Scalars['Int'];
  id: Scalars['ID'];
  isSubscriber: Scalars['Boolean'];
  ksModelId?: Maybe<Scalars['ID']>;
  listProjectSessionSummaries: SessionSummaryConnection;
  mandatoryTopicCount: Scalars['Int'];
  name: Scalars['String'];
  organisationId: Scalars['String'];
  scopeCount: Scalars['Int'];
  scopes: ScopeConnection;
  search: SearchResults;
  sessionEndCard?: Maybe<CardScope>;
  sessionEndCardId?: Maybe<Scalars['String']>;
  sessionStartCard?: Maybe<CardScope>;
  sessionStartCardId?: Maybe<Scalars['String']>;
  sessions: SessionSummaryConnection;
  summaryConfig?: Maybe<SummaryConfig>;
  topics: Array<Topic>;
  trackingCommandCount: Scalars['Int'];
  translations?: Maybe<Array<ProjectTranslation>>;
};


export type ProjectComplianceTopicsArgs = {
  input: BooleanInput;
};


export type ProjectDetectionCountsArgs = {
  date: TableStringFilterInput;
};


export type ProjectListProjectSessionSummariesArgs = {
  date: TableStringFilterInput;
};


export type ProjectScopesArgs = {
  includeImported?: InputMaybe<Scalars['Boolean']>;
  maxDeletedDate?: InputMaybe<Scalars['String']>;
};


export type ProjectSearchArgs = {
  input: CardSearchInput;
};


export type ProjectSessionsArgs = {
  date: TableStringFilterInput;
};

export type ProjectAlertingSubscription = {
  __typename?: 'ProjectAlertingSubscription';
  deleteDate?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProjectAssignment = {
  __typename?: 'ProjectAssignment';
  author?: Maybe<Scalars['ID']>;
  deleteDate?: Maybe<Scalars['AWSTimestamp']>;
  deletedBy?: Maybe<Scalars['ID']>;
  organisationId?: Maybe<Scalars['String']>;
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProjectAssignmentConnection = {
  __typename?: 'ProjectAssignmentConnection';
  items: Array<ProjectAssignment>;
};

export type ProjectAssignmentInput = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type ProjectAssistantConfig = {
  __typename?: 'ProjectAssistantConfig';
  assistantId: Scalars['ID'];
};

export type ProjectCommand = AbstractProjectVocalTrigger & {
  __typename?: 'ProjectCommand';
  card?: Maybe<Card>;
  cardCommandContexts: Array<ProjectCommandContext>;
  cardId?: Maybe<Scalars['ID']>;
  command: Command;
  commandContextTextLower?: Maybe<Scalars['String']>;
  commandId?: Maybe<Scalars['ID']>;
  compliance?: Maybe<CommandComplianceType>;
  contextualDisplays: Array<ProjectCommandContext>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  detectionCounts: DetectionCountConnection;
  id: Scalars['ID'];
  isAlerting?: Maybe<Scalars['Boolean']>;
  onlyDisplayForAgent?: Maybe<Scalars['Boolean']>;
  onlyDisplayForClient?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['ID'];
  permissiveMatching?: Maybe<Scalars['Boolean']>;
  project: Project;
  projectId: Scalars['ID'];
  sessionActivityTrigger?: Maybe<SessionActivityTrigger>;
  tabId?: Maybe<Scalars['ID']>;
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<ProjectCommandTranslation>>;
  triggerId: Scalars['ID'];
  triggeredContext?: Maybe<CommandContext>;
  userId: Scalars['ID'];
};


export type ProjectCommandDetectionCountsArgs = {
  date: TableStringFilterInput;
};

export type ProjectCommandConnection = {
  __typename?: 'ProjectCommandConnection';
  items: Array<ProjectCommand>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ProjectCommandContext = {
  __typename?: 'ProjectCommandContext';
  card: Card;
  cardId: Scalars['String'];
  command: Command;
  commandContextTextLower: Scalars['String'];
  commandId: Scalars['ID'];
  context: CommandContext;
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  projectId_commandId: Scalars['ID'];
  tabId?: Maybe<Scalars['String']>;
  trigger: TriggerDetection;
  triggerId?: Maybe<Scalars['ID']>;
};

export type ProjectCommandTranslation = {
  __typename?: 'ProjectCommandTranslation';
  commandId: Scalars['ID'];
  createdAt: Scalars['Long'];
  language: Scalars['String'];
};

export type ProjectIntention = AbstractProjectVocalTrigger & {
  __typename?: 'ProjectIntention';
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['ID']>;
  commandContextTextLower?: Maybe<Scalars['String']>;
  contextualDisplays: Array<ProjectCommandContext>;
  date: Scalars['AWSTimestamp'];
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  intention: Intention;
  isAlerting?: Maybe<Scalars['Boolean']>;
  onlyDisplayForAgent?: Maybe<Scalars['Boolean']>;
  onlyDisplayForClient?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['ID'];
  project: Project;
  projectId: Scalars['ID'];
  sessionActivityTrigger?: Maybe<SessionActivityTrigger>;
  tabId?: Maybe<Scalars['ID']>;
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
  triggerId: Scalars['ID'];
  triggeredContext?: Maybe<CommandContext>;
  userId: Scalars['ID'];
};

export type ProjectMutations = {
  __typename?: 'ProjectMutations';
  updateSummaryConfig: Project;
};


export type ProjectMutationsUpdateSummaryConfigArgs = {
  input: UpdateSummaryInput;
};

export type ProjectSessionStatistics = {
  __typename?: 'ProjectSessionStatistics';
  current: SessionStatisticsMetric;
  previous: SessionStatisticsMetric;
  project: Project;
  projectId: Scalars['ID'];
};

export type ProjectStatId = StatId & {
  __typename?: 'ProjectStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  project: Project;
  projectId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type ProjectStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type ProjectTopic = {
  __typename?: 'ProjectTopic';
  complianceTopic?: Maybe<MandatoryTopic>;
  createdAt: Scalars['AWSTimestamp'];
  createdBy: Scalars['ID'];
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  mentionThreshold: Scalars['Int'];
  organisationId: Scalars['String'];
  project: Project;
  projectCommands: Array<ProjectCommand>;
  projectId: Scalars['ID'];
  projectVocalTriggers: Array<ProjectVocalTrigger>;
  textLower: Scalars['String'];
  topic: Topic;
};

export type ProjectTopicIdInput = {
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type ProjectTopicMutations = {
  __typename?: 'ProjectTopicMutations';
  assign: ProjectTopic;
  unassign: ProjectTopic;
  update: ProjectTopic;
};


export type ProjectTopicMutationsAssignArgs = {
  input: AssignProjectTopicInput;
};


export type ProjectTopicMutationsUnassignArgs = {
  input: AssignProjectTopicInput;
};


export type ProjectTopicMutationsUpdateArgs = {
  input: UpdateProjectTopicInput;
};

export type ProjectTopicQueries = {
  __typename?: 'ProjectTopicQueries';
  get: ProjectTopic;
  list: ProjectTopicsConnection;
};


export type ProjectTopicQueriesGetArgs = {
  input: ProjectTopicIdInput;
};


export type ProjectTopicQueriesListArgs = {
  input: InfiniteProjectQueryInput;
};

export type ProjectTopicsConnection = {
  __typename?: 'ProjectTopicsConnection';
  items: Array<ProjectTopic>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ProjectTranslation = {
  __typename?: 'ProjectTranslation';
  createdAt: Scalars['Long'];
  customTerminology?: Maybe<Array<CustomTerminology>>;
  instruction?: Maybe<Scalars['String']>;
  instructionUpdatedAt?: Maybe<Scalars['Long']>;
  language: Scalars['String'];
  title: Scalars['String'];
};

export type ProjectTriggerMutations = {
  __typename?: 'ProjectTriggerMutations';
  createProjectCommand: ProjectVocalTrigger;
  createProjectIntention: ProjectVocalTrigger;
  delete: ProjectVocalTrigger;
  duplicate: ProjectVocalTrigger;
  update: ProjectVocalTrigger;
};


export type ProjectTriggerMutationsCreateProjectCommandArgs = {
  input: CreateProjectCommandInput;
};


export type ProjectTriggerMutationsCreateProjectIntentionArgs = {
  input: CreateProjectIntentionInput;
};


export type ProjectTriggerMutationsDeleteArgs = {
  input: DeleteProjectTriggerInput;
};


export type ProjectTriggerMutationsDuplicateArgs = {
  input: DuplicateProjectTriggerInput;
};


export type ProjectTriggerMutationsUpdateArgs = {
  input: UpdateProjectTriggerInput;
};

export type ProjectTriggerQueries = {
  __typename?: 'ProjectTriggerQueries';
  get: ProjectVocalTrigger;
  getTrigger?: Maybe<TriggerDetection>;
  list: ProjectVocalTriggerConnection;
};


export type ProjectTriggerQueriesGetArgs = {
  input: IdInput;
};


export type ProjectTriggerQueriesGetTriggerArgs = {
  input: GetTriggerInput;
};


export type ProjectTriggerQueriesListArgs = {
  input?: InputMaybe<InfiniteProjectQueryInput>;
};

export type ProjectVocalTrigger = ProjectCommand | ProjectIntention;

export type ProjectVocalTriggerConnection = {
  __typename?: 'ProjectVocalTriggerConnection';
  items: Array<ProjectVocalTrigger>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ProposedFactCheckTheme = {
  __typename?: 'ProposedFactCheckTheme';
  attributeIds: Array<Scalars['ID']>;
  hint: Scalars['String'];
  label: Scalars['String'];
};

export type PublishInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type QualityStatisticsMetric = {
  __typename?: 'QualityStatisticsMetric';
  notRecommendedComplianceCount: Scalars['Int'];
  recommendedComplianceCount: Scalars['Int'];
};

export type QualityStatisticsMetricTrend = {
  __typename?: 'QualityStatisticsMetricTrend';
  current: QualityStatisticsMetric;
  previous: QualityStatisticsMetric;
};

export type QualityStatisticsQueries = {
  __typename?: 'QualityStatisticsQueries';
  byTopic: Array<TopicQualityStatistics>;
  byUser: Array<UserQualityStatistics>;
  totals: QualityStatisticsMetricTrend;
};


export type QualityStatisticsQueriesByTopicArgs = {
  input: QualityStatisticsTrendInput;
};


export type QualityStatisticsQueriesByUserArgs = {
  input: QualityStatisticsTrendInput;
};


export type QualityStatisticsQueriesTotalsArgs = {
  input: QualityStatisticsTrendInput;
};

export type QualityStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type Query = {
  __typename?: 'Query';
  advancedAnalysisItem: AdvancedAnalysisItemQueries;
  applicationConnection: ApplicationConnectionQueries;
  assignment: AssignmentQueries;
  availableUsedCommands: Array<Command>;
  callStatus: CallStatusQueries;
  complianceModule: ComplianceModuleQueries;
  complianceOperationItem: ComplianceOperationItemQueries;
  complianceTopic: ComplianceTopicQueries;
  contentGenerationAssistant: ContentGenerationAssistantQuery;
  context: ContextQueries;
  /** decision tree */
  decisionTree: DecisionTreeQuery;
  document: DocumentQueries;
  evaluationSheet: EvaluationSheetQueries;
  externalUser: ExternalUserQueries;
  factCheck: FactCheckQueries;
  /** legacy */
  getAsrCommand?: Maybe<AsrCommand>;
  getCard?: Maybe<Card>;
  getCardCount: Scalars['Int'];
  /** content */
  getCardInstance: CardScope;
  getCatalog: Catalog;
  /** catalog */
  getCatalogUploadUrl: Scalars['String'];
  getCommand: Command;
  /** commands */
  getCommandAssociation?: Maybe<CardCommand>;
  getContentRequest: ContentRequest;
  getDecisionTree: DecisionTree;
  getDecisionTreeNode: DecisionTreeNode;
  getDecisionTreeRun: DecisionTreeRun;
  /** detections */
  getDetection: Detection;
  getDisplay: Display;
  getDocumentUploadUrl: Scalars['String'];
  getExcelCardImporterUploadUrl: Scalars['String'];
  getNotification: Notification;
  getOrganisation: Organisation;
  getPhrasingSubject: PhrasingSubject;
  getProject: Project;
  getRandomRow: Scalars['String'];
  getRecommender: Recommender;
  getRecommenderDatasetUploadUrl: Scalars['String'];
  /** session */
  getSession: Session;
  getStatId: StatId;
  getTeam: Team;
  /** user */
  getUserInfo: User;
  getUserPerformanceStats: UserPerformanceStats;
  intention: IntentionQueries;
  listAllUploadedDocuments?: Maybe<UploadedDocumentsConnection>;
  listAsrCommands: AsrCommandConnection;
  /** transcript */
  listAsrSessionTranscripts: TranscriptConnection;
  listAssociatedCommandsNew: ProjectCommandConnection;
  listAvailableTopics: TopicConnection;
  listCardProjectFeedbackCounts: FeedbackCountConnection;
  listCatalogs: CatalogConnection;
  /** commands */
  listCommandRequests: CommandRequestConnection;
  listCommands: CommandConnection;
  listContentRequests: ContentRequestConnection;
  listContentTags: ContentTagConnection;
  listCurrentNews: Array<News>;
  listDecisionTrees: Array<DecisionTree>;
  /** staff */
  listDetections: DetectionConnection;
  listFavoriteCards: FavoriteCardConnection;
  listInfiniteUsers: UserConnection;
  listIntegration: ListIntegration;
  listOrgCards: CardConnection;
  listOrgLibraryCards: CardConnection;
  /** news */
  listOrganisationNews: NewsConnection;
  listOrganisations: Array<Organisation>;
  /** topic */
  listOrganizationTopics: TopicConnection;
  listPhrasingSubjects: PhrasingSubjectConnection;
  listProjectCards: ScopeConnection;
  /** organisations */
  listProjects: Array<Project>;
  /** Recommender */
  listRecommenders: RecommenderConnection;
  listSessionEventsOfUserWithTopic: SessionEventConnection;
  listSessions: SessionConnection;
  /** stats */
  listStatIds: StatIdConnection;
  /** team */
  listTeams: TeamConnection;
  listUserProjectFeedbackCounts: FeedbackCountConnection;
  listUserSessionSummaries: SessionSummaryConnection;
  listUserSessions: SessionConnection;
  listUsers: Array<User>;
  organisation: OrganisationQueries;
  phrasingPerformanceSubject: PhrasingPerformanceSubjectQueries;
  postgresStats: PostgresStatsQueries;
  projectTopic: ProjectTopicQueries;
  projectTrigger: ProjectTriggerQueries;
  /** comments */
  queryComments: CommentConnection;
  /** notifications */
  queryIdentityNotifications: NotificationConnection;
  session: SessionQueries;
  transcript: TranscriptQueries;
  view: ViewQueries;
};


export type QueryAvailableUsedCommandsArgs = {
  input: Scalars['ID'];
};


export type QueryGetAsrCommandArgs = {
  id: Scalars['ID'];
};


export type QueryGetCardArgs = {
  id: Scalars['ID'];
};


export type QueryGetCardCountArgs = {
  date?: InputMaybe<TableLongFilterInput>;
};


export type QueryGetCardInstanceArgs = {
  input: GetCardInstanceInput;
};


export type QueryGetCatalogArgs = {
  input: IdInput;
};


export type QueryGetCatalogUploadUrlArgs = {
  input: GetUploadUrlInput;
};


export type QueryGetCommandArgs = {
  input: IdInput;
};


export type QueryGetCommandAssociationArgs = {
  commandId: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type QueryGetContentRequestArgs = {
  input: NumberIdInput;
};


export type QueryGetDecisionTreeArgs = {
  input: IdInput;
};


export type QueryGetDecisionTreeNodeArgs = {
  input: IdInput;
};


export type QueryGetDecisionTreeRunArgs = {
  input: IdInput;
};


export type QueryGetDetectionArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisplayArgs = {
  input: IdInput;
};


export type QueryGetDocumentUploadUrlArgs = {
  input: UploadUrlInput;
};


export type QueryGetExcelCardImporterUploadUrlArgs = {
  input: IdInput;
};


export type QueryGetNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetPhrasingSubjectArgs = {
  input: IdInput;
};


export type QueryGetProjectArgs = {
  input: IdInput;
};


export type QueryGetRandomRowArgs = {
  input: IdInput;
};


export type QueryGetRecommenderArgs = {
  input: IdInput;
};


export type QueryGetRecommenderDatasetUploadUrlArgs = {
  input: IdInput;
};


export type QueryGetSessionArgs = {
  input: IdInput;
};


export type QueryGetStatIdArgs = {
  input: GetStatIdInput;
};


export type QueryGetTeamArgs = {
  input: IdInput;
};


export type QueryListAllUploadedDocumentsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListAsrCommandsArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryListAsrSessionTranscriptsArgs = {
  input: ListAsrSessionTranscriptsInput;
};


export type QueryListAssociatedCommandsNewArgs = {
  cardId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
};


export type QueryListAvailableTopicsArgs = {
  input?: InputMaybe<IdInput>;
};


export type QueryListCardProjectFeedbackCountsArgs = {
  cardId: Scalars['ID'];
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryListCatalogsArgs = {
  input: InfiniteProjectQueryInput;
};


export type QueryListCommandRequestsArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  status: CommandRequestStatus;
};


export type QueryListCommandsArgs = {
  language: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryListContentRequestsArgs = {
  input?: InputMaybe<ListContentRequestsInput>;
};


export type QueryListContentTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListCurrentNewsArgs = {
  input: IdInput;
};


export type QueryListDetectionsArgs = {
  input: InfiniteProjectAndUserQueryInput;
};


export type QueryListFavoriteCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListInfiniteUsersArgs = {
  input: InfiniteQueryInput;
};


export type QueryListOrgCardsArgs = {
  input?: InputMaybe<DateInput>;
};


export type QueryListOrganisationNewsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListOrganizationTopicsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListPhrasingSubjectsArgs = {
  input?: InputMaybe<InfiniteProjectQueryInput>;
};


export type QueryListProjectCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
};


export type QueryListProjectsArgs = {
  organisationId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type QueryListRecommendersArgs = {
  input: QueryRecommendersInput;
};


export type QueryListSessionEventsOfUserWithTopicArgs = {
  input: ListSessionEventsOfUserWithTopicInput;
};


export type QueryListSessionsArgs = {
  filter?: InputMaybe<SessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryListStatIdsArgs = {
  input: ListStatIdsInput;
};


export type QueryListTeamsArgs = {
  input?: InputMaybe<InfiniteQueryInput>;
};


export type QueryListUserProjectFeedbackCountsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryListUserSessionSummariesArgs = {
  date: TableStringFilterInput;
};


export type QueryListUserSessionsArgs = {
  date: TableLongFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryListUsersArgs = {
  organisationId?: InputMaybe<Scalars['String']>;
};


export type QueryQueryCommentsArgs = {
  id: Scalars['ID'];
};


export type QueryQueryIdentityNotificationsArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
};

export type QueryRecommendersInput = {
  nameContains?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['String']>;
};

export type ReassignAssignmentGroupInput = {
  groupId: Scalars['ID'];
  id: Scalars['ID'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  nextAttribute?: Maybe<RecommenderColumnSpec>;
};

export type Recommender = {
  __typename?: 'Recommender';
  author: User;
  columnSpecs: Array<RecommenderColumnSpec>;
  columns?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  datasetSummary: DatasetSummary;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisationId: Scalars['String'];
  showNumbers?: Maybe<Scalars['Boolean']>;
  target?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderDatasetSummaryArgs = {
  input: RecommenderQueryInput;
};

export enum RecommenderColumnDisplayType {
  Image = 'Image',
  Link = 'Link',
  Text = 'Text'
}

export type RecommenderColumnSpec = {
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  recommenderId: Scalars['ID'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderColumnSpecDisplayInput = {
  displayOnly?: InputMaybe<Scalars['Boolean']>;
  displayType: RecommenderColumnDisplayType;
};

export type RecommenderConnection = {
  __typename?: 'RecommenderConnection';
  items: Array<Recommender>;
  nextToken?: Maybe<Scalars['String']>;
};

export type RecommenderHistogram = {
  __typename?: 'RecommenderHistogram';
  bars: Array<RecommenderHistogramBar>;
};

export type RecommenderHistogramBar = {
  __typename?: 'RecommenderHistogramBar';
  count: Scalars['Int'];
  selected?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type RecommenderNumberColumnSpec = RecommenderColumnSpec & {
  __typename?: 'RecommenderNumberColumnSpec';
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  max: Scalars['Float'];
  min: Scalars['Float'];
  recommenderId: Scalars['ID'];
  splits: Array<Scalars['Float']>;
  step: Scalars['Float'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderNumberColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderNumberColumnSpecInput = {
  max: Scalars['Float'];
  min: Scalars['Float'];
  splits: Array<Scalars['Float']>;
  step: Scalars['Float'];
};

export type RecommenderQueryInput = {
  filters: Array<AttributeFilter>;
  recommenderId: Scalars['ID'];
};

export type RecommenderStringColumnSpec = RecommenderColumnSpec & {
  __typename?: 'RecommenderStringColumnSpec';
  author: User;
  columnName: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  disabled?: Maybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  displayOnly?: Maybe<Scalars['Boolean']>;
  displayType?: Maybe<RecommenderColumnDisplayType>;
  histogram: RecommenderHistogram;
  recommenderId: Scalars['ID'];
  text: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['String'];
};


export type RecommenderStringColumnSpecHistogramArgs = {
  input: RecommenderQueryInput;
};

export type RecommenderStringColumnSpecInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  text: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

export type RelativeMetric = {
  __typename?: 'RelativeMetric';
  denominator: Scalars['Int'];
  numerator: Scalars['Int'];
  ratio: Scalars['Float'];
};

export type RemoveAdvancedAnalysisItemConditionInput = {
  advancedAnalysisItemId: Scalars['ID'];
  conditionId: Scalars['ID'];
};

export type RemoveAssistantDocumentInput = {
  assistantId: Scalars['ID'];
  documentName: Scalars['String'];
};

export type RemoveAssistantWebsiteSourceInput = {
  assistantId: Scalars['ID'];
  id: Scalars['ID'];
};

export type RemoveCardContentBlockInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type RemoveCardScopeInput = {
  cardId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type RemoveCardTabInput = {
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
};

export type RemoveDecisionTreeFromSequenceInput = {
  decisionTreeId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type RemoveDecisionTreeNodeChildInput = {
  id: Scalars['ID'];
  parentId: Scalars['ID'];
};

export type RemoveDecisionTreeSequenceConditionInput = {
  conditionId: Scalars['ID'];
  decisionTreeId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type RemoveExternalUserInput = {
  cogneedPartner: Scalars['String'];
  cogneedPartnerId: Scalars['String'];
};

export type RemovePhrasingPerformanceSubjectGoodConditionInput = {
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type RemovePhrasingPerformanceSubjectScopeConditionInput = {
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type RemoveProjectAssignmentInput = {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveReferenceInput = {
  assignmentId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type RemoveVariableFilterInput = {
  childId: Scalars['ID'];
  childValue: Scalars['String'];
  parentId: Scalars['ID'];
  variableId: Scalars['ID'];
};

export type RemoveWordingInput = {
  phrasingSubjectId: Scalars['ID'];
  wordingId: Scalars['String'];
};

export type RenameCardInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type RenameCardTabInput = {
  cardId: Scalars['ID'];
  tabId: Scalars['ID'];
  title: Scalars['String'];
};

export type RenameCatalogColumnInput = {
  columnName: Scalars['String'];
  id: Scalars['ID'];
  newName: Scalars['String'];
};

export type RenameCatalogInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RenameProjectInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RenamedColumn = {
  __typename?: 'RenamedColumn';
  newName: Scalars['String'];
  originName: Scalars['String'];
};

export type ReorderCardContentBlocksInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  newIndex: Scalars['Int'];
  tabId: Scalars['ID'];
};

export type ReorderCardTabsInput = {
  cardId: Scalars['ID'];
  newIndex: Scalars['Int'];
  tabId: Scalars['ID'];
};

export type ReorderDecisionTreeNodeChildrenInput = {
  id: Scalars['ID'];
  newIndex: Scalars['Int'];
  parentId: Scalars['ID'];
};

export type ReorderDecisionTreeSequenceInput = {
  decisionTreeId: Scalars['ID'];
  newIndex: Scalars['Int'];
  nodeId: Scalars['ID'];
};

export type ReplaceAssignmentInput = {
  extraFields?: InputMaybe<Scalars['AWSJSON']>;
  id: Scalars['ID'];
};

export type ResendInvitationInput = {
  id: Scalars['ID'];
  locale: Scalars['String'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
};

export type ResultSentence = {
  __typename?: 'ResultSentence';
  match: Scalars['Boolean'];
  score: Scalars['Float'];
  sentence: Scalars['String'];
};

export type RetryAdvancedAnalysisJobInput = {
  assignmentIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};

export type ScopeConnection = {
  __typename?: 'ScopeConnection';
  items: Array<CardScope>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum SearchMatchType {
  CardTitle = 'CardTitle',
  Content = 'Content',
  TabTitle = 'TabTitle'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  cardId: Scalars['ID'];
  cardTitle: Scalars['String'];
  contentMatch?: Maybe<Scalars['String']>;
  contentMatches?: Maybe<Array<Scalars['String']>>;
  matchType: SearchMatchType;
  tabId?: Maybe<Scalars['ID']>;
  tabTitle?: Maybe<Scalars['String']>;
  tabTitleMatch?: Maybe<Scalars['String']>;
  textMatch: Scalars['String'];
  titleMatch?: Maybe<Scalars['String']>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  count: Scalars['Int'];
  items: Array<SearchResult>;
  nextItem?: Maybe<Scalars['Int']>;
};

export type Session = {
  __typename?: 'Session';
  alternativeNumCharacters?: Maybe<Scalars['Int']>;
  alternativeNumSentences?: Maybe<Scalars['Int']>;
  alternativeTranscript?: Maybe<Array<Transcript>>;
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemSessionAssignmentConnection;
  assignedPhrasingPerformanceSubjects: PhrasingPerformanceSubjectSessionAssignmentConnection;
  callStatus?: Maybe<CallStatus>;
  complianceChecklist: ComplianceChecklist;
  conversationEngagedAt?: Maybe<Scalars['Long']>;
  date: Scalars['AWSTimestamp'];
  decisionTreeRuns: Array<DecisionTreeRun>;
  detections: Array<Detection>;
  displays?: Maybe<Array<Display>>;
  dualChannelAppVersion?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  endCause?: Maybe<Scalars['String']>;
  evaluationSheetResults?: Maybe<Array<EvaluationSheetResult>>;
  externalCall?: Maybe<ExternalCall>;
  externalCallGroupId?: Maybe<Scalars['ID']>;
  externalCallId?: Maybe<Scalars['ID']>;
  externalCallPartnerId?: Maybe<Scalars['String']>;
  externalCallStatusIndex?: Maybe<Scalars['String']>;
  factCheckRuns: FactCheckModuleRunConnection;
  finishedAt?: Maybe<Scalars['AWSTimestamp']>;
  hasNote?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDualChannel?: Maybe<Scalars['Boolean']>;
  isInactiveSession?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['String']>;
  liveAppVersion?: Maybe<Scalars['String']>;
  liveSummary?: Maybe<Scalars['String']>;
  markedForTranscriptionAt?: Maybe<Scalars['AWSTimestamp']>;
  notation?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  organisationId: Scalars['String'];
  project: Project;
  projectId: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  sessionEvents?: Maybe<Array<SessionEventV2>>;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<PhrasingSubjectRecord>>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  transcript?: Maybe<Array<Transcript>>;
  transcriptInfo: TranscriptInfo;
  updatedAt?: Maybe<Scalars['Long']>;
  user: Scalars['ID'];
  userField: User;
  whisperNumCharacters?: Maybe<Scalars['Int']>;
  whisperNumSentences?: Maybe<Scalars['Int']>;
  whisperTranscript?: Maybe<Array<Transcript>>;
};


export type SessionEvaluationSheetResultsArgs = {
  input?: InputMaybe<EvaluationSheetResultInput>;
};


export type SessionSessionEventsArgs = {
  input?: InputMaybe<ListSessionEventsInput>;
};

export enum SessionActivityTrigger {
  ActivateSession = 'ActivateSession',
  DeactivateSession = 'DeactivateSession'
}

export type SessionAdvancedAnalysisJobAssignment = AbstractAssignment & {
  __typename?: 'SessionAdvancedAnalysisJobAssignment';
  assignee: Session;
  assigneeId: Scalars['ID'];
  boolValue?: Maybe<Scalars['Boolean']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  errorMessage?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['Long']>;
  group: AdvancedAnalysisJob;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  startedAt?: Maybe<Scalars['Long']>;
  status: AdvancedAnalysisJobAssignmentStatus;
  stringValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  verbatim?: Maybe<Scalars['String']>;
};

export type SessionAdvancedAnalysisJobAssignmentConnection = {
  __typename?: 'SessionAdvancedAnalysisJobAssignmentConnection';
  items: Array<SessionAdvancedAnalysisJobAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SessionAnyItemFilterInput = {
  advancedAnalysisItemIds?: InputMaybe<Array<Scalars['ID']>>;
  topicTextLowers?: InputMaybe<Array<Scalars['String']>>;
};

export type SessionConnection = {
  __typename?: 'SessionConnection';
  filters?: Maybe<SessionConnectionFilters>;
  items: Array<Session>;
  nextToken?: Maybe<Scalars['String']>;
  options?: Maybe<SessionConnectionOptions>;
};

export type SessionConnectionFilters = {
  __typename?: 'SessionConnectionFilters';
  projectId?: Maybe<Scalars['ID']>;
  teamId?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Scalars['String']>>;
};

export type SessionConnectionOptions = {
  __typename?: 'SessionConnectionOptions';
  projects?: Maybe<Array<Project>>;
  qualityTopics?: Maybe<Array<Topic>>;
  teams?: Maybe<Array<Team>>;
  topics?: Maybe<Array<Topic>>;
  users?: Maybe<Array<User>>;
};

export type SessionEs = {
  __typename?: 'SessionEs';
  advancedAnalysis?: Maybe<Array<SessionEsAdvancedAnalysis>>;
  callStatus?: Maybe<CallStatus>;
  compliance?: Maybe<Array<SessionEsCompliance>>;
  contextIds?: Maybe<Array<Scalars['ID']>>;
  conversationEngagedAt?: Maybe<Scalars['Long']>;
  date: Scalars['Long'];
  decisionTrees?: Maybe<Array<SessionEsDecisionTrees>>;
  detections: Array<Detection>;
  duration: Scalars['Int'];
  endCause?: Maybe<Scalars['String']>;
  externalCall?: Maybe<ExternalCall>;
  externalCallGroupId?: Maybe<Scalars['ID']>;
  externalCallId?: Maybe<Scalars['ID']>;
  externalCallPartnerId?: Maybe<Scalars['String']>;
  externalCallStatusIndex?: Maybe<Scalars['String']>;
  factCheck?: Maybe<Array<SessionEsFactCheck>>;
  finishedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  isDualChannel?: Maybe<Scalars['Boolean']>;
  isInactiveSession?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  markedForTranscriptionAt?: Maybe<Scalars['Long']>;
  note?: Maybe<Scalars['String']>;
  numCharacters?: Maybe<Scalars['Int']>;
  numSentences?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  project: Project;
  projectId: Scalars['ID'];
  quality?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
  sessionEvents?: Maybe<Array<SessionEventV2>>;
  summary?: Maybe<Scalars['String']>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  transcript?: Maybe<Array<Transcript>>;
  updatedAt?: Maybe<Scalars['Long']>;
  user: User;
  userId: Scalars['ID'];
};


export type SessionEsDetectionsArgs = {
  input?: InputMaybe<IdInput>;
};


export type SessionEsSessionEventsArgs = {
  input?: InputMaybe<ListSessionEventsInput>;
};

export type SessionEsAdvancedAnalysis = {
  __typename?: 'SessionEsAdvancedAnalysis';
  boolValue?: Maybe<Scalars['Boolean']>;
  explanation?: Maybe<Scalars['String']>;
  itemId: Scalars['ID'];
  stringValue?: Maybe<Scalars['String']>;
  verbatim?: Maybe<Scalars['String']>;
};

export type SessionEsCompliance = {
  __typename?: 'SessionEsCompliance';
  rejectedAt?: Maybe<Scalars['Long']>;
  requiredAt: Scalars['Long'];
  topic: Topic;
  topicTextLower: Scalars['String'];
  validatedAt?: Maybe<Scalars['Long']>;
};

export type SessionEsConnection = {
  __typename?: 'SessionEsConnection';
  filters?: Maybe<SessionConnectionFilters>;
  items: Array<SessionEs>;
  nextToken?: Maybe<Scalars['String']>;
  options?: Maybe<SessionConnectionOptions>;
  total: Scalars['Int'];
};

export type SessionEsDecisionTrees = {
  __typename?: 'SessionEsDecisionTrees';
  decisionTreeId: Scalars['ID'];
  decisionTreeRun: DecisionTreeRun;
  decisionTreeRunId: Scalars['ID'];
};

export type SessionEsFactCheck = {
  __typename?: 'SessionEsFactCheck';
  attributeId: Scalars['ID'];
  productId: Scalars['ID'];
  status: FactCheckResultStatus;
};

export type SessionEsSearchInput = {
  advancedAnalysis?: InputMaybe<AdvancedAnalysisFilterInput>;
  anyItem?: InputMaybe<SessionAnyItemFilterInput>;
  compliance?: InputMaybe<ComplianceFilterInput>;
  content?: InputMaybe<StringFilter>;
  contextIds?: InputMaybe<StringFilter>;
  conversationEngagedAt?: InputMaybe<LongFilter>;
  date?: InputMaybe<LongFilter>;
  decisionTrees?: InputMaybe<StringFilter>;
  duration?: InputMaybe<LongFilter>;
  endCause?: InputMaybe<StringFilter>;
  externalCallGroupId?: InputMaybe<StringFilter>;
  externalCallId?: InputMaybe<StringFilter>;
  externalCallPartnerId?: InputMaybe<StringFilter>;
  externalCallStatusIndex?: InputMaybe<StringFilter>;
  factCheck?: InputMaybe<FactCheckFilterInput>;
  finishedAt?: InputMaybe<LongFilter>;
  isDualChannel?: InputMaybe<BooleanFilter>;
  isInactiveSession?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<StringFilter>;
  markedForTranscriptionAt?: InputMaybe<LongFilter>;
  note?: InputMaybe<StringFilter>;
  numCharacters?: InputMaybe<LongFilter>;
  numSentences?: InputMaybe<LongFilter>;
  pagination: PaginationInput;
  projectId?: InputMaybe<StringFilter>;
  quality?: InputMaybe<StringFilter>;
  score?: InputMaybe<FloatFilter>;
  summary?: InputMaybe<StringFilter>;
  tagsId?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<StringFilter>;
  transcript?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SessionEvent = {
  __typename?: 'SessionEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  mention?: Maybe<SessionTopicMention>;
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  required?: Maybe<SessionTopicRequired>;
  session: Session;
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
  userId: Scalars['ID'];
};

export enum SessionEventComplianceType {
  ComplianceExcludedEvent = 'ComplianceExcludedEvent',
  ComplianceRejectedEvent = 'ComplianceRejectedEvent',
  ComplianceRequiredEvent = 'ComplianceRequiredEvent',
  ComplianceValidatedEvent = 'ComplianceValidatedEvent',
  ContextEvent = 'ContextEvent',
  ConversationEngagedEvent = 'ConversationEngagedEvent',
  DetectionEvent = 'DetectionEvent',
  DurationThresholdReachedEvent = 'DurationThresholdReachedEvent',
  TopicMentionEvent = 'TopicMentionEvent',
  TopicPreviouslyNotValidatedEvent = 'TopicPreviouslyNotValidatedEvent',
  TopicPreviouslyValidatedEvent = 'TopicPreviouslyValidatedEvent'
}

export type SessionEventConnection = {
  __typename?: 'SessionEventConnection';
  items: Array<SessionEvent>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum SessionEventType {
  FormulationTopicMentioned = 'FormulationTopicMentioned',
  TopicRequired = 'TopicRequired'
}

export type SessionEventV2 = ComplianceExcludedEvent | ComplianceRejectedEvent | ComplianceRequiredEvent | ComplianceValidatedEvent | ContextEvent | ConversationEngagedEvent | DetectionEvent | DurationThresholdReachedEvent | TopicMentionEvent | TopicPreviouslyNotValidatedEvent | TopicPreviouslyValidatedEvent;

export type SessionEventV2Cause = {
  __typename?: 'SessionEventV2Cause';
  event: SessionEventV2;
  id: Scalars['ID'];
};

export type SessionFactCheckFact = {
  __typename?: 'SessionFactCheckFact';
  attributeId: Scalars['ID'];
  criterion: Scalars['String'];
  documented: Scalars['String'];
  kind: FactCheckSpecKind;
  label: Scalars['String'];
};

export type SessionFactCheckPlan = {
  __typename?: 'SessionFactCheckPlan';
  externalCallGroupId?: Maybe<Scalars['ID']>;
  externalCallStatusIndex?: Maybe<Scalars['String']>;
  lineCount: Scalars['Int'];
  projectId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  representativeSessionId: Scalars['ID'];
  sessionId: Scalars['ID'];
  sessionIds: Array<Scalars['ID']>;
  status: SessionFactCheckStatus;
  targets: Array<SessionFactCheckTarget>;
};

export type SessionFactCheckPlanInput = {
  moduleId?: InputMaybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
};

export enum SessionFactCheckStatus {
  Gradable = 'Gradable',
  IncompleteProduct = 'IncompleteProduct',
  NoCallStatus = 'NoCallStatus',
  NoModule = 'NoModule',
  NoRoutedProduct = 'NoRoutedProduct',
  NoTranscript = 'NoTranscript'
}

export type SessionFactCheckTarget = {
  __typename?: 'SessionFactCheckTarget';
  latestRun?: Maybe<FactCheckModuleRun>;
  module: FactCheckModule;
  planKey: Scalars['String'];
  product?: Maybe<FactCheckProduct>;
  reason?: Maybe<Scalars['String']>;
  status: SessionFactCheckStatus;
  themes: Array<SessionFactCheckTheme>;
};

export type SessionFactCheckTheme = {
  __typename?: 'SessionFactCheckTheme';
  facts: Array<SessionFactCheckFact>;
  hint: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type SessionFactCheckTranscriptExport = {
  __typename?: 'SessionFactCheckTranscriptExport';
  byteSize?: Maybe<Scalars['Int']>;
  expiresAt?: Maybe<Scalars['Long']>;
  lineCount: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  representativeSessionId: Scalars['ID'];
  sessionId: Scalars['ID'];
  sessionIds: Array<Scalars['ID']>;
  status: SessionFactCheckStatus;
  url?: Maybe<Scalars['String']>;
};

export type SessionFilterInput = {
  date?: InputMaybe<TableIntFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  organisationId?: InputMaybe<TableStringFilterInput>;
  user?: InputMaybe<TableStringFilterInput>;
};

export type SessionMutations = {
  __typename?: 'SessionMutations';
  create: Session;
  update: Session;
};


export type SessionMutationsCreateArgs = {
  input: CreateSessionInputV2;
};


export type SessionMutationsUpdateArgs = {
  input: UpdateSessionInput;
};

export type SessionQueries = {
  __typename?: 'SessionQueries';
  getComplianceChecklist: ComplianceChecklist;
  listByOrganisation: SessionConnection;
  search: SessionEsConnection;
};


export type SessionQueriesGetComplianceChecklistArgs = {
  input: IdInput;
};


export type SessionQueriesListByOrganisationArgs = {
  input: InfiniteSessionQueryInput;
};


export type SessionQueriesSearchArgs = {
  input: SessionEsSearchInput;
};

export type SessionStatId = StatId & {
  __typename?: 'SessionStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  session: Session;
  sessionId: Scalars['ID'];
  startDate: Scalars['Long'];
};


export type SessionStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type SessionStatisticsInput = {
  period: StatisticsPeriodInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type SessionStatisticsMetric = {
  __typename?: 'SessionStatisticsMetric';
  dualAppSessionCount: Scalars['Int'];
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Long'];
  sessionScoreCount: Scalars['Int'];
  sessionScoreTotal: Scalars['Float'];
};

export type SessionStatisticsMetricTrend = {
  __typename?: 'SessionStatisticsMetricTrend';
  current: SessionStatisticsMetric;
  previous: SessionStatisticsMetric;
};

export type SessionStatisticsQueries = {
  __typename?: 'SessionStatisticsQueries';
  byProject: Array<ProjectSessionStatistics>;
  byTeam: Array<TeamSessionStatistics>;
  byUser: Array<UserSessionStatistics>;
  daily: Array<DailySessionStatistics>;
  totals: SessionStatisticsMetricTrend;
};


export type SessionStatisticsQueriesByProjectArgs = {
  input: SessionStatisticsTrendInput;
};


export type SessionStatisticsQueriesByTeamArgs = {
  input: SessionStatisticsTrendInput;
};


export type SessionStatisticsQueriesByUserArgs = {
  input: SessionStatisticsTrendInput;
};


export type SessionStatisticsQueriesDailyArgs = {
  input: SessionStatisticsInput;
};


export type SessionStatisticsQueriesTotalsArgs = {
  input: SessionStatisticsTrendInput;
};

export type SessionStatisticsTrendInput = {
  periods: StatisticsTrendInput;
  scope?: InputMaybe<StatisticsScopeInput>;
};

export type SessionStatsBigNumbersTrend = {
  __typename?: 'SessionStatsBigNumbersTrend';
  current: SessionStatsMetric;
  previous: SessionStatsMetric;
};

export type SessionStatsMetric = {
  __typename?: 'SessionStatsMetric';
  avgCallDuration?: Maybe<Scalars['Float']>;
  avgSessionDuration?: Maybe<Scalars['Float']>;
  avgSessionScore?: Maybe<Scalars['Float']>;
  callCoverage?: Maybe<Scalars['Float']>;
  displayCount: Scalars['Int'];
  displayOriginRepartition: DisplayOriginRepartition;
  dualAppSessionCount: Scalars['Int'];
  dualAppSessionRatio?: Maybe<Scalars['Float']>;
  externalCallCoveredDuration: Scalars['Long'];
  externalCallDuration: Scalars['Long'];
  externalCalls: Scalars['Long'];
  externalCallsCovered: Scalars['Long'];
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Long'];
};

export type SessionStatsPageQueries = {
  __typename?: 'SessionStatsPageQueries';
  bigNumbers: SessionStatsBigNumbersTrend;
  userTable: Array<SessionStatsUserRow>;
};


export type SessionStatsPageQueriesBigNumbersArgs = {
  input: SessionStatisticsTrendInput;
};


export type SessionStatsPageQueriesUserTableArgs = {
  input: SessionStatisticsTrendInput;
};

export type SessionStatsUserRow = {
  __typename?: 'SessionStatsUserRow';
  current: SessionStatsMetric;
  previous: SessionStatsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type SessionSummary = {
  __typename?: 'SessionSummary';
  count: Scalars['Int'];
  date: Scalars['String'];
  duration: Scalars['Int'];
  organisationId: Scalars['String'];
  projectId: Scalars['ID'];
  userId: Scalars['String'];
};

export type SessionSummaryConnection = {
  __typename?: 'SessionSummaryConnection';
  items: Array<SessionSummary>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SessionTopicMention = {
  __typename?: 'SessionTopicMention';
  detectedCommand: Command;
  detectedCommandId: Scalars['String'];
  formulationScore?: Maybe<CommandComplianceType>;
  isFromClient?: Maybe<Scalars['Boolean']>;
  topicMentionedAt: Scalars['Long'];
  topicMentionedVerbatim: Scalars['String'];
};

export type SessionTopicRequired = {
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredByConditionTopics = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredByConditionTopics';
  conditionTopics: Array<ConditionTopic>;
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredByDuration = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredByDuration';
  minDuration: Scalars['Int'];
  topicRequiredAt: Scalars['Long'];
};

export type SessionTopicRequiredBySessionStep = SessionTopicRequired & {
  __typename?: 'SessionTopicRequiredBySessionStep';
  sessionStep: MandatoryTopicSessionStep;
  topicRequiredAt: Scalars['Long'];
};

export type SetFactCheckProductSpecsInput = {
  id: Scalars['ID'];
  specs: Array<FactCheckSpecInput>;
};

export type SetIntegrationsInput = {
  aircallIntegration?: InputMaybe<Scalars['Boolean']>;
  genesysIntegration?: InputMaybe<Scalars['Boolean']>;
  inocxIntegration?: InputMaybe<Scalars['Boolean']>;
  openPhoneIntegration?: InputMaybe<Scalars['Boolean']>;
  ringoverIntegration?: InputMaybe<Scalars['Boolean']>;
  slackHuddleIntegration?: InputMaybe<Scalars['Boolean']>;
  viadialogIntegration?: InputMaybe<Scalars['Boolean']>;
};

export type SetUserScopesInput = {
  id: Scalars['ID'];
  scopes: Array<Scalars['String']>;
};

export type SimpleNamedObject = {
  __typename?: 'SimpleNamedObject';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SmarttribuneIntegration = {
  __typename?: 'SmarttribuneIntegration';
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  enabled: Scalars['Boolean'];
  knowledgeBaseId: Scalars['Int'];
  projectIds: Array<Scalars['String']>;
};

export enum SpeakerType {
  Agent = 'Agent',
  Client = 'Client'
}

export type StandardOrgSetting = OrgFeatureSettings & {
  __typename?: 'StandardOrgSetting';
  enabled: Scalars['Boolean'];
  staffOnly?: Maybe<Scalars['Boolean']>;
};

export type StartAssistantDataSourceSyncInput = {
  assistantId: Scalars['ID'];
  dataSourceId: Scalars['ID'];
};

export type StartDecisionTreeRunInput = {
  id: Scalars['ID'];
  isPreviewRun?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  sessionId?: InputMaybe<Scalars['ID']>;
};

export enum StatElement {
  AdvancedAnalysisItem = 'AdvancedAnalysisItem',
  Card = 'Card',
  Command = 'Command',
  ComplianceModule = 'ComplianceModule',
  DecisionTree = 'DecisionTree',
  DecisionTreeLeafNode = 'DecisionTreeLeafNode',
  EvaluationSheet = 'EvaluationSheet',
  FormulationTopic = 'FormulationTopic',
  Intention = 'Intention',
  MandatoryTopic = 'MandatoryTopic',
  PhrasingSubject = 'PhrasingSubject',
  PhrasingSubjectWording = 'PhrasingSubjectWording',
  Project = 'Project',
  Session = 'Session',
  Team = 'Team',
  Topic = 'Topic',
  User = 'User'
}

export type StatExportAdvancedAnalysisFilterInput = {
  type?: InputMaybe<AdvancedAnalysisItemType>;
};

export enum StatExportElement {
  AdvancedAnalysisItem = 'AdvancedAnalysisItem',
  EvaluationAdvancedAnalysisItem = 'EvaluationAdvancedAnalysisItem',
  EvaluationSheetItems = 'EvaluationSheetItems'
}

export enum StatExportFormat {
  CsvRawData = 'CsvRawData',
  ExcelReport = 'ExcelReport'
}

export type StatExportMutations = {
  __typename?: 'StatExportMutations';
  generateAdvancedAnalysisItemsExportUrl: Scalars['String'];
  generateEvaluationSheetSessionsExportUrl: Scalars['String'];
  generatePostgresItemStatsExportUrl: Scalars['String'];
};


export type StatExportMutationsGenerateAdvancedAnalysisItemsExportUrlArgs = {
  input: GenerateAdvancedAnalysisItemsExportUrlInput;
};


export type StatExportMutationsGenerateEvaluationSheetSessionsExportUrlArgs = {
  input: GenerateEvaluationSheetSessionExportUrlInput;
};


export type StatExportMutationsGeneratePostgresItemStatsExportUrlArgs = {
  input: GeneratePostgresItemStatsExportUrlInput;
};

export type StatId = {
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
};


export type StatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type StatIdConnection = {
  __typename?: 'StatIdConnection';
  items?: Maybe<Array<StatId>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StatIdFilterInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  cardId?: InputMaybe<Scalars['ID']>;
  commandCategory?: InputMaybe<Category>;
  commandId?: InputMaybe<Scalars['String']>;
  complianceModuleId?: InputMaybe<Scalars['ID']>;
  contextId?: InputMaybe<Scalars['ID']>;
  decisionTreeId?: InputMaybe<Scalars['ID']>;
  decisionTreeLeafNodeId?: InputMaybe<Scalars['ID']>;
  evaluationSheetId?: InputMaybe<Scalars['ID']>;
  importedCards?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['ID']>;
  sessionId?: InputMaybe<Scalars['ID']>;
  speaker?: InputMaybe<SpeakerType>;
  teamId?: InputMaybe<Scalars['ID']>;
  topicTextLower?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type StatIdFilters = {
  __typename?: 'StatIdFilters';
  advancedAnalysisItemId?: Maybe<Scalars['ID']>;
  cardId?: Maybe<Scalars['ID']>;
  commandCategory?: Maybe<Category>;
  commandId?: Maybe<Scalars['String']>;
  complianceModuleId?: Maybe<Scalars['ID']>;
  decisionTreeId?: Maybe<Scalars['ID']>;
  evaluationSheetId?: Maybe<Scalars['ID']>;
  importedCards?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['ID']>;
  sessionId?: Maybe<Scalars['ID']>;
  speaker?: Maybe<SpeakerType>;
  teamId?: Maybe<Scalars['ID']>;
  topicTextLower?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type StatMetricConnection = {
  __typename?: 'StatMetricConnection';
  items?: Maybe<Array<StatMetrics>>;
};

export type StatMetricFilterInput = {
  endDate: Scalars['Long'];
};

export type StatMetrics = WithMetrics & {
  __typename?: 'StatMetrics';
  advancedAnalysisComplianceCount?: Maybe<Scalars['Int']>;
  advancedAnalysisComplianceTotal?: Maybe<Scalars['Int']>;
  advancedAnalysisItemRun?: Maybe<Array<KeyIntValue>>;
  advancedAnalysisItemRunCount?: Maybe<Scalars['Int']>;
  advancedAnalysisQualityCount?: Maybe<Scalars['Int']>;
  advancedAnalysisQualityTotal?: Maybe<Scalars['Int']>;
  assistantChatCount?: Maybe<Scalars['Int']>;
  assistantInputTokenCount?: Maybe<Scalars['Long']>;
  assistantLaunchCount?: Maybe<Scalars['Int']>;
  assistantMessageCount?: Maybe<Scalars['Int']>;
  assistantOutputTokenCount?: Maybe<Scalars['Long']>;
  assistantThreadDuration?: Maybe<Scalars['Long']>;
  compliancyCompletedCount?: Maybe<Scalars['Int']>;
  compliancyRequiredCount?: Maybe<Scalars['Int']>;
  date: Scalars['String'];
  decisionTreeLaunchedCount?: Maybe<Scalars['Int']>;
  decisionTreeResolvedCount?: Maybe<Scalars['Int']>;
  detectionCount?: Maybe<Scalars['Int']>;
  displayCount?: Maybe<Scalars['Int']>;
  displayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  dualAppSessionCount?: Maybe<Scalars['Int']>;
  evaluationSheetCount?: Maybe<Scalars['Float']>;
  evaluationSheetTotal?: Maybe<Scalars['Float']>;
  evaluationSheetUnweightedCount?: Maybe<Scalars['Long']>;
  externalCallCoveredDuration?: Maybe<Scalars['Long']>;
  externalCallDuration?: Maybe<Scalars['Long']>;
  externalCalls?: Maybe<Scalars['Long']>;
  externalCallsCovered?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  negativeFeedbackCount?: Maybe<Scalars['Int']>;
  notRecommendedComplianceCount?: Maybe<Scalars['Int']>;
  numDaysWithSession?: Maybe<Scalars['Int']>;
  positiveFeedbackCount?: Maybe<Scalars['Int']>;
  recommendedComplianceCount?: Maybe<Scalars['Int']>;
  sessionComplianceCount?: Maybe<Scalars['Int']>;
  sessionComplianceTotal?: Maybe<Scalars['Float']>;
  sessionCount?: Maybe<Scalars['Int']>;
  sessionDuration?: Maybe<Scalars['Long']>;
  sessionQualityCount?: Maybe<Scalars['Int']>;
  sessionQualityTotal?: Maybe<Scalars['Float']>;
  sessionScoreCount?: Maybe<Scalars['Int']>;
  sessionScoreTotal?: Maybe<Scalars['Float']>;
  sessionSummaryCount?: Maybe<Scalars['Int']>;
  sessionSummaryInputTokens?: Maybe<Scalars['Int']>;
  sessionSummaryOutputTokens?: Maybe<Scalars['Int']>;
  totalSessionScore?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  visibleDisplayCount?: Maybe<Scalars['Int']>;
  visibleDisplayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  wordingSuccessCount?: Maybe<Scalars['Int']>;
  wordingUtteranceCount?: Maybe<Scalars['Int']>;
};

export type StatisticsPeriodInput = {
  endDate: Scalars['Long'];
  startDate: Scalars['Long'];
};

export type StatisticsScopeInput = {
  advancedAnalysisItemId?: InputMaybe<Scalars['ID']>;
  cardId?: InputMaybe<Scalars['ID']>;
  commandId?: InputMaybe<Scalars['ID']>;
  complianceModuleId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  speaker?: InputMaybe<SpeakerType>;
  teamId?: InputMaybe<Scalars['ID']>;
  topicTextLower?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type StatisticsTrendInput = {
  current: StatisticsPeriodInput;
  previous: StatisticsPeriodInput;
};

export type StatusPhrasingSubjectCondition = BasePhrasingSubjectCondition & {
  __typename?: 'StatusPhrasingSubjectCondition';
  failureStatus: Array<Scalars['String']>;
  minCallDuration?: Maybe<Scalars['Int']>;
  successStatus: Array<Scalars['String']>;
};

export type StatusPhrasingSubjectConditionInput = {
  failureStatus: Array<Scalars['String']>;
  minCallDuration?: InputMaybe<Scalars['Int']>;
  successStatus: Array<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Array<Scalars['String']>>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  match?: InputMaybe<Scalars['String']>;
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type StripeBillingInfo = {
  __typename?: 'StripeBillingInfo';
  address?: Maybe<StripeAddress>;
  name: Scalars['String'];
  preferredLocale: Scalars['String'];
};

export type StripeCard = {
  __typename?: 'StripeCard';
  brand: Scalars['String'];
  last4: Scalars['String'];
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<StripeAddress>;
  card?: Maybe<StripeCard>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type StripeNextPayment = {
  __typename?: 'StripeNextPayment';
  amount: Scalars['Float'];
  date: Scalars['Int'];
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  id: Scalars['String'];
  name: Scalars['String'];
  prices: Array<StripeProductPrice>;
};

export type StripeProductPlan = {
  __typename?: 'StripeProductPlan';
  active: Scalars['Boolean'];
  createdAt: Scalars['Long'];
  id: Scalars['String'];
  interval: Scalars['String'];
  productId: Scalars['String'];
};

export type StripeProductPrice = {
  __typename?: 'StripeProductPrice';
  currency: Scalars['String'];
  id: Scalars['String'];
  productId: Scalars['String'];
  type: StripeProductPriceType;
  unitAmount: Scalars['Int'];
};

export enum StripeProductPriceType {
  OneTime = 'one_time',
  Recurring = 'recurring'
}

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  billingInfo?: Maybe<StripeBillingInfo>;
  card?: Maybe<StripeCard>;
  endOfTrial?: Maybe<Scalars['Int']>;
  nextPayment: StripeNextPayment;
  numSeats: Scalars['Int'];
  paymentIntent?: Maybe<Scalars['String']>;
  productDescription: Scalars['String'];
};

export type StripeSubscriptionEntity = {
  __typename?: 'StripeSubscriptionEntity';
  id: Scalars['String'];
  minLicenses: Scalars['Int'];
  subscription: StripeSubscriptionInfo;
};

export type StripeSubscriptionInfo = {
  __typename?: 'StripeSubscriptionInfo';
  customer: StripeCustomer;
  customerId: Scalars['String'];
  endOfTrial?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  lines: Array<StripeSubscriptionLine>;
  metadata?: Maybe<Array<KeyStringValue>>;
  nextPayment: StripeNextPayment;
  paymentIntent?: Maybe<Scalars['String']>;
};

export type StripeSubscriptionLine = {
  __typename?: 'StripeSubscriptionLine';
  id: Scalars['String'];
  numSeats: Scalars['Int'];
  plan: StripeProductPlan;
  price: StripeProductPrice;
  product: StripeProduct;
  subscriptionId: Scalars['String'];
};

export type SubmitFactCheckResultInput = {
  agentClaim?: InputMaybe<Scalars['String']>;
  attributeId: Scalars['ID'];
  citedLineIndexes?: InputMaybe<Array<Scalars['Int']>>;
  citedValues?: InputMaybe<Array<Scalars['String']>>;
  explanation?: InputMaybe<Scalars['String']>;
  offListClaims?: InputMaybe<Array<Scalars['String']>>;
  status: FactCheckResultStatus;
};

export type SubmitSessionFactCheckRunInput = {
  moduleId: Scalars['ID'];
  planKey: Scalars['String'];
  productId: Scalars['ID'];
  results: Array<SubmitFactCheckResultInput>;
  sessionId: Scalars['ID'];
};

export type Subscription = {
  __typename?: 'Subscription';
  addedDetection?: Maybe<Detection>;
  subscribeAdvancedAnalysisItemEvaluationJobResult?: Maybe<AdvancedAnalysisItemEvaluationJobResult>;
  subscribeAdvancedAnalysisJob?: Maybe<AdvancedAnalysisJob>;
  subscribeSession: Session;
  subscribeSessionChecklist: Session;
};


export type SubscriptionAddedDetectionArgs = {
  sessionId: Scalars['String'];
};


export type SubscriptionSubscribeAdvancedAnalysisItemEvaluationJobResultArgs = {
  evaluationJobId: Scalars['ID'];
};


export type SubscriptionSubscribeAdvancedAnalysisJobArgs = {
  id: Scalars['ID'];
};


export type SubscriptionSubscribeSessionArgs = {
  id: Scalars['ID'];
};


export type SubscriptionSubscribeSessionChecklistArgs = {
  id: Scalars['ID'];
};

export type SummaryConfig = {
  __typename?: 'SummaryConfig';
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  id: Scalars['ID'];
  instruction: Scalars['String'];
  organisationId: Scalars['ID'];
  speakerConfig?: Maybe<SummarySpeakerConfig>;
  summarySessionMetadata?: Maybe<SummarySessionMetadata>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type SummaryConfigProjectAssignment = AbstractAssignment & {
  __typename?: 'SummaryConfigProjectAssignment';
  assignee: SummaryConfig;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Project;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type SummaryConfigProjectAssignmentConnection = {
  __typename?: 'SummaryConfigProjectAssignmentConnection';
  items: Array<SummaryConfigProjectAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SummaryConfigSessionAssignment = AbstractAssignment & {
  __typename?: 'SummaryConfigSessionAssignment';
  assignee: SummaryConfig;
  assigneeId: Scalars['ID'];
  content: Scalars['String'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: Session;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  inputTokenCount: Scalars['Int'];
  model?: Maybe<Scalars['String']>;
  organisationId: Scalars['ID'];
  outputTokenCount: Scalars['Int'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type SummaryConfigSessionAssignmentConnection = {
  __typename?: 'SummaryConfigSessionAssignmentConnection';
  items: Array<SummaryConfigSessionAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type SummarySessionMetadata = {
  __typename?: 'SummarySessionMetadata';
  sessionDuration?: Maybe<Scalars['Boolean']>;
  timeUTC?: Maybe<Scalars['Boolean']>;
};

export type SummarySessionMetadataInput = {
  sessionDuration?: InputMaybe<Scalars['Boolean']>;
  timeUTC?: InputMaybe<Scalars['Boolean']>;
};

export type SummarySpeakerConfig = {
  __typename?: 'SummarySpeakerConfig';
  agentName: Scalars['String'];
  clientName: Scalars['String'];
};

export type SummarySpeakerConfigInput = {
  agentName: Scalars['String'];
  clientName: Scalars['String'];
};

export type TableBooleanFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type TableDetectionStatusFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<DetectionStatus>;
};

export type TableFloatFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  ge?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  le?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  notContains?: InputMaybe<Scalars['Float']>;
};

export type TableIdFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  beginsWith?: InputMaybe<Scalars['ID']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  ge?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  le?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  notContains?: InputMaybe<Scalars['ID']>;
};

export type TableIntFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  ge?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  le?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  notContains?: InputMaybe<Scalars['Int']>;
};

export type TableLongFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['AWSTimestamp']>>>;
  contains?: InputMaybe<Scalars['AWSTimestamp']>;
  eq?: InputMaybe<Scalars['AWSTimestamp']>;
  ge?: InputMaybe<Scalars['AWSTimestamp']>;
  gt?: InputMaybe<Scalars['AWSTimestamp']>;
  le?: InputMaybe<Scalars['AWSTimestamp']>;
  lt?: InputMaybe<Scalars['AWSTimestamp']>;
  ne?: InputMaybe<Scalars['AWSTimestamp']>;
  notContains?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type TableStringFilterInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  beginsWith?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  ge?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  le?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  notContains?: InputMaybe<Scalars['String']>;
};

export type TableTagFilterInput = {
  author?: InputMaybe<TableIdFilterInput>;
  contentId?: InputMaybe<TableIdFilterInput>;
  date?: InputMaybe<TableIntFilterInput>;
  deletedAt?: InputMaybe<TableIntFilterInput>;
  deletedBy?: InputMaybe<TableIdFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  organisationId?: InputMaybe<TableStringFilterInput>;
  text?: InputMaybe<TableStringFilterInput>;
};

export type Team = {
  __typename?: 'Team';
  color: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  memberCount: Scalars['Int'];
  members: Array<TeamMembership>;
  organisationId: Scalars['ID'];
  title: Scalars['String'];
  titleLowerCase: Scalars['String'];
  updatedAt: Scalars['Long'];
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  items: Array<Team>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TeamMembership = {
  __typename?: 'TeamMembership';
  deletedAt?: Maybe<Scalars['Long']>;
  organisationId: Scalars['ID'];
  team: Team;
  teamId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
};

export type TeamSessionStatistics = {
  __typename?: 'TeamSessionStatistics';
  current: SessionStatisticsMetric;
  previous: SessionStatisticsMetric;
  team: Team;
  teamId: Scalars['ID'];
};

export type TeamStatId = StatId & {
  __typename?: 'TeamStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
  team: Team;
  teamId: Scalars['ID'];
};


export type TeamStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type ThreadAdvancedAnalysisJobAssignment = AbstractAssignment & {
  __typename?: 'ThreadAdvancedAnalysisJobAssignment';
  assignee: ContentGenerationAssistantThread;
  assigneeId: Scalars['ID'];
  boolValue?: Maybe<Scalars['Boolean']>;
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  errorMessage?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['Long']>;
  group: AdvancedAnalysisJob;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  startedAt?: Maybe<Scalars['Long']>;
  status: AdvancedAnalysisJobAssignmentStatus;
  stringValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  verbatim?: Maybe<Scalars['String']>;
};

export type ThreadAdvancedAnalysisJobAssignmentConnection = {
  __typename?: 'ThreadAdvancedAnalysisJobAssignmentConnection';
  items: Array<ThreadAdvancedAnalysisJobAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ThreadContentGenerationAssistantAssignment = AbstractAssignment & {
  __typename?: 'ThreadContentGenerationAssistantAssignment';
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type Topic = {
  __typename?: 'Topic';
  color: Scalars['String'];
  createdAt: Scalars['AWSTimestamp'];
  createdBy?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['AWSTimestamp']>;
  mandatoryTopic?: Maybe<MandatoryTopic>;
  organisationId: Scalars['ID'];
  projectCommands?: Maybe<ProjectCommandConnection>;
  projectVocalTriggers?: Maybe<ProjectVocalTriggerConnection>;
  text: Scalars['String'];
  textLower: Scalars['String'];
  threshold: TopicThreshold;
  translations?: Maybe<Array<TopicTranslation>>;
  user?: Maybe<User>;
};


export type TopicMandatoryTopicArgs = {
  input: IdInput;
};


export type TopicProjectCommandsArgs = {
  input?: InputMaybe<IdInput>;
};


export type TopicProjectVocalTriggersArgs = {
  input?: InputMaybe<IdInput>;
};

export type TopicComplianceModuleAssignment = AbstractAssignment & {
  __typename?: 'TopicComplianceModuleAssignment';
  assignee: Topic;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceModule;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type TopicComplianceModuleAssignmentConnection = {
  __typename?: 'TopicComplianceModuleAssignmentConnection';
  items: Array<TopicComplianceModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TopicComplianceOperationItemAssignment = AbstractAssignment & {
  __typename?: 'TopicComplianceOperationItemAssignment';
  assignee: Topic;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceOperationItem;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  weight: Scalars['Float'];
};

export type TopicComplianceOperationItemAssignmentConnection = {
  __typename?: 'TopicComplianceOperationItemAssignmentConnection';
  items: Array<TopicComplianceOperationItemAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TopicComplianceStat = {
  __typename?: 'TopicComplianceStat';
  current: RelativeMetric;
  previous?: Maybe<RelativeMetric>;
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type TopicComplianceStatistics = {
  __typename?: 'TopicComplianceStatistics';
  current: ComplianceStatisticsMetric;
  previous: ComplianceStatisticsMetric;
  topic?: Maybe<Topic>;
  topicTextLower: Scalars['String'];
};

export type TopicConnection = {
  __typename?: 'TopicConnection';
  items: Array<Topic>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TopicEvaluationSheetAssignment = AbstractAssignment & {
  __typename?: 'TopicEvaluationSheetAssignment';
  assignee: Topic;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  criticityLevel: EvaluationSheetCriticityLevel;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: EvaluationSheet;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
  weight: Scalars['Float'];
};

export type TopicEvaluationSheetAssignmentConnection = {
  __typename?: 'TopicEvaluationSheetAssignmentConnection';
  items: Array<TopicEvaluationSheetAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type TopicMentionEvent = BaseSessionEventV2 & {
  __typename?: 'TopicMentionEvent';
  causes: Array<SessionEventV2Cause>;
  date: Scalars['Long'];
  id: Scalars['ID'];
  isFromClient: Scalars['Boolean'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  threshold: Scalars['Int'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type TopicPreviouslyNotValidatedEvent = BaseSessionEventV2 & {
  __typename?: 'TopicPreviouslyNotValidatedEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type TopicPreviouslyValidatedEvent = BaseSessionEventV2 & {
  __typename?: 'TopicPreviouslyValidatedEvent';
  date: Scalars['Long'];
  id: Scalars['ID'];
  organisationId: Scalars['String'];
  sessionId: Scalars['ID'];
  topic: Topic;
  topicTextLower: Scalars['String'];
};

export type TopicQualityStatistics = {
  __typename?: 'TopicQualityStatistics';
  current: QualityStatisticsMetric;
  previous: QualityStatisticsMetric;
  topic?: Maybe<Topic>;
  topicTextLower: Scalars['String'];
};

export type TopicStatId = StatId & {
  __typename?: 'TopicStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
  topic?: Maybe<Topic>;
  topicTextLower?: Maybe<Scalars['String']>;
};


export type TopicStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type TopicThreshold = {
  __typename?: 'TopicThreshold';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type TopicTranslation = {
  __typename?: 'TopicTranslation';
  createdAt: Scalars['Long'];
  language: Scalars['String'];
  title: Scalars['String'];
};

export type TopicViewAssignment = AbstractAssignment & {
  __typename?: 'TopicViewAssignment';
  assignee: Topic;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: View;
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type TopicViewAssignmentConnection = {
  __typename?: 'TopicViewAssignmentConnection';
  items: Array<TopicViewAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  duration?: Maybe<Scalars['Long']>;
  isFromClient?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  text: Scalars['String'];
  timestamp: Scalars['Long'];
};

export type TranscriptConnection = {
  __typename?: 'TranscriptConnection';
  transcripts: Array<Transcript>;
};

export type TranscriptInfo = {
  __typename?: 'TranscriptInfo';
  numCharacters?: Maybe<Scalars['Int']>;
  numSentences?: Maybe<Scalars['Int']>;
};

export type TranscriptMutation = {
  __typename?: 'TranscriptMutation';
  phrasingSubject: PhrasingSubjectMutation;
};

export type TranscriptQueries = {
  __typename?: 'TranscriptQueries';
  phrasingSubject: PhrasingSubjectQueries;
};

export enum TranscriptType {
  Alternative = 'alternative',
  Whisper = 'whisper'
}

export type TranscriptUtterance = {
  __typename?: 'TranscriptUtterance';
  createdAt: Scalars['Long'];
  duration?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  isFromClient?: Maybe<Scalars['Boolean']>;
  organisationId: Scalars['String'];
  sessionId: Scalars['String'];
  text: Scalars['String'];
  transcriptType: TranscriptType;
};

export type TransitionContentRequestInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  counter: Scalars['Int'];
  state?: InputMaybe<ContentRequestState>;
};

export type TranslateCardInput = {
  cardId: Scalars['ID'];
  language: Scalars['String'];
  projectId: Scalars['ID'];
};

export type TranslateItemInput = {
  id: Scalars['ID'];
  language: Scalars['String'];
};

export enum TreeSequenceItemInclusionType {
  Blacklist = 'Blacklist',
  Whitelist = 'Whitelist'
}

export type TriggerDetection = Command | Intention;

export type UpateSessionInput = {
  duration: Scalars['Int'];
  endCause?: InputMaybe<Scalars['String']>;
  endSession?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type UpdateAdvancedAnalysisItemConditionGroupInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  advancedAnalysisItemId: Scalars['ID'];
  conditionId: Scalars['ID'];
};

export type UpdateAdvancedAnalysisItemConditionRuleInput = {
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  advancedAnalysisItemId: Scalars['ID'];
  conditionId: Scalars['ID'];
};

export type UpdateAdvancedAnalysisItemInput = {
  boolPositiveAnswer?: InputMaybe<Scalars['Boolean']>;
  discoverOptions?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  question?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdvancedAnalysisItemType>;
};

export type UpdateAsrCommandInput = {
  alternatives: Array<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  language: Scalars['String'];
  levenshteinDistance: Scalars['String'];
  name: Scalars['String'];
  prefixSize: Scalars['Int'];
};

export type UpdateAssistantInput = {
  contentGenerationSystemPrompt?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: InputMaybe<ContentGenerationAssistantStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssistantType>;
};

export type UpdateAssistantInstructionInput = {
  assistantId: Scalars['ID'];
  condenseQueryInstruction?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<ContentGenerationAssistantLlmModel>;
  rephraseConfig?: InputMaybe<UpdateRephraseInstructionInput>;
  titleInstruction?: InputMaybe<Scalars['String']>;
};

export type UpdateAssistantOrganisationConfigInput = {
  quotas?: InputMaybe<UpdateAssistantOrganisationQuotasConfigInput>;
};

export type UpdateAssistantOrganisationQuotasConfigInput = {
  dailyRequests: Scalars['Int'];
  monthlyRequests: Scalars['Int'];
};

export type UpdateAssistantWebsiteDataSourceInput = {
  assistantId: Scalars['ID'];
  dataSourceId: Scalars['ID'];
  exclusionFilters?: InputMaybe<Array<Scalars['String']>>;
  inclusionFilters?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  seedUrls?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateAutoStartUrlInput = {
  projectId?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type UpdateCallStatusInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCardContentBlockInput = {
  blockId: Scalars['ID'];
  cardId: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<ContentBlockDisplayType>;
  tabId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCardInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCardMetaInput = {
  expirationDate?: InputMaybe<Scalars['AWSTimestamp']>;
  isLibrary?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCatalogDraftInput = {
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateCommandNewInput = {
  alternatives?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  forbiddenWordings?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  onlyAlternative?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCommandRequestInput = {
  commandId: Scalars['ID'];
  organisationId: Scalars['ID'];
  status: CommandRequestStatus;
};

export type UpdateCommentInput = {
  content: Scalars['String'];
  id: Scalars['String'];
};

export type UpdateComplianceModuleInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateComplianceOperationItemInput = {
  id: Scalars['ID'];
  operator?: InputMaybe<ComplianceOperationItemScoreRuleOperator>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateContextInput = {
  color?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type UpdateDecisionTreeInput = {
  allowComments?: InputMaybe<Scalars['Boolean']>;
  hideLeafContent?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sequenceOnly?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDecisionTreeNodeChildValueInput = {
  childID: Scalars['ID'];
  childValue: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateDecisionTreeNodeColorInput = {
  color: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateDecisionTreeNodeInput = {
  id: Scalars['ID'];
  isLeaf?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  richText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DecisionTreeNodeType>;
};

export type UpdateDecisionTreeRunHistoryInput = {
  id: Scalars['ID'];
  nodeHistory: Array<Scalars['String']>;
};

export type UpdateDecisionTreeRunHistoryV2Input = {
  history: Array<DecisionTreeRunNodeHistoryItemInput>;
  id: Scalars['ID'];
};

export type UpdateDecisionTreeSequenceConditionInput = {
  conditionId: Scalars['ID'];
  decisionTreeId: Scalars['ID'];
  inclusionType?: InputMaybe<TreeSequenceItemInclusionType>;
  nodeId: Scalars['ID'];
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDecisionTreeVariableInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDisplayFeedbackInput = {
  feedback?: InputMaybe<Feedback>;
  id: Scalars['ID'];
};

export type UpdateDisplayInput = {
  feedback?: InputMaybe<Feedback>;
  id: Scalars['ID'];
  isVisible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEvaluationSheetInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  scoreThresholds?: InputMaybe<EvaluationSheetScoreThresholdsInput>;
};

export type UpdateExcelCardImporterInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateExternalUserInput = {
  cogneedId?: InputMaybe<Scalars['String']>;
  cogneedPartner: Scalars['String'];
  cogneedPartnerId: Scalars['String'];
};

export type UpdateFactCheckAttributeInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type UpdateFactCheckModuleInput = {
  attributionGuidance?: InputMaybe<Scalars['String']>;
  attributionMode?: InputMaybe<FactCheckAttributionMode>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFactCheckProductInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFactCheckThemeInput = {
  hint?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateIntentionInput = {
  id: Scalars['ID'];
  samples?: InputMaybe<Array<IntentionSamplesInput>>;
  text?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
};

export type UpdateLastEmailSentInput = {
  id: Scalars['ID'];
  language: Scalars['String'];
};

export type UpdateMandatoryTopicInput = {
  complianceExample?: InputMaybe<Scalars['String']>;
  conditionTopics?: InputMaybe<Array<Scalars['String']>>;
  externalStatusCodeBlacklist?: InputMaybe<Array<Scalars['String']>>;
  forbiddenCommands?: InputMaybe<Array<Scalars['String']>>;
  forceRequiredIfPreviousNotValidated?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  minimumDuration?: InputMaybe<Scalars['Float']>;
  reminderTime?: InputMaybe<Scalars['Float']>;
  reminderType?: InputMaybe<MandatoryTopicReminderType>;
  sessionStepCondition?: InputMaybe<MandatoryTopicSessionStep>;
  sessionTagBlacklist?: InputMaybe<Array<Scalars['String']>>;
  sessionTagWhitelist?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateNewsInput = {
  content?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Long']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Long']>;
  status?: InputMaybe<NewsStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganisationInput = {
  organisationId: Scalars['ID'];
  patch: Scalars['AWSJSON'];
};

export type UpdatePasswordInput = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};

export type UpdatePersonalInfoInput = {
  displayName: Scalars['String'];
};

export type UpdatePhrasingPerformanceSubjectGoodConditionGroupInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type UpdatePhrasingPerformanceSubjectGoodConditionRuleInput = {
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type UpdatePhrasingPerformanceSubjectInput = {
  candidateThreshold?: InputMaybe<Scalars['Float']>;
  confirmedMatchThreshold?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  preFilterThreshold?: InputMaybe<Scalars['Float']>;
  subSpanLengthTolerance?: InputMaybe<Scalars['Int']>;
};

export type UpdatePhrasingPerformanceSubjectScopeConditionGroupInput = {
  advancedAnalysisItemConditionAndInput?: InputMaybe<AdvancedAnalysisItemConditionAndInput>;
  advancedAnalysisItemConditionNotInput?: InputMaybe<AdvancedAnalysisItemConditionNotInput>;
  advancedAnalysisItemConditionOrInput?: InputMaybe<AdvancedAnalysisItemConditionOrInput>;
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type UpdatePhrasingPerformanceSubjectScopeConditionRuleInput = {
  advancedAnalysisItemConditionBooleanRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionBooleanRefValueInput>;
  advancedAnalysisItemConditionCallStatusInInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInInput>;
  advancedAnalysisItemConditionCallStatusInput?: InputMaybe<AdvancedAnalysisItemConditionCallStatusInput>;
  advancedAnalysisItemConditionContextInput?: InputMaybe<AdvancedAnalysisItemConditionContextInput>;
  advancedAnalysisItemConditionMinDurationInput?: InputMaybe<AdvancedAnalysisItemConditionMinDurationInput>;
  advancedAnalysisItemConditionStringRefValueInput?: InputMaybe<AdvancedAnalysisItemConditionStringRefValueInput>;
  conditionId: Scalars['ID'];
  phrasingPerformanceSubjectId: Scalars['ID'];
};

export type UpdatePhrasingSubjectInput = {
  condition?: InputMaybe<PhrasingSubjectConditionInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sessionEndCardId?: InputMaybe<Scalars['String']>;
  sessionStartCardId?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectTopicInput = {
  mentionThreshold?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  textLower: Scalars['String'];
};

export type UpdateProjectTriggerInput = {
  cardCommandContexts?: InputMaybe<Array<CardCommandContextInput>>;
  cardId?: InputMaybe<Scalars['String']>;
  commandContextTextLower?: InputMaybe<Scalars['String']>;
  compliance?: InputMaybe<CommandComplianceType>;
  id: Scalars['ID'];
  isAlerting?: InputMaybe<Scalars['Boolean']>;
  onlyDisplayForAgent?: InputMaybe<Scalars['Boolean']>;
  onlyDisplayForClient?: InputMaybe<Scalars['Boolean']>;
  permissiveMatching?: InputMaybe<Scalars['Boolean']>;
  tabId?: InputMaybe<Scalars['String']>;
  topicTextLower?: InputMaybe<Scalars['String']>;
};

export type UpdatePushSubscriptionInput = {
  locale: Scalars['String'];
  pushSubscription: Scalars['String'];
};

export type UpdateRecommenderInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
};

export type UpdateRephraseInstructionInput = {
  enabled: Scalars['Boolean'];
  instruction?: InputMaybe<Scalars['String']>;
};

export type UpdateSessionInput = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
};

export type UpdateStripeInfoInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  preferredLocale: Scalars['String'];
};

export type UpdateSummaryConfigInput = {
  id: Scalars['ID'];
  llmQuestion?: InputMaybe<Scalars['String']>;
};

export type UpdateSummaryInput = {
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  speakerConfig?: InputMaybe<SummarySpeakerConfigInput>;
  summarySessionMetadata?: InputMaybe<SummarySessionMetadataInput>;
};

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTopicColorInput = {
  color: Scalars['String'];
  textLower: Scalars['String'];
};

export type UpdateTopicThresholdInput = {
  max: Scalars['Float'];
  min: Scalars['Float'];
  textLower: Scalars['String'];
};

export type UpdateTranslateInstructionInput = {
  customTerminology?: InputMaybe<Array<CustomTerminologyInput>>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
};

export type UpdateUserNotificationSettingsInput = {
  notifyOnDetection?: InputMaybe<LiveNotificationType>;
  notifyOnExternalCall?: InputMaybe<LiveNotificationType>;
  notifyOnNewMandatoryTopic?: InputMaybe<LiveNotificationType>;
};

export type UpdateUserPermissionsInput = {
  id: Scalars['ID'];
  role: Scalars['Int'];
};

export type UpdateUserSettingsInput = {
  notifications?: InputMaybe<UpdateUserNotificationSettingsInput>;
};

export type UpdateViewInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UploadUrlInput = {
  fileType: Scalars['String'];
  id: Scalars['String'];
  metadataMap?: InputMaybe<Scalars['String']>;
  update: Scalars['Boolean'];
};

export type UploadedDocuments = {
  __typename?: 'UploadedDocuments';
  date: Scalars['Long'];
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type UploadedDocumentsConnection = {
  __typename?: 'UploadedDocumentsConnection';
  items: Array<UploadedDocuments>;
  nextToken?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  anonymized?: Maybe<Scalars['Boolean']>;
  appSettings?: Maybe<UserSettings>;
  assignments: ProjectAssignmentConnection;
  callsSincePeriod?: Maybe<Scalars['Int']>;
  coverageStatus?: Maybe<CallCoverageStatus>;
  deletedAt?: Maybe<Scalars['Long']>;
  /** Legacy stats */
  detectionCounts: DetectionCountConnection;
  displayName: Scalars['String'];
  email: Scalars['String'];
  externalUser?: Maybe<ExternalUser>;
  feedbackStats: FeedbackCountConnection;
  id: Scalars['String'];
  invitedAt?: Maybe<Scalars['Long']>;
  invitedBy?: Maybe<Scalars['ID']>;
  isConfirmed: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  lastCallsCounter: Scalars['Int'];
  lastMailsAt: Array<Scalars['Long']>;
  latestSession?: Maybe<Session>;
  locale?: Maybe<Scalars['String']>;
  /** monitoring */
  nonCoveredCallsCounter: Scalars['Int'];
  numNotifications?: Maybe<Scalars['Int']>;
  organisationId: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  pushSubscription?: Maybe<Scalars['String']>;
  recentDisplayCount?: Maybe<Scalars['Int']>;
  /** stats */
  recentUsageDuration?: Maybe<Scalars['Int']>;
  role: Scalars['Int'];
  scopes?: Maybe<Array<Scalars['String']>>;
  sessionStats: SessionSummaryConnection;
  slackId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  teamAssignmentCount: Scalars['Int'];
  teamAssignments: Array<TeamMembership>;
  uncoveredPeriod?: Maybe<Period>;
  updatedBy?: Maybe<Scalars['ID']>;
};


export type UserDetectionCountsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type UserFeedbackStatsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};


export type UserSessionStatsArgs = {
  date: TableStringFilterInput;
  projectId?: InputMaybe<Scalars['ID']>;
};

export type UserAdvancedAnalysisItemStatistics = {
  __typename?: 'UserAdvancedAnalysisItemStatistics';
  current: AdvancedAnalysisItemStatisticsMetric;
  previous: AdvancedAnalysisItemStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserAuthMutations = {
  __typename?: 'UserAuthMutations';
  assignGroup: Scalars['Boolean'];
  generateTemporaryCode: Scalars['String'];
  retrieveAmplifyCredentials: UserTemporaryCode;
};


export type UserAuthMutationsAssignGroupArgs = {
  input: IdInput;
};


export type UserAuthMutationsGenerateTemporaryCodeArgs = {
  input: GenerateTemporaryCodeInput;
};


export type UserAuthMutationsRetrieveAmplifyCredentialsArgs = {
  input: Scalars['String'];
};

export type UserComplianceStatistics = {
  __typename?: 'UserComplianceStatistics';
  current: ComplianceStatisticsMetric;
  previous: ComplianceStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserComplianceStats = {
  __typename?: 'UserComplianceStats';
  current: RelativeMetric;
  previous?: Maybe<RelativeMetric>;
  table: Array<TopicComplianceStat>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']>;
};

export type UserDetectionStatistics = {
  __typename?: 'UserDetectionStatistics';
  current: DetectionStatisticsMetric;
  previous: DetectionStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserDisplayStatistics = {
  __typename?: 'UserDisplayStatistics';
  current: DisplayStatisticsMetric;
  previous: DisplayStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserEngagementMetrics = {
  __typename?: 'UserEngagementMetrics';
  sessionCount: Scalars['Int'];
  sessionDuration: Scalars['Int'];
  sessionDurationAverage?: Maybe<Scalars['Float']>;
};

export type UserEngagementStats = {
  __typename?: 'UserEngagementStats';
  current: UserEngagementMetrics;
  previous: UserEngagementMetrics;
};

export type UserExternalCallStatistics = {
  __typename?: 'UserExternalCallStatistics';
  current: ExternalCallStatisticsMetric;
  previous: ExternalCallStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserMutations = {
  __typename?: 'UserMutations';
  auth: UserAuthMutations;
  owner: OwnerUserMutations;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  notifyOnDetection?: Maybe<LiveNotificationType>;
  notifyOnExternalCall?: Maybe<LiveNotificationType>;
  notifyOnNewMandatoryTopic?: Maybe<LiveNotificationType>;
};

export type UserPerformanceStats = {
  __typename?: 'UserPerformanceStats';
  compliance?: Maybe<UserComplianceStats>;
  engagement?: Maybe<UserEngagementStats>;
  quality?: Maybe<UserComplianceStats>;
};


export type UserPerformanceStatsComplianceArgs = {
  input: GetUserPerformanceStatsInput;
};


export type UserPerformanceStatsEngagementArgs = {
  input: GetUserPerformanceStatsInput;
};


export type UserPerformanceStatsQualityArgs = {
  input: GetUserPerformanceStatsInput;
};

export type UserQualityStatistics = {
  __typename?: 'UserQualityStatistics';
  current: QualityStatisticsMetric;
  previous: QualityStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserSessionStatistics = {
  __typename?: 'UserSessionStatistics';
  current: SessionStatisticsMetric;
  previous: SessionStatisticsMetric;
  user: User;
  userId: Scalars['ID'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  consentedLinks?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<UserNotificationSettings>;
};

export type UserStatId = StatId & {
  __typename?: 'UserStatId';
  endDate: Scalars['Long'];
  filters?: Maybe<StatIdFilters>;
  id?: Maybe<Scalars['String']>;
  metrics: StatMetricConnection;
  startDate: Scalars['Long'];
  user: User;
  userId: Scalars['ID'];
};


export type UserStatIdMetricsArgs = {
  input?: InputMaybe<MetricsFilter>;
};

export type UserTemporaryCode = {
  __typename?: 'UserTemporaryCode';
  accessToken: Scalars['String'];
  expireAt: Scalars['Long'];
  idToken: Scalars['String'];
  lastAuthUser: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type View = {
  __typename?: 'View';
  assignedAdvancedAnalysisItems: AdvancedAnalysisItemViewAssignmentConnection;
  assignedCommands: CommandViewAssignmentConnection;
  assignedIntentions: IntentionViewAssignmentConnection;
  assignedTopics: TopicViewAssignmentConnection;
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  mirroredModule?: Maybe<ViewComplianceModuleAssignment>;
  name: Scalars['String'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ViewComplianceModuleAssignment = AbstractAssignment & {
  __typename?: 'ViewComplianceModuleAssignment';
  assignee: View;
  assigneeId: Scalars['ID'];
  counter: Scalars['Int'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['ID'];
  createdByUser: User;
  deletedAt?: Maybe<Scalars['Long']>;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedByUser?: Maybe<User>;
  group: ComplianceModule;
  groupId: Scalars['ID'];
  hiddenInReports?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
  updatedAt: Scalars['Long'];
  updatedBy: Scalars['ID'];
  updatedByUser: User;
};

export type ViewComplianceModuleAssignmentConnection = {
  __typename?: 'ViewComplianceModuleAssignmentConnection';
  items: Array<ViewComplianceModuleAssignment>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ViewMutations = {
  __typename?: 'ViewMutations';
  create: View;
  delete: View;
  update: View;
};


export type ViewMutationsCreateArgs = {
  input: CreateViewInput;
};


export type ViewMutationsDeleteArgs = {
  input: IdInput;
};


export type ViewMutationsUpdateArgs = {
  input: UpdateViewInput;
};

export type ViewQueries = {
  __typename?: 'ViewQueries';
  get: View;
  list: Array<View>;
};


export type ViewQueriesGetArgs = {
  input: IdInput;
};

export type WithMetrics = {
  advancedAnalysisComplianceCount?: Maybe<Scalars['Int']>;
  advancedAnalysisComplianceTotal?: Maybe<Scalars['Int']>;
  advancedAnalysisItemRun?: Maybe<Array<KeyIntValue>>;
  advancedAnalysisQualityCount?: Maybe<Scalars['Int']>;
  advancedAnalysisQualityTotal?: Maybe<Scalars['Int']>;
  assistantChatCount?: Maybe<Scalars['Int']>;
  assistantInputTokenCount?: Maybe<Scalars['Long']>;
  assistantLaunchCount?: Maybe<Scalars['Int']>;
  assistantMessageCount?: Maybe<Scalars['Int']>;
  assistantOutputTokenCount?: Maybe<Scalars['Long']>;
  assistantThreadDuration?: Maybe<Scalars['Long']>;
  compliancyCompletedCount?: Maybe<Scalars['Int']>;
  compliancyRequiredCount?: Maybe<Scalars['Int']>;
  decisionTreeLaunchedCount?: Maybe<Scalars['Int']>;
  decisionTreeResolvedCount?: Maybe<Scalars['Int']>;
  detectionCount?: Maybe<Scalars['Int']>;
  displayCount?: Maybe<Scalars['Int']>;
  displayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  dualAppSessionCount?: Maybe<Scalars['Int']>;
  evaluationSheetCount?: Maybe<Scalars['Float']>;
  evaluationSheetTotal?: Maybe<Scalars['Float']>;
  evaluationSheetUnweightedCount?: Maybe<Scalars['Long']>;
  externalCallCoveredDuration?: Maybe<Scalars['Long']>;
  externalCallDuration?: Maybe<Scalars['Long']>;
  externalCalls?: Maybe<Scalars['Long']>;
  externalCallsCovered?: Maybe<Scalars['Long']>;
  notRecommendedComplianceCount?: Maybe<Scalars['Int']>;
  recommendedComplianceCount?: Maybe<Scalars['Int']>;
  sessionComplianceCount?: Maybe<Scalars['Int']>;
  sessionComplianceTotal?: Maybe<Scalars['Float']>;
  sessionCount?: Maybe<Scalars['Int']>;
  sessionDuration?: Maybe<Scalars['Long']>;
  sessionQualityCount?: Maybe<Scalars['Int']>;
  sessionQualityTotal?: Maybe<Scalars['Float']>;
  sessionScoreCount?: Maybe<Scalars['Int']>;
  sessionScoreTotal?: Maybe<Scalars['Float']>;
  sessionSummaryCount?: Maybe<Scalars['Int']>;
  sessionSummaryInputTokens?: Maybe<Scalars['Int']>;
  sessionSummaryOutputTokens?: Maybe<Scalars['Int']>;
  totalSessionScore?: Maybe<Scalars['Float']>;
  visibleDisplayCount?: Maybe<Scalars['Int']>;
  visibleDisplayOriginRepartition?: Maybe<DisplayOriginRepartition>;
  wordingSuccessCount?: Maybe<Scalars['Int']>;
  wordingUtteranceCount?: Maybe<Scalars['Int']>;
};

export type Wording = {
  __typename?: 'Wording';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type WriteDecisionTreeRunCommentInput = {
  nodeId: Scalars['ID'];
  runId: Scalars['ID'];
  userComment: Scalars['String'];
};

export type GenerateEvaluationSheetSessionExportUrlInput = {
  evaluationSheetId: Scalars['ID'];
  format: StatExportFormat;
  language: Scalars['String'];
  search: SessionEsSearchInput;
};

export type GenerateTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateTokenMutation = { __typename?: 'Mutation', generateToken: string };


export const GenerateTokenDocument = `
    mutation generateToken {
  generateToken
}
    `;
export const useGenerateTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateTokenMutation, TError, GenerateTokenMutationVariables, TContext>) =>
    useMutation<GenerateTokenMutation, TError, GenerateTokenMutationVariables, TContext>(
      ['generateToken'],
      (variables?: GenerateTokenMutationVariables) => fetchWithAmplify<GenerateTokenMutation, GenerateTokenMutationVariables>(GenerateTokenDocument, variables)(),
      options
    );